
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("foVrt", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4acD6 = parcelRequire("4acD6");


var $ihTS4 = parcelRequire("ihTS4");


var $jhcFr = parcelRequire("jhcFr");


var $9Tkc6 = parcelRequire("9Tkc6");


var $2Yc46 = parcelRequire("2Yc46");


var $9wGTI = parcelRequire("9wGTI");


var $7QM6o = parcelRequire("7QM6o");


var $bQm3c = parcelRequire("bQm3c");


var $02cx8 = parcelRequire("02cx8");


var $lmEhP = parcelRequire("lmEhP");


var $hfIjM = parcelRequire("hfIjM");

const $820a39291628bd44$var$CARD_OPTIONS = {
    allowDatasource: true
};
const $820a39291628bd44$var$defaultOptions = {
    appearance: 'full-page',
    onFeedbackClicked: ()=>{},
    onReviewStateEntered: ()=>{},
    onExperienceComplete: ()=>{},
    aiGlobalOptIn: {
        status: 'disabled',
        triggerOptInFlow: ()=>{}
    }
};
const $820a39291628bd44$export$ac968d961305af39 = (options)=>{
    const optionsToUse = options || $820a39291628bd44$var$defaultOptions;
    const createEditorPluginAIOptions = (0, $42omo.useMemo)(()=>optionsToUse.appearance === 'page-comment' ? (0, $9Tkc6.createPageCommentEditorPluginAIOptions) : (0, $9Tkc6.createPageEditorPluginAIOptions), [
        optionsToUse.appearance
    ]);
    const optionsToUseRef = (0, $42omo.useRef)(optionsToUse);
    optionsToUseRef.current = optionsToUse;
    const { cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    // Memoize session data to avoid recreating the object on every render
    const sessionData = (0, $42omo.useMemo)(()=>userId && cloudId ? {
            userId: userId,
            cloudId: cloudId
        } : undefined, [
        userId,
        cloudId
    ]);
    // Use the dedicated hook for auto-apply state management
    const autoApplyState = (0, $2Yc46.useAutoApplyState)((0, $9wGTI.fg)('enable_auto_apply_toggling') ? sessionData : undefined);
    const isInDocumentStreamingAllowed = (0, $9wGTI.fg)('enable_auto_apply_toggling') ? autoApplyState?.enabled ?? false : false;
    const refresh = autoApplyState?.refresh;
    // Listen for changes from other parts of the app
    (0, $42omo.useEffect)(()=>{
        if (!(0, $9wGTI.fg)('enable_auto_apply_toggling') || !refresh) return;
        const handleAutoApplyChange = ()=>{
            // Refresh the state from backend/localStorage when toggle changes
            refresh();
        };
        window.addEventListener('autoApplyChanged', handleAutoApplyChange);
        return ()=>window.removeEventListener('autoApplyChanged', handleAutoApplyChange);
    }, [
        refresh
    ]);
    // Use a ref to avoid recreating the options object on every state update
    const isInDocumentStreamingAllowedRef = (0, $42omo.useRef)(isInDocumentStreamingAllowed);
    isInDocumentStreamingAllowedRef.current = isInDocumentStreamingAllowed;
    const productConfig = (0, $42omo.useMemo)(()=>({
            product: 'confluence',
            cloudId: cloudId
        }), [
        cloudId
    ]);
    const linkPicker = (0, $jhcFr.useLinkPickerEditorProps)(undefined, productConfig);
    const spaceId = (0, $7QM6o.useSpaceId)();
    const mentionProvider = (0, $hfIjM.useMentionProvider)(spaceId);
    const linkingProp = (0, $lmEhP.useLinkingFeatures)($820a39291628bd44$var$CARD_OPTIONS);
    const PromptEditor = (0, $42omo.useMemo)(()=>(0, $ihTS4.createPromptEditor)({
            linkPicker: linkPicker,
            enableLinks: true,
            linking: linkingProp.linking,
            mentionProvider: mentionProvider,
            featureFlags: {}
        }), [
        linkingProp.linking,
        linkPicker,
        mentionProvider
    ]);
    const editorRovoButtonActions = (0, $02cx8.useEditorRovoButtonActions)();
    const isAISmartButtonEnabled = (0, $42omo.useMemo)(()=>optionsToUse.appearance !== 'page-comment' && optionsToUse.aiGlobalOptIn.status === 'enabled', [
        optionsToUse.appearance,
        optionsToUse.aiGlobalOptIn.status
    ]);
    const { setNudges: setNudges } = (0, $4acD6.useAISmartButtonActions)();
    const aiSmartButtonOptions = (0, $42omo.useMemo)(()=>isAISmartButtonEnabled ? {
            actions: {
                ...editorRovoButtonActions,
                setNudges: setNudges
            }
        } : undefined, [
        isAISmartButtonEnabled,
        editorRovoButtonActions,
        setNudges
    ]);
    return (0, $42omo.useMemo)(()=>{
        return createEditorPluginAIOptions({
            aiGlobalOptIn: optionsToUseRef.current.aiGlobalOptIn,
            /**
			 * Hide AI button in primary toolbar when AI proactive is enabled or
			 * 	when appearance is full-page and AI smart button is enabled
			 */ hidePrimaryToolbarButton: optionsToUse.appearance === 'full-page' && optionsToUse.aiGlobalOptIn.status === 'enabled',
            generativeAIApiUrl: `${window.location.origin}/gateway/api/editor-ai/v1/generative/ai`,
            handleFeedbackSubmission: async (feedbackMetadata)=>{
                try {
                    // TODO: EDF-831: Fix and ensure types match with handleFeedbackSubmission
                    optionsToUseRef.current.onFeedbackClicked?.(feedbackMetadata);
                    return {
                        status: 'submitted'
                    };
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                } catch (error) {
                    return {
                        status: 'failed'
                    };
                }
            },
            onAnnotationsRemoved: (0, $9wGTI.fg)('platform_editor_ai_aifc_streaming') ? optionsToUseRef.current.onAnnotationsRemoved : undefined,
            onExperienceEvent: {
                // Thumbs up and down are being deprecated and are no longer used.
                THUMBS_UP: ()=>{},
                THUMBS_DOWN: ()=>{},
                REVIEW_STATE_ENTERED: ()=>{
                    optionsToUseRef.current.onReviewStateEntered?.();
                },
                EXPERIENCE_COMPLETE: ()=>{
                    optionsToUseRef.current.onExperienceComplete?.();
                }
            },
            onDocChangeByAgent: (_agent)=>{
            // TODO Integrate with confluence
            },
            onAIProviderChanged: (source, aiProvider)=>{
                if (optionsToUseRef.current.onAIProviderChanged) optionsToUseRef.current.onAIProviderChanged(source, aiProvider);
            },
            getUserPreferences: ()=>{
                if (!(0, $9wGTI.fg)('enable_auto_apply_toggling')) return {};
                return {
                    isInDocumentStreamingAllowed: isInDocumentStreamingAllowedRef.current
                };
            },
            getChannelVariables: optionsToUseRef.current.getChannelVariables,
            product: 'CONFLUENCE',
            objectId: optionsToUseRef.current.contentId,
            PromptEditor: PromptEditor,
            AIButtonWrapper: options?.AIButtonWrapper,
            providers: options?.providers,
            /**
			 * Need to audit logs only for confluence page as of now.
			 */ auditLogSettings: optionsToUse.appearance !== 'page-comment' && optionsToUse.contentId ? {
                enabled: true,
                eventData: {
                    type: 'page',
                    pageId: optionsToUse.contentId
                }
            } : {
                enabled: false
            },
            ...isAISmartButtonEnabled && {
                aiSmartButtonOptions: aiSmartButtonOptions
            },
            ...optionsToUse.usePlatformPrompt && {
                onSubmit: ()=>{}
            }
        });
    }, [
        createEditorPluginAIOptions,
        optionsToUse.appearance,
        optionsToUse.contentId,
        PromptEditor,
        options?.AIButtonWrapper,
        options?.providers,
        isAISmartButtonEnabled,
        aiSmartButtonOptions,
        optionsToUse.aiGlobalOptIn.status,
        optionsToUse.usePlatformPrompt
    ]);
};
module.exports["useEditorPluginAIOptions"] = $820a39291628bd44$export$ac968d961305af39;

});

parcelRegister("9Tkc6", function(module, exports) {
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $AMCQl = parcelRequire("AMCQl");

var $bpQiY = parcelRequire("bpQiY");

var $7ShCl = parcelRequire("7ShCl");


var $drPNW = parcelRequire("drPNW");

var $oeZjt = parcelRequire("oeZjt");

var $j398X = parcelRequire("j398X");

var $iulqN = parcelRequire("iulqN");

var $j8LwF = parcelRequire("j8LwF");

var $eugUs = parcelRequire("eugUs");

var $cH4SO = parcelRequire("cH4SO");

var $dLjaJ = parcelRequire("dLjaJ");


var $cbtR4 = parcelRequire("cbtR4");


var $dh538 = parcelRequire("dh538");


var $5SuLc = parcelRequire("5SuLc");


var $9lB81 = parcelRequire("9lB81");


var $l5nYy = parcelRequire("l5nYy");


var $e1P7K = parcelRequire("e1P7K");


var $2gxrt = parcelRequire("2gxrt");


var $iBSwI = parcelRequire("iBSwI");


var $5N5Hu = parcelRequire("5N5Hu");


var $39uD5 = parcelRequire("39uD5");


var $7FAg9 = parcelRequire("7FAg9");


var $i5NyM = parcelRequire("i5NyM");


var $2KJU8 = parcelRequire("2KJU8");


var $96Uu5 = parcelRequire("96Uu5");


var $kOMDA = parcelRequire("kOMDA");


var $70Lwl = parcelRequire("70Lwl");


var $iipo1 = parcelRequire("iipo1");


var $6PN31 = parcelRequire("6PN31");


var $8vIZB = parcelRequire("8vIZB");


var $klIiV = parcelRequire("klIiV");

const $34183cfe058a8bad$export$fa98ce94fc01fa17 = {
    brainstormConfigItem: (0, $9lB81.brainstorm)(),
    freeGenerateAifcConfigItem: (0, $7FAg9.freeGenerateAifc)()
};
function $34183cfe058a8bad$var$getDynamicSurfaceConfigItems(opts) {
    const dynamicSurfaceConfigItems = [
        // Only brainstorm, suggest title and find action items are enabled for empty
        {
            config: (0, $iBSwI.improveWriting)(opts),
            triggers: {
                empty: {
                    enabled: false
                },
                selection: {
                    enabled: true
                }
            }
        },
        {
            config: (0, $iBSwI.fixSpellingAndGrammar)(opts),
            triggers: {
                empty: {
                    enabled: false
                },
                selection: {
                    enabled: true
                }
            }
        },
        {
            config: (0, $l5nYy.changeToneToProfessional)(opts),
            triggers: {
                empty: {
                    enabled: false
                },
                selection: {
                    enabled: true
                }
            }
        },
        {
            config: (0, $l5nYy.changeToneToEmpathetic)(opts),
            triggers: {
                empty: {
                    enabled: false
                },
                selection: {
                    enabled: true
                }
            }
        },
        {
            config: (0, $l5nYy.changeToneToCasual)(opts),
            triggers: {
                empty: {
                    enabled: false
                },
                selection: {
                    enabled: true
                }
            }
        },
        {
            config: (0, $l5nYy.changeToneToEducational)(opts),
            triggers: {
                empty: {
                    enabled: false
                },
                selection: {
                    enabled: true
                }
            }
        },
        {
            config: (0, $96Uu5.makeShorter)(opts),
            triggers: {
                empty: {
                    enabled: false
                },
                selection: {
                    enabled: true
                }
            }
        },
        {
            config: (0, $2KJU8.makeLonger)(opts),
            triggers: {
                empty: {
                    enabled: false
                },
                selection: {
                    enabled: true
                }
            }
        },
        (0, $kOMDA.addPolishWithOptions)(opts),
        // Convert to table and bullet list are already on enabled for selection
        (0, $e1P7K.convertToBulletListWithOptions)(opts),
        (0, $2gxrt.convertToTableWithOptions)(opts),
        (0, $39uD5.findActionItemsWithOptions)(opts),
        (0, $70Lwl.suggestTitleForConfluenceTitleToolbarWithOptions)(opts),
        {
            config: (0, $iipo1.summarizeWriting)(opts),
            triggers: {
                empty: {
                    enabled: false
                },
                selection: {
                    enabled: true
                }
            }
        },
        ...(0, $6PN31.translationConfigItemWithOptionsEnabledForSelectionOnly)(opts)
    ];
    // Fix this const name after team 25 with platform_editor_ai_aifc_streaming being cleaned up
    const dynamicSurfaceConfigItemsTeam25 = [
        {
            config: (0, $iBSwI.improveWriting)(opts),
            triggers: {
                empty: {
                    enabled: false
                },
                selection: {
                    enabled: true
                }
            }
        },
        ...(0, $dh538.fg)('platform_editor_ai_aifc_patch_ga') ? [
            (0, $kOMDA.addPolishWithOptions)(opts)
        ] : [],
        {
            config: (0, $iBSwI.fixSpellingAndGrammar)(opts),
            triggers: {
                empty: {
                    enabled: true,
                    docMinSize: 1
                },
                selection: {
                    enabled: true
                }
            }
        },
        {
            config: (0, $l5nYy.changeToneToCasual)(opts),
            triggers: {
                empty: {
                    enabled: true,
                    docMinSize: 1
                },
                selection: {
                    enabled: true
                }
            }
        },
        {
            config: (0, $l5nYy.changeToneToEmpathetic)(opts),
            triggers: {
                empty: {
                    enabled: true,
                    docMinSize: 1
                },
                selection: {
                    enabled: true
                }
            }
        },
        {
            config: (0, $l5nYy.changeToneToProfessional)(opts),
            triggers: {
                empty: {
                    enabled: true,
                    docMinSize: 1
                },
                selection: {
                    enabled: true
                }
            }
        },
        {
            config: (0, $96Uu5.makeShorter)(opts),
            triggers: {
                empty: {
                    enabled: true,
                    docMinSize: 1
                },
                selection: {
                    enabled: true
                }
            }
        },
        {
            config: (0, $2KJU8.makeLonger)(opts),
            triggers: {
                empty: {
                    enabled: true,
                    docMinSize: 1
                },
                selection: {
                    enabled: true
                }
            }
        },
        ...!(0, $dh538.fg)('platform_editor_ai_aifc_patch_ga') ? [
            (0, $kOMDA.addPolishWithOptions)(opts)
        ] : [],
        ...(0, $6PN31.translationConfigItemWithOptionsEnabledForSelectionOnly)(opts)
    ];
    return opts.isInDocumentStreamingEnabled ? dynamicSurfaceConfigItemsTeam25 : dynamicSurfaceConfigItems;
}
const $34183cfe058a8bad$export$25814a113f71ded2 = (props)=>{
    const { editorView: editorView, configItem: configItem } = props;
    const openAIModalCommand = (0, $5SuLc.createOpenAIModalCommand)({
        state: editorView.state,
        configItem: configItem,
        lastTriggeredFrom: 'triggerConfigItem',
        aiGlobalOptIn: {
            status: 'enabled',
            triggerOptInFlow: ()=>{}
        }
    });
    openAIModalCommand(editorView.state, editorView.dispatch);
};
function $34183cfe058a8bad$export$15d114523124a386(options) {
    /**
   * Not abstracting these defaults up, in order to be explicit about possible
   * different behaviours between page comment and page editors.
   */ // Now deprecated - migrate to handleFeedbackSubmission
    const onExperienceEvent = options.onExperienceEvent || {
        THUMBS_UP: ()=>{},
        THUMBS_DOWN: ()=>{},
        REVIEW_STATE_ENTERED: ()=>{},
        EXPERIENCE_COMPLETE: ()=>{}
    };
    function getConfigItems(opts) {
        const list = [
            (0, $l5nYy.changeToneToProfessionalWithOptions)(opts),
            (0, $iipo1.summarizeWritingWithOptions)(opts),
            (0, $iBSwI.improveWritingWithOptions)(opts),
            (0, $iBSwI.fixSpellingAndGrammarWithOptions)(opts),
            (0, $96Uu5.makeShorterWithOptions)(opts),
            (0, $2KJU8.makeLongerWithOptions)(opts),
            (0, $e1P7K.convertToBulletListWithOptions)(opts),
            (0, $2gxrt.convertToTableWithOptions)(opts),
            (0, $70Lwl.suggestTitleWithOptions)(opts),
            (0, $l5nYy.changeToneToEmpatheticWithOptions)(opts),
            (0, $l5nYy.changeToneToCasualWithOptions)(opts),
            (0, $l5nYy.changeToneToEducationalWithOptions)(opts),
            ...(0, $6PN31.translationConfigItemWithOptions)(opts)
        ];
        const experimentalPromptPlaceholderData = (0, $5N5Hu.getExperimentalPromptPlaceholderConfigItemWithOptions)();
        if (experimentalPromptPlaceholderData) {
            const { listOrder: listOrder, configItemWithOptions: configItemWithOptions } = experimentalPromptPlaceholderData;
            list.splice(listOrder, 0, configItemWithOptions);
        }
        return list;
    }
    const product = options.product ? options.product : 'CONFLUENCE';
    const isInDocumentStreamingEnabled = options.isInDocumentStreamingEnabled ?? (0, $dh538.fg)('platform_editor_ai_aifc_streaming');
    return {
        aiGlobalOptIn: options.aiGlobalOptIn,
        baseGenerate: (0, $i5NyM.freeGenerate)(),
        configItemWithOptions: getConfigItems({
            product: product,
            isInDocumentStreamingEnabled: isInDocumentStreamingEnabled
        }),
        disableAISelectionToolbar: true,
        product: product,
        objectId: options.objectId,
        getFetchCustomHeaders: options.getFetchCustomHeaders || (0, $klIiV._getFetchCustomHeaders),
        onExperienceEvent: onExperienceEvent,
        handleFeedbackSubmission: options.handleFeedbackSubmission,
        AIButtonWrapper: options.AIButtonWrapper,
        PromptEditor: options.PromptEditor,
        providers: options.providers,
        auditLogSettings: options.auditLogSettings,
        /**
     * Below options are added to use rovo agent behind the scenes for free generate.
     *
     * Need to load rovo agents, so getChannelVariables and isRovoEnabled is set.
     * showRovoAgentsInCommandPalette will disable showing Rovo agents section.
     * useFreeGenerateEditorAgent will swap standard free generate prompt with
     * 	rovo agent enabled free generate after agents are loaded.
     * If loading agents fails, then fallback to standard free generate.
     */ getChannelVariables: options.getChannelVariables,
        isRovoEnabled: options.isRovoEnabled ?? true,
        showRovoAgentsInCommandPalette: options.showRovoAgentsInCommandPalette ?? false,
        useFreeGenerateEditorAgent: options.useFreeGenerateEditorAgent ?? true,
        onSubmit: options.onSubmit,
        onAnnotationsRemoved: options.onAnnotationsRemoved,
        getUserPreferences: options.getUserPreferences,
        isInDocumentStreamingEnabled: isInDocumentStreamingEnabled
    };
}
const $34183cfe058a8bad$export$b2747cd26144b27d = (options)=>{
    /**
   * Not abstracting these defaults up, in order to be explicit about possible
   * different behaviours between page comment and page editors.
   */ // Now deprecated - migrate to handleFeedbackSubmission
    const onExperienceEvent = options.onExperienceEvent || {
        THUMBS_UP: ()=>{},
        THUMBS_DOWN: ()=>{},
        REVIEW_STATE_ENTERED: ()=>{},
        EXPERIENCE_COMPLETE: ()=>{}
    };
    function getConfigItems(opts) {
        const list = [
            (0, $l5nYy.changeToneToProfessionalWithOptions)(opts),
            (0, $iipo1.summarizeWritingWithOptions)(opts),
            (0, $iBSwI.improveWritingWithOptions)(opts),
            (0, $iBSwI.fixSpellingAndGrammarWithOptions)(opts),
            (0, $96Uu5.makeShorterWithOptions)(opts),
            (0, $2KJU8.makeLongerWithOptions)(opts),
            (0, $e1P7K.convertToBulletListWithOptions)(opts),
            (0, $2gxrt.convertToTableWithOptions)(opts),
            (0, $39uD5.findActionItemsWithOptions)(opts),
            (0, $70Lwl.suggestTitleWithOptions)(opts),
            (0, $l5nYy.changeToneToEmpatheticWithOptions)(opts),
            (0, $l5nYy.changeToneToCasualWithOptions)(opts),
            (0, $l5nYy.changeToneToEducationalWithOptions)(opts),
            (0, $kOMDA.addPolishWithOptions)(opts),
            ...(0, $6PN31.translationConfigItemWithOptions)(opts)
        ];
        const newListOrder = [
            (0, $iBSwI.fixSpellingAndGrammarWithOptions)(opts),
            (0, $l5nYy.changeToneToProfessionalWithOptions)(opts),
            (0, $96Uu5.makeShorterWithOptions)(opts),
            (0, $iipo1.summarizeWritingWithOptions)(opts),
            (0, $iBSwI.improveWritingWithOptions)(opts),
            (0, $2KJU8.makeLongerWithOptions)(opts),
            (0, $e1P7K.convertToBulletListWithOptions)(opts),
            (0, $2gxrt.convertToTableWithOptions)(opts),
            (0, $39uD5.findActionItemsWithOptions)(opts),
            (0, $70Lwl.suggestTitleWithOptions)(opts),
            (0, $l5nYy.changeToneToEmpatheticWithOptions)(opts),
            (0, $l5nYy.changeToneToCasualWithOptions)(opts),
            (0, $l5nYy.changeToneToEducationalWithOptions)(opts),
            (0, $kOMDA.addPolishWithOptions)(opts),
            ...(0, $6PN31.translationConfigItemWithOptions)(opts)
        ];
        const experimentalPromptPlaceholderData = (0, $5N5Hu.getExperimentalPromptPlaceholderConfigItemWithOptions)();
        if (experimentalPromptPlaceholderData && !opts.isInDocumentStreamingEnabled) {
            const { listOrder: listOrder, configItemWithOptions: configItemWithOptions } = experimentalPromptPlaceholderData;
            list.splice(listOrder, 0, configItemWithOptions);
        }
        return opts.isInDocumentStreamingEnabled ? newListOrder : list;
    }
    const product = options.product ? options.product : 'CONFLUENCE';
    const isInDocumentStreamingEnabled = options.isInDocumentStreamingEnabled ?? (0, $dh538.fg)('platform_editor_ai_aifc_streaming');
    const configItemOptions = {
        product: product,
        isInDocumentStreamingEnabled: isInDocumentStreamingEnabled
    };
    return {
        aiGlobalOptIn: options.aiGlobalOptIn,
        baseGenerate: (0, $i5NyM.freeGenerate)(configItemOptions),
        configItemWithOptions: getConfigItems(configItemOptions),
        getSelectionToolbarDropdowns () {
            const selectionToolbarOptions = [
                {
                    id: 'change-tone',
                    label: (0, $7ShCl.aiMessages).confluenceChangeToneSelectionToolbarDropdownMenuTitle,
                    options: [
                        {
                            label: (0, $AMCQl.aiConfigItemMessages).changeToneProfessionalToneSelectionToolbarDropdownItemTitle,
                            configItem: (0, $l5nYy.changeToneToProfessional)(configItemOptions)
                        },
                        {
                            label: (0, $AMCQl.aiConfigItemMessages).changeToneEmpatheticToneSelectionToolbarDropdownItemTitle,
                            configItem: (0, $l5nYy.changeToneToEmpathetic)(configItemOptions)
                        },
                        {
                            label: (0, $AMCQl.aiConfigItemMessages).changeToneCasualToneSelectionToolbarDropdownItemTitle,
                            configItem: (0, $l5nYy.changeToneToCasual)(configItemOptions)
                        },
                        {
                            label: (0, $AMCQl.aiConfigItemMessages).changeToneNeutralToneSelectionToolbarDropdownItemTitle,
                            configItem: (0, $l5nYy.changeToneToNeutral)(configItemOptions)
                        },
                        {
                            label: (0, $AMCQl.aiConfigItemMessages).changeToneEducationalToneSelectionToolbarDropdownItemTitle,
                            configItem: (0, $l5nYy.changeToneToEducational)(configItemOptions)
                        }
                    ]
                },
                {
                    id: 'rewrite',
                    label: (0, $7ShCl.aiMessages).confluenceRewriteSelectionToolbarDropdownMenuTitle,
                    options: [
                        {
                            label: (0, $AMCQl.aiConfigItemMessages).improveWritingSelectionToolbarDropdownItemTitle,
                            configItem: (0, $iBSwI.improveWriting)(configItemOptions)
                        },
                        {
                            label: (0, $AMCQl.aiConfigItemMessages).fixSpellingGrammarSelectionToolbarDropdownItemTitle,
                            configItem: (0, $iBSwI.fixSpellingAndGrammar)(configItemOptions)
                        },
                        {
                            label: (0, $AMCQl.aiConfigItemMessages).summarizeWritingSelectionToolbarDropdownItemTitle,
                            configItem: (0, $iipo1.summarizeWriting)(configItemOptions)
                        },
                        {
                            label: (0, $AMCQl.aiConfigItemMessages).makeShorterSelectionToolbarDropdownItemTitle,
                            configItem: (0, $96Uu5.makeShorter)(configItemOptions)
                        }
                    ]
                }
            ];
            const translationConfigItemsMap = (0, $6PN31.createTranslationConfigItems)(configItemOptions);
            const translateOptions = (0, $8vIZB.getSortedSupportedTranslationLanguages)().map((language)=>{
                const label = (0, $bpQiY.aiLanguageMessages)[language];
                return {
                    label: label,
                    configItem: translationConfigItemsMap[language]
                };
            });
            selectionToolbarOptions.push({
                id: 'translate',
                label: (0, $7ShCl.aiMessages).confluenceTranslateSelectionToolbarDropdownMenuTitle,
                options: translateOptions
            });
            return selectionToolbarOptions;
        },
        disableAISelectionToolbar: false,
        hidePrimaryToolbarButton: isInDocumentStreamingEnabled ? false : options.hidePrimaryToolbarButton,
        product: product,
        objectId: options.objectId,
        getFetchCustomHeaders: options.getFetchCustomHeaders || (0, $klIiV._getFetchCustomHeaders),
        getChannelVariables: options.getChannelVariables,
        onDocChangeByAgent: options.onDocChangeByAgent,
        onAIProviderChanged: options.onAIProviderChanged,
        onExperienceEvent: onExperienceEvent,
        handleFeedbackSubmission: options.handleFeedbackSubmission,
        AIButtonWrapper: options.AIButtonWrapper,
        PromptEditor: options.PromptEditor,
        disableInterrogation: options.disableInterrogation ?? false,
        aiUsageDisclaimer: options.aiUsageDisclaimer,
        isRovoEnabled: options.isRovoEnabled ?? true,
        /**
     * Below options are added because;
     * - Show rovo agents in command palette.
     */ showRovoAgentsInCommandPalette: options.showRovoAgentsInCommandPalette ?? true,
        providers: options.providers,
        auditLogSettings: options.auditLogSettings,
        aiSmartButtonOptions: options.aiSmartButtonOptions,
        heroConfigItem: isInDocumentStreamingEnabled ? (0, $iBSwI.improveWritingWithOptions)(configItemOptions) : undefined,
        ...options.aiGlobalOptIn.status === 'enabled' && (0, $dh538.fg)('ai-smart-button-team-25') && {
            dynamicSurfaceConfigItems: $34183cfe058a8bad$var$getDynamicSurfaceConfigItems(configItemOptions)
        },
        onAnnotationsRemoved: options.onAnnotationsRemoved,
        getUserPreferences: options.getUserPreferences,
        onSubmit: options.onSubmit,
        isInDocumentStreamingEnabled: isInDocumentStreamingEnabled
    };
};
const $34183cfe058a8bad$export$679d027153aa30cf = (editorApi)=>{
    const onActionClick = (configItem)=>{
        return ()=>{
            editorApi.aiExperience?.actions.openAIModal({
                invokedFrom: 'objectSidebar',
                configItem: configItem
            });
        };
    };
    const configItemOptions = {
        product: 'CONFLUENCE',
        isInDocumentStreamingEnabled: (0, $dh538.fg)('platform_editor_ai_aifc_streaming')
    };
    const changeToneActionItems = [
        {
            title: (0, $7ShCl.aiMessages).moreProfessionalToneToolbarDropdownIconTitle,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($oeZjt))),
            onClick: onActionClick((0, $l5nYy.changeToneToProfessional)(configItemOptions))
        },
        {
            title: (0, $7ShCl.aiMessages).moreCasualToneToolbarDropdownIconTitle,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($j398X))),
            onClick: onActionClick((0, $l5nYy.changeToneToCasual)(configItemOptions))
        },
        {
            title: (0, $7ShCl.aiMessages).moreEmpatheticToneToolbarDropdownIconTitle,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($j8LwF))),
            onClick: onActionClick((0, $l5nYy.changeToneToEmpathetic)(configItemOptions))
        }
    ];
    const adjustLengthActionItems = [
        {
            title: (0, $7ShCl.aiMessages).makeShorterToolbarDropdownIconTitle,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($cH4SO))),
            onClick: onActionClick((0, $96Uu5.makeShorter)(configItemOptions))
        },
        {
            title: (0, $7ShCl.aiMessages).makeLongerToolbarDropdownIconTitle,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($eugUs))),
            onClick: onActionClick((0, $2KJU8.makeLonger)(configItemOptions))
        }
    ];
    const objectSideBarButtons = [
        {
            title: (0, $7ShCl.aiMessages).spellingAndGrammarToolbarDropdownIconTitle,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($dLjaJ))),
            onClick: onActionClick((0, $iBSwI.fixSpellingAndGrammar)(configItemOptions))
        },
        {
            title: (0, $7ShCl.aiMessages).changeToneToolbarDropdownIconTitle,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($iulqN))),
            subItems: changeToneActionItems
        },
        {
            title: (0, $7ShCl.aiMessages).adjustLengthToolbarDropdownIconTitle,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($drPNW))),
            subItems: adjustLengthActionItems
        },
        {
            title: (0, $AMCQl.aiConfigItemMessages).addPolishTitle,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($cbtR4))),
            onClick: onActionClick((0, $kOMDA.addPolish)(configItemOptions))
        }
    ];
    return objectSideBarButtons;
};
module.exports["UNSTABLE_configItems"] = $34183cfe058a8bad$export$fa98ce94fc01fa17;
module.exports["createPageCommentEditorPluginAIOptions"] = $34183cfe058a8bad$export$15d114523124a386;
module.exports["createPageEditorPluginAIOptions"] = $34183cfe058a8bad$export$b2747cd26144b27d;
module.exports["getEditorActionsForObjectSidebar"] = $34183cfe058a8bad$export$679d027153aa30cf;

});

parcelRegister("9lB81", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $AMCQl = parcelRequire("AMCQl");


var $amTdb = parcelRequire("amTdb");


var $jc4DP = parcelRequire("jc4DP");


var $bwpRs = parcelRequire("bwpRs");

const $27f50db3f6ad9211$export$683185be8e4be56f = (options)=>({
        key: (0, $bwpRs.CONFIG_ITEM_KEYS).BRAINSTORM,
        title: (0, $AMCQl.aiConfigItemMessages).brainstormTitle,
        description: (0, $AMCQl.aiConfigItemMessages).brainstormDescription,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $amTdb.BrainstormIcon), null),
        promptLabel: (0, $AMCQl.aiConfigItemMessages).brainstormPromptLabel,
        promptHint: (0, $AMCQl.aiConfigItemMessages).brainstormPromptHint,
        doNotHighlightDocWhenSelectionIsEmpty: true,
        agentId: 'editor_agent',
        intentSchemaId: 'brainstorm_intent_schema.json',
        featureId: 'brainstorm',
        alwaysNoDocAndSelection: true,
        actions: {
            empty: [
                (0, $jc4DP.createInsertAtCurrentPosition)({
                    appearance: 'primary'
                })
            ]
        },
        getBackendModel: ()=>{
            return 'assistance-service';
        }
    });
const $27f50db3f6ad9211$export$dddd8d441293ae3 = (options)=>({
        config: $27f50db3f6ad9211$export$683185be8e4be56f(options),
        triggers: {
            empty: {
                enabled: true,
                docMinSize: 0
            },
            selection: {
                enabled: false
            }
        }
    });
module.exports["brainstorm"] = $27f50db3f6ad9211$export$683185be8e4be56f;

});

parcelRegister("amTdb", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $3HOqx = parcelRequire("3HOqx");

const $3aec6cdf0df0a4db$export$ced89349fedce38 = ({ size: size = 'medium' } = {})=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3HOqx))), {
        label: "",
        spacing: "spacious",
        size: size
    });
module.exports["BrainstormIcon"] = $3aec6cdf0df0a4db$export$ced89349fedce38;

});

parcelRegister("e1P7K", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $AMCQl = parcelRequire("AMCQl");


var $cUQMr = parcelRequire("cUQMr");


var $jc4DP = parcelRequire("jc4DP");


var $bwpRs = parcelRequire("bwpRs");

const $42e6feb7d3869fde$var$intentSchemaId = 'convert_to_bullet_points.json';
const $42e6feb7d3869fde$export$c791aa34bcfdf607 = (options)=>({
        key: (0, $bwpRs.CONFIG_ITEM_KEYS).CONVERT_TO_BULLETED_LIST,
        title: (0, $AMCQl.aiConfigItemMessages).convertToBulletListTitle,
        description: (0, $AMCQl.aiConfigItemMessages).convertToBulletListDescription,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cUQMr))), {
                label: "",
                spacing: "spacious"
            }),
        statusLozengeType: 'beta',
        intentSchemaId: $42e6feb7d3869fde$var$intentSchemaId,
        actions: {
            selection: [
                (0, $jc4DP.createInsertBelow)({
                    appearance: 'secondary',
                    factoryOptions: options
                }),
                (0, $jc4DP.createReplace)({
                    appearance: 'primary'
                })
            ]
        }
    });
const $42e6feb7d3869fde$export$37c986c539d0ca07 = (options)=>({
        config: $42e6feb7d3869fde$export$c791aa34bcfdf607(options),
        triggers: {
            empty: {
                enabled: false
            },
            selection: {
                enabled: true
            }
        }
    });
module.exports["convertToBulletListWithOptions"] = $42e6feb7d3869fde$export$37c986c539d0ca07;

});

parcelRegister("2gxrt", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $AMCQl = parcelRequire("AMCQl");


var $4ymSL = parcelRequire("4ymSL");


var $jc4DP = parcelRequire("jc4DP");


var $bwpRs = parcelRequire("bwpRs");

const $db220b5201a1bbd7$var$intentSchemaId = 'convert_to_table.json';
const $db220b5201a1bbd7$export$a7ada90d2d2877a7 = (options)=>({
        key: (0, $bwpRs.CONFIG_ITEM_KEYS).CONVERT_TO_TABLE,
        title: (0, $AMCQl.aiConfigItemMessages).convertToTableTitle,
        description: (0, $AMCQl.aiConfigItemMessages).convertToTableDescription,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4ymSL))), {
                label: "",
                spacing: "spacious"
            }),
        statusLozengeType: 'beta',
        intentSchemaId: $db220b5201a1bbd7$var$intentSchemaId,
        actions: {
            selection: [
                (0, $jc4DP.createInsertBelow)({
                    appearance: 'secondary',
                    factoryOptions: options
                }),
                (0, $jc4DP.createReplace)({
                    appearance: 'primary'
                })
            ]
        }
    });
const $db220b5201a1bbd7$export$d67616d0b45ccf63 = (options)=>({
        config: $db220b5201a1bbd7$export$a7ada90d2d2877a7(options),
        triggers: {
            empty: {
                enabled: false
            },
            selection: {
                enabled: true
            }
        }
    });
module.exports["convertToTableWithOptions"] = $db220b5201a1bbd7$export$d67616d0b45ccf63;

});

parcelRegister("5N5Hu", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $amTdb = parcelRequire("amTdb");


var $jc4DP = parcelRequire("jc4DP");


var $bwpRs = parcelRequire("bwpRs");


var $hPLeC = parcelRequire("hPLeC");

const $84071a294f2874db$export$6cd03141a939166d = ()=>{
    const configurations = (0, $hPLeC.getExperimentalPlaceholderPromptConfiguration)();
    if (configurations) {
        const statusLozengeType = configurations.statusType.toLowerCase() === 'new' || configurations.statusType.toLowerCase() === 'beta' ? configurations.statusType.toLowerCase() : undefined;
        return {
            ...configurations,
            configItem: {
                key: (0, $bwpRs.CONFIG_ITEM_KEYS).EXPERIMENTAL_PROMPT_PLACEHOLDER,
                title: configurations.label,
                description: configurations.description,
                icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $amTdb.BrainstormIcon), null),
                statusLozengeType: statusLozengeType,
                intentSchemaId: configurations.intent,
                actions: {
                    empty: [
                        (0, $jc4DP.createInsertAtCurrentPosition)({
                            appearance: 'secondary'
                        }),
                        (0, $jc4DP.createInsertAtTop)({
                            appearance: 'primary'
                        })
                    ],
                    selection: [
                        (0, $jc4DP.createInsertBelow)({
                            appearance: 'secondary'
                        }),
                        (0, $jc4DP.createReplace)({
                            appearance: 'primary'
                        })
                    ]
                },
                getBackendModel: ()=>{
                    return 'assistance-service';
                }
            }
        };
    }
};
const $84071a294f2874db$export$d991dc90761ce2a0 = ()=>{
    const res = $84071a294f2874db$export$6cd03141a939166d();
    if (res) {
        const { configItem: configItem, ...others } = res;
        return {
            configItemWithOptions: {
                config: configItem,
                triggers: {
                    empty: {
                        enabled: true,
                        docMinSize: 1
                    },
                    selection: {
                        enabled: true
                    }
                }
            },
            ...others
        };
    }
};
module.exports["getExperimentalPromptPlaceholderConfigItemWithOptions"] = $84071a294f2874db$export$d991dc90761ce2a0;

});

parcelRegister("hPLeC", function(module, exports) {

var $c6GJD = parcelRequire("c6GJD");

const $63b70a897e24cdc6$export$cd87ff8f4335648e = ()=>{
    const getExperimentValue = (0, $c6GJD.default).getExperimentValue;
    const variation = getExperimentValue('platform_editor_ai-prompts-placeholder', 'cohort', 'not-enrolled');
    if (variation !== 'control' && variation !== 'not-enrolled') {
        const label = getExperimentValue('platform_editor_ai-prompts-placeholder', 'label', '');
        const description = getExperimentValue('platform_editor_ai-prompts-placeholder', 'description', '');
        const intent = getExperimentValue('platform_editor_ai-prompts-placeholder', 'intent', '');
        const listOrder = getExperimentValue('platform_editor_ai-prompts-placeholder', 'list_order', 0);
        const analyticsExperienceName = getExperimentValue('platform_editor_ai-prompts-placeholder', 'analytics_experience_name', '');
        // The follow are optional backwards compatible properties which can be configured in the experiment
        const showOnEmpty = getExperimentValue('platform_editor_ai-prompts-placeholder', 'show_on_empty_page', true);
        const statusType = getExperimentValue('platform_editor_ai-prompts-placeholder', 'prompt_status_type', '');
        if (label && description && intent && analyticsExperienceName) return {
            label: {
                id: label,
                description: label,
                defaultMessage: label
            },
            description: {
                id: description,
                description: description,
                defaultMessage: description
            },
            intent: intent,
            listOrder: listOrder,
            analyticsExperienceName: analyticsExperienceName,
            showOnEmpty: showOnEmpty,
            statusType: statusType
        };
    }
};
module.exports["getExperimentalPlaceholderPromptConfiguration"] = $63b70a897e24cdc6$export$cd87ff8f4335648e;

});

parcelRegister("39uD5", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $AMCQl = parcelRequire("AMCQl");


var $eIfuq = parcelRequire("eIfuq");


var $jc4DP = parcelRequire("jc4DP");


var $bwpRs = parcelRequire("bwpRs");

const $3e2ed2d891be3ae7$export$acf0f0fea45f23f0 = (options)=>({
        key: (0, $bwpRs.CONFIG_ITEM_KEYS).FIND_ACTION_ITEMS,
        title: (0, $AMCQl.aiConfigItemMessages).findActionItemsTitle,
        description: (0, $AMCQl.aiConfigItemMessages).findActionItemsDescription,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eIfuq.FindActionItemsIcon), null),
        intentSchemaId: 'action_items_intent_schema.json',
        featureId: 'find_action_items',
        actions: {
            empty: [
                (0, $jc4DP.createInsertAtTop)({
                    appearance: 'secondary'
                }),
                (0, $jc4DP.createInsertAtCurrentPosition)({
                    appearance: 'primary'
                })
            ],
            selection: [
                (0, $jc4DP.createInsertAtTop)({
                    appearance: 'secondary'
                }),
                (0, $jc4DP.createInsertBelow)({
                    appearance: 'primary',
                    factoryOptions: options
                })
            ]
        },
        getBackendModel: ()=>{
            return 'assistance-service';
        }
    });
const $3e2ed2d891be3ae7$export$8edb35f92492e5cd = (options)=>({
        config: $3e2ed2d891be3ae7$export$acf0f0fea45f23f0(options),
        triggers: {
            empty: {
                enabled: true,
                docMinSize: 1
            },
            selection: {
                enabled: true
            }
        }
    });
module.exports["findActionItemsWithOptions"] = $3e2ed2d891be3ae7$export$8edb35f92492e5cd;

});

parcelRegister("eIfuq", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $54tpX = parcelRequire("54tpX");

const $c28ec1426b832604$export$6eebfc33bd4f687b = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($54tpX))), {
        label: "",
        color: "currentColor",
        spacing: "spacious"
    });
module.exports["FindActionItemsIcon"] = $c28ec1426b832604$export$6eebfc33bd4f687b;

});

parcelRegister("7FAg9", function(module, exports) {

var $AMCQl = parcelRequire("AMCQl");


var $SFzFl = parcelRequire("SFzFl");


var $bwpRs = parcelRequire("bwpRs");

const $3502234323631fdc$export$28052871323f977f = (options)=>({
        key: (0, $bwpRs.CONFIG_ITEM_KEYS).FREE_GENERATE_AIFC,
        // This is to avoid StateMachine `guard` check
        title: {
            id: 'free-generate-aifc-title',
            defaultMessage: 'Free Generate AIFC'
        },
        description: (0, $SFzFl.default).aiUniversalLongCallToAction,
        promptHint: (0, $AMCQl.aiConfigItemMessages).freeGeneratePromptHint,
        adfPrompt: true,
        doNotHighlightDocWhenSelectionIsEmpty: true,
        insertOnEmptySelection: true,
        intentSchemaId: 'custom_free_generate_intent_schema.json',
        actions: {},
        getBackendModel: ()=>'aifc-bridge'
    });
module.exports["freeGenerateAifc"] = $3502234323631fdc$export$28052871323f977f;

});

parcelRegister("a37Yb", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9wGTI = parcelRequire("9wGTI");


var $9BMpC = parcelRequire("9BMpC");

const $10850ba042c4d830$export$8476ffec3fa9a1c6 = ({ editorAPIRef: editorAPIRef })=>{
    const pluginOptions = (0, $42omo.useMemo)(()=>{
        if (!(0, $9wGTI.fg)('cc_aifc_ai_streaming_spotlight')) return {};
        return {
            ButtonWrapper: ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9BMpC.AIStreamingSpotlight), {
                    editorAPIRef: editorAPIRef
                }, children)
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return {
        pluginOptions: pluginOptions
    };
};
module.exports["useTrackChangesPlugin"] = $10850ba042c4d830$export$8476ffec3fa9a1c6;

});

parcelRegister("9BMpC", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $inPa6 = parcelRequire("inPa6");


var $iXCQx = parcelRequire("iXCQx");


var $bqAtB = parcelRequire("bqAtB");

var $k7Tf7 = parcelRequire("k7Tf7");

var $a90ar = parcelRequire("a90ar");

var $3chlW = parcelRequire("3chlW");

var $f1UQW = parcelRequire("f1UQW");

var $71521 = parcelRequire("71521");

var $aVS0S = parcelRequire("aVS0S");

var $2owmo = parcelRequire("2owmo");

var $eopLP = parcelRequire("eopLP");

var $aZQ5F = parcelRequire("aZQ5F");

var $bUJpY = parcelRequire("bUJpY");

var $fNcP1 = parcelRequire("fNcP1");

var $8tIbq = parcelRequire("8tIbq");


var $fT2ta = parcelRequire("fT2ta");


var $cO1el = parcelRequire("cO1el");


var $eiA8Z = parcelRequire("eiA8Z");


var $lsxnT = parcelRequire("lsxnT");


var $bPDOf = parcelRequire("bPDOf");


var $ivb8S = parcelRequire("ivb8S");


var $9wGTI = parcelRequire("9wGTI");

const $3da6770d1388bea2$var$i18n = (0, $cgtv4.defineMessages)({
    AIStreamingSpotlightTitle: {
        id: "onboarding-ai-first-create.ai-streaming.spotlight.title",
        defaultMessage: "View changes or undo"
    },
    AIStreamingSpotlightDescription: {
        id: "onboarding-ai-first-create.ai-streamin.spotlight.description",
        defaultMessage: "Compare your edits and Rovo\u2019s to a prior version and undo if needed."
    },
    AIStreamingSpotlightCTA: {
        id: "onboarding-ai-first-create.ai-streamin.spotlight.cta",
        defaultMessage: "OK"
    }
});
const $3da6770d1388bea2$export$cdcb27ae41cfd474 = ({ children: children, editorAPIRef: editorAPIRef })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [isSpotlightActive, setIsSpotlightActive] = (0, $42omo.useState)(false);
    const [streamingState, setStreamingState] = (0, $42omo.useState)('initial');
    const { isStreaming: isStreaming, isShowDiffAvailable: isShowDiffAvailable } = (0, $eiA8Z.useSharedPluginStateWithSelector)(editorAPIRef?.current, [
        'aiExperience',
        'trackChanges'
    ], (states)=>{
        return {
            isStreaming: states?.aiExperienceState?.isStreaming,
            isShowDiffAvailable: states?.trackChangesState?.isShowDiffAvailable
        };
    });
    (0, $42omo.useEffect)(()=>{
        if (isStreaming) {
            if (streamingState === 'initial') setStreamingState('streaming');
        } else if (streamingState === 'streaming' && isShowDiffAvailable) setStreamingState('completed');
        else setStreamingState('initial');
    }, [
        isStreaming,
        isShowDiffAvailable,
        streamingState
    ]);
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const { data: data, loading: loading, error: error } = (0, $ivb8S.useGetOnboardingState)([
        ...Object.values((0, $bPDOf.AIFC_ONBOARDING_STATE_KEYS))
    ], !(0, $9wGTI.fg)('cc_aifc_ai_streaming_spotlight') || !(0, $9wGTI.fg)('aifc_create_enabled'));
    const { hasSeenTrackChangesStreamingSpotlight: hasSeenTrackChangesStreamingSpotlight } = (0, $ivb8S.deserializeState)(data);
    const handleSpotlightStart = (0, $42omo.useCallback)(()=>{
        setOnboardingState({
            key: (0, $bPDOf.AIFC_ONBOARDING_STATE_KEYS).hasSeenTrackChangesStreamingSpotlight,
            value: 'true'
        });
        setIsSpotlightActive(true);
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'AIStreamingSpotlight',
                attributes: {
                    source: 'onboarding-ai-first-create'
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        setOnboardingState
    ]);
    const handleSpotlightStop = (0, $42omo.useCallback)(()=>{
        setIsSpotlightActive(false);
    }, []);
    const { useChoreographer: useChoreographer } = (0, $lsxnT.useChoreographerAssets)();
    const aiStreamingSpotlightChoreographer = useChoreographer('AIStreamingSpotlight', {
        start: handleSpotlightStart,
        stop: handleSpotlightStop
    });
    const handleSpotlightInteraction = (0, $42omo.useCallback)((action, actionSubject, actionSubjectIdSuffix)=>{
        setIsSpotlightActive(false);
        aiStreamingSpotlightChoreographer.stopMessage();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: action,
                actionSubject: actionSubject,
                actionSubjectId: `AIStreamingSpotlight${actionSubjectIdSuffix ?? ''}`,
                source: 'onboarding-ai-first-create'
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        aiStreamingSpotlightChoreographer
    ]);
    const handleOnClick = (0, $42omo.useCallback)(()=>{
        handleSpotlightInteraction('clicked', 'button', 'CTA');
    }, [
        handleSpotlightInteraction
    ]);
    const handleOnDismiss = (0, $42omo.useCallback)(()=>{
        handleSpotlightInteraction('clicked', 'button', 'Dismiss');
    }, [
        handleSpotlightInteraction
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!loading && !error && !hasSeenTrackChangesStreamingSpotlight && !isStreaming && isShowDiffAvailable && streamingState === 'completed' && (0, $9wGTI.fg)('cc_aifc_ai_streaming_spotlight')) aiStreamingSpotlightChoreographer.startMessage();
    }, [
        loading,
        error,
        hasSeenTrackChangesStreamingSpotlight,
        aiStreamingSpotlightChoreographer,
        isStreaming,
        isShowDiffAvailable,
        streamingState
    ]);
    if (!isSpotlightActive) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k7Tf7.PopoverProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8tIbq.UNSAFE_UpdateOnChange), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a90ar.PopoverTarget), null, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bqAtB.PopoverContent), {
        dismiss: handleOnDismiss,
        isVisible: isSpotlightActive,
        placement: "bottom-start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fT2ta.default), {
        entranceDirection: "left"
    }, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $71521.SpotlightCard), {
            testId: "ai-streaming-spotlight"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aZQ5F.SpotlightHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUJpY.SpotlightHeadline), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
            as: "span",
            size: "small"
        }, formatMessage($3da6770d1388bea2$var$i18n.AIStreamingSpotlightTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aVS0S.SpotlightControls), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2owmo.SpotlightDismissControl), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f1UQW.SpotlightBody), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, formatMessage($3da6770d1388bea2$var$i18n.AIStreamingSpotlightDescription))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eopLP.SpotlightFooter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3chlW.SpotlightActions), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fNcP1.SpotlightPrimaryAction), {
            onClick: handleOnClick
        }, formatMessage($3da6770d1388bea2$var$i18n.AIStreamingSpotlightCTA)))))))));
};
module.exports["AIStreamingSpotlight"] = $3da6770d1388bea2$export$cdcb27ae41cfd474;

});

parcelRegister("84Iqc", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $dotQt = parcelRequire("dotQt");

const $0a7e0bfbc3e153f6$export$b025b000fc343096 = ({ api: _api, config: config })=>({
        name: 'showDiff',
        commands: {
            showDiff: (params)=>({ tr: tr })=>{
                    return tr.setMeta((0, $dotQt.showDiffPluginKey), {
                        ...params,
                        action: 'SHOW_DIFF'
                    });
                },
            hideDiff: ({ tr: tr })=>{
                return tr.setMeta((0, $dotQt.showDiffPluginKey), {
                    steps: [],
                    action: 'HIDE_DIFF'
                });
            },
            scrollToNext: ({ tr: tr })=>{
                return tr.setMeta((0, $dotQt.showDiffPluginKey), {
                    action: 'SCROLL_TO_NEXT'
                });
            },
            scrollToPrevious: ({ tr: tr })=>{
                return tr.setMeta((0, $dotQt.showDiffPluginKey), {
                    action: 'SCROLL_TO_PREVIOUS'
                });
            }
        },
        pmPlugins () {
            return [
                {
                    name: 'showDiffPlugin',
                    plugin: ({ getIntl: getIntl })=>(0, $dotQt.createPlugin)(config, getIntl)
                }
            ];
        },
        getSharedState: (editorState)=>{
            if (!editorState) return {
                isDisplayingChanges: false,
                activeIndex: undefined
            };
            const pluginState = (0, $dotQt.showDiffPluginKey).getState(editorState);
            const decorationCount = (0, $dh538.fg)('platform_editor_show_diff_scroll_navigation') ? (0, $dotQt.getScrollableDecorations)(pluginState?.decorations) : pluginState?.decorations?.find() || [];
            return {
                isDisplayingChanges: decorationCount.length > 0,
                activeIndex: pluginState?.activeIndex,
                numberOfChanges: decorationCount.length
            };
        }
    });
module.exports["showDiffPlugin"] = $0a7e0bfbc3e153f6$export$b025b000fc343096;

});

parcelRegister("dotQt", function(module, exports) {

var $6tl2G = parcelRequire("6tl2G");


var $1S4f7 = parcelRequire("1S4f7");


var $ks2lK = parcelRequire("ks2lK");


var $cO9ey = parcelRequire("cO9ey");


var $ftzrq = parcelRequire("ftzrq");


var $dh538 = parcelRequire("dh538");


var $dMUUs = parcelRequire("dMUUs");


var $8IH6e = parcelRequire("8IH6e");

const $5e437f43e556a591$export$cc8ba64700247b36 = new (0, $ks2lK.PluginKey)('showDiffPlugin');
const $5e437f43e556a591$export$c459ab16dd3c3d79 = (set)=>set?.find(undefined, undefined, (spec)=>spec.key === 'diff-inline' || spec.key === 'diff-widget' || spec.key === 'diff-block') ?? [];
const $5e437f43e556a591$export$ae829ec7b2625219 = (config, getIntl)=>{
    const nodeViewSerializer = new (0, $8IH6e.NodeViewSerializer)({});
    const setNodeViewSerializer = (editorView)=>{
        nodeViewSerializer.init({
            editorView: editorView
        });
    };
    return new (0, $1S4f7.SafePlugin)({
        key: $5e437f43e556a591$export$cc8ba64700247b36,
        appendTransaction (transactions, oldState, newState) {
            if (!(0, $dh538.fg)('platform_editor_show_diff_scroll_navigation')) return;
            // Check if any transaction contains scroll actions
            const scrollTransaction = transactions.find((tr)=>tr.getMeta($5e437f43e556a591$export$cc8ba64700247b36)?.action === 'SCROLL_TO_NEXT' || tr.getMeta($5e437f43e556a591$export$cc8ba64700247b36)?.action === 'SCROLL_TO_PREVIOUS');
            if (!scrollTransaction) return;
            const pluginState = $5e437f43e556a591$export$cc8ba64700247b36.getState(newState);
            if (!pluginState || pluginState.decorations.find().length === 0) return;
            const decorations = $5e437f43e556a591$export$c459ab16dd3c3d79(pluginState.decorations);
            const decoration = decorations[pluginState.activeIndex ?? 0];
            if (!decoration) return;
            const { from: from, to: to } = decoration;
            const $pos = newState.doc.resolve(from);
            const isNodeSelection = $pos.nodeAfter && $pos.nodeAfter.nodeSize === to - from && !$pos.nodeAfter.isInline;
            const tr = newState.tr;
            if (isNodeSelection) tr.setSelection((0, $ks2lK.NodeSelection).create(newState.doc, from));
            else tr.setSelection((0, $ks2lK.TextSelection).create(newState.doc, from));
            return tr.scrollIntoView();
        },
        state: {
            init (_, _state) {
                // We do initial setup after we setup the editor view
                return {
                    steps: [],
                    originalDoc: undefined,
                    decorations: (0, $ftzrq.DecorationSet).empty,
                    isDisplayingChanges: false
                };
            },
            apply: (tr, currentPluginState, oldState, newState)=>{
                const meta = tr.getMeta($5e437f43e556a591$export$cc8ba64700247b36);
                let newPluginState = currentPluginState;
                if (meta) {
                    if (meta?.action === 'SHOW_DIFF') {
                        // Update the plugin state with the new metadata
                        newPluginState = {
                            ...currentPluginState,
                            ...meta,
                            isDisplayingChanges: true,
                            activeIndex: 0
                        };
                        // Calculate and store decorations in state
                        const decorations = (0, $dMUUs.calculateDiffDecorations)({
                            state: newState,
                            pluginState: newPluginState,
                            nodeViewSerializer: nodeViewSerializer,
                            colorScheme: config?.colorScheme,
                            intl: getIntl(),
                            activeIndexPos: (0, $dh538.fg)('platform_editor_show_diff_scroll_navigation') ? newPluginState.activeIndexPos : undefined
                        });
                        // Update the decorations
                        newPluginState.decorations = decorations;
                    } else if (meta?.action === 'HIDE_DIFF') newPluginState = {
                        ...currentPluginState,
                        ...meta,
                        decorations: (0, $ftzrq.DecorationSet).empty,
                        isDisplayingChanges: false,
                        activeIndex: undefined
                    };
                    else if ((meta?.action === 'SCROLL_TO_NEXT' || meta?.action === 'SCROLL_TO_PREVIOUS') && (0, $dh538.fg)('platform_editor_show_diff_scroll_navigation')) {
                        // Update the active index in plugin state and recalculate decorations
                        const decorations = $5e437f43e556a591$export$c459ab16dd3c3d79(currentPluginState.decorations);
                        if (decorations.length > 0) {
                            let nextIndex = currentPluginState.activeIndex ?? 0;
                            if (meta.action === 'SCROLL_TO_NEXT') nextIndex = (nextIndex + 1) % decorations.length;
                            else nextIndex = (nextIndex - 1 + decorations.length) % decorations.length;
                            const activeDecoration = decorations[nextIndex];
                            newPluginState = {
                                ...currentPluginState,
                                activeIndex: nextIndex,
                                activeIndexPos: activeDecoration ? {
                                    from: activeDecoration.from,
                                    to: activeDecoration.to
                                } : undefined
                            };
                            // Recalculate decorations with the new active index
                            const updatedDecorations = (0, $dMUUs.calculateDiffDecorations)({
                                state: newState,
                                pluginState: newPluginState,
                                nodeViewSerializer: nodeViewSerializer,
                                colorScheme: config?.colorScheme,
                                intl: getIntl(),
                                activeIndexPos: newPluginState.activeIndexPos
                            });
                            newPluginState.decorations = updatedDecorations;
                        }
                    } else newPluginState = {
                        ...currentPluginState,
                        ...meta
                    };
                }
                return {
                    ...newPluginState,
                    decorations: newPluginState.decorations.map(tr.mapping, tr.doc)
                };
            }
        },
        view (editorView) {
            setNodeViewSerializer(editorView);
            let isFirst = true;
            return {
                update (view) {
                    // If we're using configuration to show diffs we initialise here once we setup the editor view
                    if (config?.originalDoc && config?.steps && config.steps.length > 0 && isFirst) {
                        isFirst = false;
                        view.dispatch(view.state.tr.setMeta($5e437f43e556a591$export$cc8ba64700247b36, {
                            action: 'SHOW_DIFF',
                            steps: config.steps.map((step)=>(0, $cO9ey.Step).fromJSON(view.state.schema, step)),
                            originalDoc: (0, $6tl2G.processRawValue)(view.state.schema, config.originalDoc)
                        }));
                    }
                }
            };
        },
        props: {
            decorations: (state)=>{
                const pluginState = $5e437f43e556a591$export$cc8ba64700247b36.getState(state);
                return pluginState?.decorations;
            }
        }
    });
};
module.exports["showDiffPluginKey"] = $5e437f43e556a591$export$cc8ba64700247b36;
module.exports["getScrollableDecorations"] = $5e437f43e556a591$export$c459ab16dd3c3d79;
module.exports["createPlugin"] = $5e437f43e556a591$export$ae829ec7b2625219;

});

parcelRegister("dMUUs", function(module, exports) {
// eslint-disable-next-line @atlassian/tangerine/import/entry-points

var $a4TK8 = parcelRequire("a4TK8");


var $2XqLN = parcelRequire("2XqLN");


var $6rMOj = parcelRequire("6rMOj");


var $2pjJ5 = parcelRequire("2pjJ5");


var $ftzrq = parcelRequire("ftzrq");


var $ffwvy = parcelRequire("ffwvy");


var $4eIWc = parcelRequire("4eIWc");


var $8R7BX = parcelRequire("8R7BX");


var $kOdMm = parcelRequire("kOdMm");

const $6a1dd0c85e18c1ea$var$calculateNodesForBlockDecoration = (doc, from, to, colorScheme)=>{
    const decorations = [];
    // Iterate over the document nodes within the range
    doc.nodesBetween(from, to, (node, pos)=>{
        if (node.isBlock) {
            const decoration = (0, $4eIWc.createBlockChangedDecoration)({
                from: pos,
                to: pos + node.nodeSize,
                name: node.type.name
            }, colorScheme);
            if (decoration) decorations.push(decoration);
        }
    });
    return decorations;
};
/**
 * Groups adjacent changes to reduce visual fragmentation in diffs.
 * Merges consecutive insertions and deletions that are close together.
 */ function $6a1dd0c85e18c1ea$var$optimizeChanges(changes) {
    if (changes.length <= 1) return changes;
    const optimized = [];
    let current = {
        ...changes[0]
    };
    for(let i = 1; i < changes.length; i++){
        const next = changes[i];
        // Check if changes are adjacent or very close (within 2 positions)
        const isAdjacent = next.fromB <= current.toB + 2;
        if (isAdjacent) current = {
            fromA: current.fromA,
            toA: Math.max(current.toA, next.toA),
            fromB: current.fromB,
            toB: Math.max(current.toB, next.toB),
            deleted: [
                ...current.deleted,
                ...next.deleted
            ],
            inserted: [
                ...current.inserted,
                ...next.inserted
            ]
        };
        else {
            optimized.push(current);
            current = {
                ...next
            };
        }
    }
    optimized.push(current);
    return optimized;
}
const $6a1dd0c85e18c1ea$var$calculateDiffDecorationsInner = ({ state: state, pluginState: pluginState, nodeViewSerializer: nodeViewSerializer, colorScheme: colorScheme, intl: intl, activeIndexPos: activeIndexPos })=>{
    const { originalDoc: originalDoc, steps: steps } = pluginState;
    if (!originalDoc || !pluginState.isDisplayingChanges) return (0, $ftzrq.DecorationSet).empty;
    const { tr: tr } = state;
    let steppedDoc = originalDoc;
    const attrSteps = [];
    const simplifiedSteps = (0, $kOdMm.simplifySteps)(steps, originalDoc);
    const stepMaps = [];
    for (const step of simplifiedSteps){
        const result = step.apply(steppedDoc);
        if (result.failed === null && result.doc) {
            if ((0, $ffwvy.stepIsValidAttrChange)(step, steppedDoc, result.doc)) attrSteps.push(step);
            stepMaps.push(step.getMap());
            steppedDoc = result.doc;
        }
    }
    // Rather than using .eq() we use a custom function that only checks for structural
    // changes and ignores differences in attributes which don't affect decoration positions
    if (!(0, $2pjJ5.areNodesEqualIgnoreAttrs)(steppedDoc, tr.doc)) return (0, $ftzrq.DecorationSet).empty;
    const changeset = (0, $6rMOj.ChangeSet).create(originalDoc).addSteps(steppedDoc, stepMaps, tr.doc);
    const changes = (0, $6rMOj.simplifyChanges)(changeset.changes, tr.doc);
    const optimizedChanges = $6a1dd0c85e18c1ea$var$optimizeChanges(changes);
    const decorations = [];
    optimizedChanges.forEach((change)=>{
        const isActive = activeIndexPos && change.fromB >= activeIndexPos.from && change.toB <= activeIndexPos.to;
        if (change.inserted.length > 0) {
            decorations.push((0, $4eIWc.createInlineChangedDecoration)(change, colorScheme, isActive));
            decorations.push(...$6a1dd0c85e18c1ea$var$calculateNodesForBlockDecoration(tr.doc, change.fromB, change.toB, colorScheme));
        }
        if (change.deleted.length > 0) {
            const isActive = activeIndexPos && change.fromB >= activeIndexPos.from && change.toB <= activeIndexPos.to;
            const decoration = (0, $4eIWc.createDeletedContentDecoration)({
                change: change,
                doc: originalDoc,
                nodeViewSerializer: nodeViewSerializer,
                colorScheme: colorScheme,
                newDoc: tr.doc,
                intl: intl,
                isActive: isActive
            });
            if (decoration) decorations.push(...decoration);
        }
    });
    (0, $8R7BX.getMarkChangeRanges)(steps).forEach((change)=>{
        const isActive = activeIndexPos && change.fromB >= activeIndexPos.from && change.toB <= activeIndexPos.to;
        decorations.push((0, $4eIWc.createInlineChangedDecoration)(change, colorScheme, isActive));
    });
    (0, $ffwvy.getAttrChangeRanges)(tr.doc, attrSteps).forEach((change)=>{
        decorations.push(...$6a1dd0c85e18c1ea$var$calculateNodesForBlockDecoration(tr.doc, change.fromB, change.toB, colorScheme));
    });
    return (0, $ftzrq.DecorationSet).empty.add(tr.doc, decorations);
};
const $6a1dd0c85e18c1ea$export$aa7cf3ccfb5d875f = (0, $2XqLN.default)($6a1dd0c85e18c1ea$var$calculateDiffDecorationsInner, // Cache results unless relevant inputs change
([{ pluginState: pluginState, state: state, colorScheme: colorScheme, intl: intl, activeIndexPos: activeIndexPos }], [{ pluginState: lastPluginState, state: lastState, colorScheme: lastColorScheme, intl: lastIntl, activeIndexPos: lastActiveIndexPos }])=>{
    const originalDocIsSame = lastPluginState.originalDoc && pluginState.originalDoc && pluginState.originalDoc.eq(lastPluginState.originalDoc);
    return (originalDocIsSame && (0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(pluginState.steps, lastPluginState.steps) && state.doc.eq(lastState.doc) && colorScheme === lastColorScheme && intl.locale === lastIntl.locale && (0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(activeIndexPos, lastActiveIndexPos)) ?? false;
});
module.exports["calculateDiffDecorations"] = $6a1dd0c85e18c1ea$export$aa7cf3ccfb5d875f;

});

parcelRegister("ffwvy", function(module, exports) {

var $9YoeD = parcelRequire("9YoeD");


var $aXG5V = parcelRequire("aXG5V");

const $295ce6c80dd2e5a4$var$filterUndefined = (x)=>!!x;
// Currently allow attributes that indicats a change in media image
const $295ce6c80dd2e5a4$var$allowedAttrs = [
    'id',
    'collection',
    'url'
];
const $295ce6c80dd2e5a4$export$34445edbbb29aecb = (doc, steps)=>{
    return steps.map((step)=>{
        if (step instanceof (0, $aXG5V.AttrStep) && $295ce6c80dd2e5a4$var$allowedAttrs.includes(step.attr) || step instanceof (0, $9YoeD.SetAttrsStep) && step.attrs && [
            ...Object.keys(step.attrs)
        ].some((v)=>$295ce6c80dd2e5a4$var$allowedAttrs.includes(v))) {
            const $pos = doc.resolve(step.pos);
            if ($pos.parent.type === doc.type.schema.nodes.mediaSingle) {
                const startPos = $pos.pos + $pos.parentOffset;
                return {
                    fromB: startPos,
                    toB: startPos + $pos.parent.nodeSize - 1
                };
            }
        }
        return undefined;
    }).filter($295ce6c80dd2e5a4$var$filterUndefined);
};
const $295ce6c80dd2e5a4$export$78b37f7430a7646c = (step, beforeDoc, afterDoc)=>{
    try {
        if (step instanceof (0, $aXG5V.AttrStep) || step instanceof (0, $9YoeD.SetAttrsStep)) {
            const attrStepAfter = afterDoc.nodeAt(step.pos);
            const attrStepBefore = beforeDoc.nodeAt(step.pos);
            // The change affected the document
            if (attrStepAfter && attrStepBefore && !attrStepAfter.eq(attrStepBefore)) return true;
        }
        return false;
    } catch (e) {
        return false;
    }
};
module.exports["getAttrChangeRanges"] = $295ce6c80dd2e5a4$export$34445edbbb29aecb;
module.exports["stepIsValidAttrChange"] = $295ce6c80dd2e5a4$export$78b37f7430a7646c;

});

parcelRegister("4eIWc", function(module, exports) {

var $24P9d = parcelRequire("24P9d");


var $ftzrq = parcelRequire("ftzrq");


var $dh538 = parcelRequire("dh538");


var $1oCLl = parcelRequire("1oCLl");


var $jFdfP = parcelRequire("jFdfP");


var $dI1fe = parcelRequire("dI1fe");


var $8fkLz = parcelRequire("8fkLz");


var $3Syf5 = parcelRequire("3Syf5");


var $9LSAA = parcelRequire("9LSAA");

const $3dc8b0bd0fe77648$export$69543ba6b110e31c = (change, colorScheme, isActive = false)=>{
    let style;
    if (colorScheme === 'traditional') style = isActive ? (0, $dI1fe.traditionalInsertStyleActive) : (0, $dI1fe.traditionalInsertStyle);
    else style = isActive ? (0, $jFdfP.editingStyleActive) : (0, $jFdfP.editingStyle);
    return (0, $ftzrq.Decoration).inline(change.fromB, change.toB, {
        style: style,
        'data-testid': 'show-diff-changed-decoration'
    }, {
        key: 'diff-inline'
    });
};
const $3dc8b0bd0fe77648$export$8482edbd6aeab6ec = (colorScheme)=>colorScheme === 'traditional' ? (0, $dI1fe.deletedTraditionalContentStyleUnbounded) : (0, $jFdfP.deletedContentStyleUnbounded);
const $3dc8b0bd0fe77648$export$e981ebd97f4ac3fc = (colorScheme, isActive = false)=>{
    if (colorScheme === 'traditional') return 0, $dI1fe.deletedTraditionalContentStyle;
    if (isActive) return (0, $1oCLl.expValEquals)('platform_editor_enghealth_a11y_jan_fixes', 'isEnabled', true) ? (0, $jFdfP.deletedContentStyleNewActive) : (0, $jFdfP.deletedContentStyleActive);
    return (0, $1oCLl.expValEquals)('platform_editor_enghealth_a11y_jan_fixes', 'isEnabled', true) ? (0, $jFdfP.deletedContentStyleNew) : (0, $jFdfP.deletedContentStyle);
};
const $3dc8b0bd0fe77648$var$getNodeClass = (name)=>{
    switch(name){
        case 'extension':
            return 'show-diff-changed-decoration-node';
        default:
            return undefined;
    }
};
const $3dc8b0bd0fe77648$var$getBlockNodeStyle = (name, colorScheme)=>{
    return colorScheme === 'traditional' ? (0, $dI1fe.getTraditionalNodeStyle)(name) : (0, $jFdfP.getStandardNodeStyle)(name);
};
const $3dc8b0bd0fe77648$export$8df64513a6dc1f2a = (change, colorScheme)=>{
    if ((0, $dh538.fg)('platform_editor_show_diff_scroll_navigation')) {
        const style = $3dc8b0bd0fe77648$var$getBlockNodeStyle(change.name, colorScheme);
        const className = $3dc8b0bd0fe77648$var$getNodeClass(change.name);
        if (style || className) return (0, $ftzrq.Decoration).node(change.from, change.to, {
            style: style,
            'data-testid': 'show-diff-changed-decoration-node',
            class: className
        }, {
            key: 'diff-block'
        });
        return undefined;
    } else return (0, $ftzrq.Decoration).node(change.from, change.to, {
        style: $3dc8b0bd0fe77648$var$getBlockNodeStyle(change.name, colorScheme),
        'data-testid': 'show-diff-changed-decoration-node',
        class: $3dc8b0bd0fe77648$var$getNodeClass(change.name)
    }, {
        key: 'diff-block'
    });
};
const $3dc8b0bd0fe77648$var$createContentWrapper = (colorScheme, isActive = false)=>{
    const wrapper = document.createElement('span');
    const baseStyle = (0, $24P9d.convertToInlineCss)({
        position: 'relative',
        width: 'fit-content'
    });
    wrapper.setAttribute('style', `${baseStyle}${$3dc8b0bd0fe77648$export$e981ebd97f4ac3fc(colorScheme, isActive)}`);
    const strikethrough = document.createElement('span');
    strikethrough.setAttribute('style', $3dc8b0bd0fe77648$export$8482edbd6aeab6ec(colorScheme));
    wrapper.append(strikethrough);
    return wrapper;
};
const $3dc8b0bd0fe77648$export$afefde4fd21bcada = ({ change: change, doc: doc, nodeViewSerializer: nodeViewSerializer, colorScheme: colorScheme, newDoc: newDoc, intl: intl, isActive: isActive = false })=>{
    const slice = doc.slice(change.fromA, change.toA);
    if (slice.content.content.length === 0) return;
    const isTableCellContent = slice.content.content.some(()=>slice.content.content.some((siblingNode)=>[
                'tableHeader',
                'tableCell'
            ].includes(siblingNode.type.name)));
    const isTableRowContent = slice.content.content.some(()=>slice.content.content.some((siblingNode)=>[
                'tableRow'
            ].includes(siblingNode.type.name)));
    if (isTableCellContent) return;
    if (isTableRowContent) {
        if (!(0, $dh538.fg)('platform_editor_ai_aifc_patch_ga')) return;
        const { decorations: decorations } = (0, $3Syf5.handleDeletedRows)([
            change
        ], doc, newDoc, nodeViewSerializer, colorScheme);
        return decorations;
    }
    const serializer = nodeViewSerializer;
    // For non-table content, use the existing span wrapper approach
    const dom = document.createElement('span');
    /*
   * The thinking is we separate out the fragment we got from doc.slice
   * and if it's the first or last content, we go in however many the sliced Open
   * or sliced End depth is and match only the entire node.
   */ slice.content.forEach((node)=>{
        // Helper function to handle multiple child nodes
        const handleMultipleChildNodes = (node)=>{
            if (node.content.childCount > 1 && node.type.inlineContent) {
                node.content.forEach((childNode)=>{
                    const childNodeView = serializer.tryCreateNodeView(childNode);
                    if (childNodeView) {
                        const lineBreak = document.createElement('br');
                        dom.append(lineBreak);
                        const wrapper = $3dc8b0bd0fe77648$var$createContentWrapper(colorScheme, isActive);
                        wrapper.append(childNodeView);
                        dom.append(wrapper);
                    } else {
                        // Fallback to serializing the individual child node
                        const serializedChild = serializer.serializeNode(childNode);
                        if (serializedChild) {
                            const wrapper = $3dc8b0bd0fe77648$var$createContentWrapper(colorScheme, isActive);
                            wrapper.append(serializedChild);
                            dom.append(wrapper);
                        }
                    }
                });
                return true; // Indicates we handled multiple children
            }
            return false; // Indicates single child, continue with normal logic
        };
        // Determine which node to use and how to serialize
        const isFirst = slice.content.firstChild === node;
        const isLast = slice.content.lastChild === node;
        const hasInlineContent = node.content.childCount > 0 && node.type.inlineContent === true;
        let fallbackSerialization;
        if (handleMultipleChildNodes(node)) return;
        if ((isFirst || isLast && slice.content.childCount > 2) && hasInlineContent) fallbackSerialization = ()=>serializer.serializeFragment(node.content);
        else if (isLast && slice.content.childCount === 2) fallbackSerialization = ()=>{
            if (node.type.name === 'text') return document.createTextNode(node.text || '');
            if (node.type.name === 'paragraph') {
                const lineBreak = document.createElement('br');
                dom.append(lineBreak);
                return serializer.serializeFragment(node.content);
            }
            return serializer.serializeFragment(node.content);
        };
        else fallbackSerialization = ()=>serializer.serializeNode(node);
        // Try to create node view, fallback to serialization
        const nodeView = serializer.tryCreateNodeView(node);
        if (nodeView) {
            if (node.isInline) {
                const wrapper = $3dc8b0bd0fe77648$var$createContentWrapper(colorScheme, isActive);
                wrapper.append(nodeView);
                dom.append(wrapper);
            } else // Handle all block nodes with unified function
            (0, $8fkLz.handleBlockNodeView)(dom, nodeView, node, colorScheme, intl);
        } else if (nodeViewSerializer.getFilteredNodeViewBlocklist([
            'paragraph',
            'tableRow'
        ]).has(node.type.name)) // Skip the case where the node is a paragraph or table row that way it can still be rendered and delete the entire table
        return;
        else {
            const fallbackNode = fallbackSerialization();
            if (fallbackNode) {
                const wrapper = (0, $8fkLz.createDeletedStyleWrapperWithoutOpacity)(colorScheme, isActive);
                wrapper.append(fallbackNode);
                dom.append(wrapper);
            }
        }
    });
    dom.setAttribute('data-testid', 'show-diff-deleted-decoration');
    // Widget decoration used for deletions as the content is not in the document
    // and we want to display the deleted content with a style.
    const safeInsertPos = (0, $9LSAA.findSafeInsertPos)(newDoc, change.fromB, slice);
    return [
        (0, $ftzrq.Decoration).widget(safeInsertPos, dom, {
            key: 'diff-widget'
        })
    ];
};
module.exports["createInlineChangedDecoration"] = $3dc8b0bd0fe77648$export$69543ba6b110e31c;
module.exports["getDeletedContentStyle"] = $3dc8b0bd0fe77648$export$e981ebd97f4ac3fc;
module.exports["createBlockChangedDecoration"] = $3dc8b0bd0fe77648$export$8df64513a6dc1f2a;
module.exports["createDeletedContentDecoration"] = $3dc8b0bd0fe77648$export$afefde4fd21bcada;

});

parcelRegister("jFdfP", function(module, exports) {

var $24P9d = parcelRequire("24P9d");

const $e676ff892da56a0a$export$8382eabaf43593de = (0, $24P9d.convertToInlineCss)({
    background: "var(--ds-background-accent-purple-subtlest, #F8EEFE)",
    textDecoration: 'underline',
    textDecorationStyle: 'dotted',
    textDecorationThickness: "var(--ds-space-025, 2px)",
    textDecorationColor: "var(--ds-border-accent-purple, #AF59E1)"
});
const $e676ff892da56a0a$export$97e4289fb0e21ca7 = (0, $24P9d.convertToInlineCss)({
    background: "var(--ds-background-accent-purple-subtler, #EED7FC)",
    textDecoration: 'underline',
    textDecorationStyle: 'dotted',
    textDecorationThickness: "var(--ds-space-025, 2px)",
    textDecorationColor: "var(--ds-text-accent-purple, #803FA5)"
});
const $e676ff892da56a0a$export$f65e7b80cdbdaf11 = (0, $24P9d.convertToInlineCss)({
    color: "var(--ds-text-accent-gray, #505258)",
    textDecoration: 'line-through',
    position: 'relative',
    opacity: 0.6
});
const $e676ff892da56a0a$export$1c9944aa8f37265b = (0, $24P9d.convertToInlineCss)({
    color: "var(--ds-text, #292A2E)",
    textDecoration: 'line-through',
    textDecorationColor: "var(--ds-text-accent-gray, #505258)",
    position: 'relative',
    opacity: 1
});
const $e676ff892da56a0a$export$da356444d868ff8e = (0, $24P9d.convertToInlineCss)({
    color: "var(--ds-text-accent-gray, #505258)",
    textDecoration: 'line-through',
    position: 'relative',
    opacity: 0.8
});
const $e676ff892da56a0a$export$cb9ee613be1d30ce = (0, $24P9d.convertToInlineCss)({
    color: "var(--ds-text, #292A2E)",
    textDecoration: 'line-through',
    textDecorationColor: "var(--ds-text-accent-gray, #505258)",
    position: 'relative',
    opacity: 1
});
const $e676ff892da56a0a$export$f9aac5ed53f3d424 = (0, $24P9d.convertToInlineCss)({
    position: 'absolute',
    top: '50%',
    width: '100%',
    display: 'inline-block',
    borderTop: `1px solid ${"var(--ds-text-accent-gray, #505258)"}`,
    pointerEvents: 'none',
    zIndex: 1
});
const $e676ff892da56a0a$var$editingStyleQuoteNode = (0, $24P9d.convertToInlineCss)({
    borderLeft: `2px solid ${"var(--ds-border-accent-purple, #AF59E1)"}`
});
const $e676ff892da56a0a$var$editingStyleRuleNode = (0, $24P9d.convertToInlineCss)({
    backgroundColor: "var(--ds-border-accent-purple, #AF59E1)"
});
const $e676ff892da56a0a$var$editingStyleNode = (0, $24P9d.convertToInlineCss)({
    boxShadow: `0 0 0 1px ${"var(--ds-border-accent-purple, #AF59E1)"}`,
    borderRadius: "var(--ds-radius-small, 4px)"
});
const $e676ff892da56a0a$var$editingStyleCardBlockNode = (0, $24P9d.convertToInlineCss)({
    boxShadow: `0 0 0 1px ${"var(--ds-border-accent-purple, #AF59E1)"}`,
    borderRadius: "var(--ds-radius-medium, 6px)"
});
const $e676ff892da56a0a$var$standardDecorationMarkerVariableName = (0, $24P9d.convertToInlineCss)({
    '--diff-decoration-marker-color': "var(--ds-border-accent-purple, #AF59E1)"
});
const $e676ff892da56a0a$export$302a34abd475e253 = (nodeName)=>{
    if ([
        'mediaSingle',
        'mediaGroup',
        'table',
        // Handle table separately to avoid border issues
        'tableRow',
        'tableCell',
        'tableHeader',
        'paragraph',
        // Paragraph and heading nodes do not need special styling
        'heading',
        'hardBreak',
        'decisionList',
        'taskList',
        'taskItem',
        'bulletList',
        'orderedList',
        'layoutSection'
    ].includes(nodeName)) // Layout nodes do not need special styling
    return undefined;
    if ([
        'extension',
        'embedCard',
        'listItem'
    ].includes(nodeName)) return $e676ff892da56a0a$var$standardDecorationMarkerVariableName;
    if (nodeName === 'blockquote') return $e676ff892da56a0a$var$editingStyleQuoteNode;
    if (nodeName === 'rule') return $e676ff892da56a0a$var$editingStyleRuleNode;
    if (nodeName === 'blockCard') return $e676ff892da56a0a$var$editingStyleCardBlockNode;
    return $e676ff892da56a0a$var$editingStyleNode;
};
module.exports["editingStyle"] = $e676ff892da56a0a$export$8382eabaf43593de;
module.exports["editingStyleActive"] = $e676ff892da56a0a$export$97e4289fb0e21ca7;
module.exports["deletedContentStyle"] = $e676ff892da56a0a$export$f65e7b80cdbdaf11;
module.exports["deletedContentStyleActive"] = $e676ff892da56a0a$export$1c9944aa8f37265b;
module.exports["deletedContentStyleNew"] = $e676ff892da56a0a$export$da356444d868ff8e;
module.exports["deletedContentStyleNewActive"] = $e676ff892da56a0a$export$cb9ee613be1d30ce;
module.exports["deletedContentStyleUnbounded"] = $e676ff892da56a0a$export$f9aac5ed53f3d424;
module.exports["getStandardNodeStyle"] = $e676ff892da56a0a$export$302a34abd475e253;

});

parcelRegister("dI1fe", function(module, exports) {

var $24P9d = parcelRequire("24P9d");

const $5db301645b17d8de$export$5f26b1217ef25d6b = (0, $24P9d.convertToInlineCss)({
    background: "var(--ds-background-accent-green-subtlest, #DCFFF1)",
    textDecoration: 'underline',
    textDecorationStyle: 'solid',
    textDecorationThickness: "var(--ds-space-025, 2px)",
    textDecorationColor: "var(--ds-border-accent-green, #22A06B)"
});
const $5db301645b17d8de$export$a9b71bdebdda9dc4 = (0, $24P9d.convertToInlineCss)({
    background: "var(--ds-background-accent-green-subtler, #BAF3DB)",
    textDecoration: 'underline',
    textDecorationStyle: 'solid',
    textDecorationThickness: "var(--ds-space-025, 2px)",
    textDecorationColor: "var(--ds-text-accent-green, #216E4E)"
});
const $5db301645b17d8de$export$24f11b9f611e0821 = (0, $24P9d.convertToInlineCss)({
    textDecorationColor: "var(--ds-border-accent-red, #E2483D)",
    textDecoration: 'line-through',
    position: 'relative',
    opacity: 1
});
const $5db301645b17d8de$export$d7c13cc5c70ee199 = (0, $24P9d.convertToInlineCss)({
    position: 'absolute',
    top: '50%',
    width: '100%',
    display: 'inline-block',
    borderTop: `1px solid ${"var(--ds-border-accent-red, #E2483D)"}`,
    pointerEvents: 'none',
    zIndex: 1
});
const $5db301645b17d8de$var$traditionalStyleQuoteNode = (0, $24P9d.convertToInlineCss)({
    borderLeft: `2px solid ${"var(--ds-border-accent-green, #22A06B)"}`
});
const $5db301645b17d8de$var$traditionalStyleRuleNode = (0, $24P9d.convertToInlineCss)({
    backgroundColor: "var(--ds-border-accent-green, #22A06B)"
});
const $5db301645b17d8de$var$traditionalStyleNode = (0, $24P9d.convertToInlineCss)({
    boxShadow: `0 0 0 1px ${"var(--ds-border-accent-green, #22A06B)"}`,
    borderRadius: "var(--ds-radius-small, 4px)"
});
const $5db301645b17d8de$var$traditionalStyleCardBlockNode = (0, $24P9d.convertToInlineCss)({
    boxShadow: `0 0 0 1px ${"var(--ds-border-accent-green, #22A06B)"}`,
    borderRadius: "var(--ds-radius-medium, 6px)"
});
const $5db301645b17d8de$var$traditionalDecorationMarkerVariable = (0, $24P9d.convertToInlineCss)({
    '--diff-decoration-marker-color': "var(--ds-border-accent-green, #22A06B)"
});
const $5db301645b17d8de$export$6b74dc21c501ec2c = (nodeName)=>{
    if ([
        'mediaSingle',
        'mediaGroup',
        'table',
        // Handle table separately to avoid border issues
        'tableRow',
        'tableCell',
        'tableHeader',
        'paragraph',
        // Paragraph and heading nodes do not need special styling
        'heading',
        'hardBreak',
        'decisionList',
        'taskList',
        'taskItem',
        'bulletList',
        'orderedList',
        'layoutSection'
    ].includes(nodeName)) // Layout nodes do not need special styling
    return undefined;
    if ([
        'extension',
        'embedCard',
        'listItem'
    ].includes(nodeName)) return $5db301645b17d8de$var$traditionalDecorationMarkerVariable;
    if (nodeName === 'blockquote') return $5db301645b17d8de$var$traditionalStyleQuoteNode;
    if (nodeName === 'rule') return $5db301645b17d8de$var$traditionalStyleRuleNode;
    if (nodeName === 'blockCard') return $5db301645b17d8de$var$traditionalStyleCardBlockNode;
    return $5db301645b17d8de$var$traditionalStyleNode;
};
module.exports["traditionalInsertStyle"] = $5db301645b17d8de$export$5f26b1217ef25d6b;
module.exports["traditionalInsertStyleActive"] = $5db301645b17d8de$export$a9b71bdebdda9dc4;
module.exports["deletedTraditionalContentStyle"] = $5db301645b17d8de$export$24f11b9f611e0821;
module.exports["deletedTraditionalContentStyleUnbounded"] = $5db301645b17d8de$export$d7c13cc5c70ee199;
module.exports["getTraditionalNodeStyle"] = $5db301645b17d8de$export$6b74dc21c501ec2c;

});

parcelRegister("8fkLz", function(module, exports) {

var $24P9d = parcelRequire("24P9d");


var $808tb = parcelRequire("808tb");


var $dh538 = parcelRequire("dh538");


var $4eIWc = parcelRequire("4eIWc");

const $56ac3b5fb8d3a4d7$export$4be2f4158e5479e9 = (0, $24P9d.convertToInlineCss)({
    borderLeft: `2px solid ${"var(--ds-border-accent-gray, #7D818A)"}`
});
const $56ac3b5fb8d3a4d7$export$a26de8170ba89016 = (0, $24P9d.convertToInlineCss)({
    marginTop: "var(--ds-space-150, 12px)",
    paddingTop: "var(--ds-space-025, 2px)",
    paddingBottom: "var(--ds-space-025, 2px)",
    paddingLeft: "var(--ds-space-025, 2px)",
    boxShadow: `0 0 0 1px ${"var(--ds-border-accent-gray, #7D818A)"}`,
    borderRadius: "var(--ds-radius-small, 4px)"
});
const $56ac3b5fb8d3a4d7$export$781ad9e3e3929b91 = (0, $24P9d.convertToInlineCss)({
    marginTop: "var(--ds-space-150, 12px)",
    paddingTop: "var(--ds-space-025, 2px)",
    paddingBottom: "var(--ds-space-025, 2px)",
    paddingLeft: "var(--ds-space-025, 2px)",
    boxShadow: `0 0 0 1px ${"var(--ds-border-accent-red, #E2483D)"}`,
    borderRadius: "var(--ds-radius-small, 4px)"
});
const $56ac3b5fb8d3a4d7$export$2b892754935ecdf0 = (0, $24P9d.convertToInlineCss)({
    boxShadow: `0 0 0 1px ${"var(--ds-border-accent-gray, #7D818A)"}`,
    borderRadius: "var(--ds-radius-small, 4px)"
});
const $56ac3b5fb8d3a4d7$export$2881f0731c48e52 = (0, $24P9d.convertToInlineCss)({
    boxShadow: `0 0 0 1px ${"var(--ds-border-accent-red, #E2483D)"}`,
    borderRadius: "var(--ds-radius-small, 4px)"
});
const $56ac3b5fb8d3a4d7$export$95d973a7458c1194 = (0, $24P9d.convertToInlineCss)({
    boxShadow: `0 0 0 1px ${"var(--ds-border-accent-gray, #7D818A)"}`,
    borderRadius: `calc(${"var(--ds-radius-xsmall, 2px)"} + 1px)`
});
const $56ac3b5fb8d3a4d7$export$4d45bc5137e495cf = (0, $24P9d.convertToInlineCss)({
    boxShadow: `0 0 0 1px ${"var(--ds-border-accent-red, #E2483D)"}`,
    borderRadius: `calc(${"var(--ds-radius-xsmall, 2px)"} + 1px)`
});
const $56ac3b5fb8d3a4d7$var$lozengeStyle = (0, $24P9d.convertToInlineCss)({
    display: 'inline-flex',
    boxSizing: 'border-box',
    position: 'static',
    blockSize: 'min-content',
    borderRadius: "var(--ds-radius-small, 4px)",
    overflow: 'hidden',
    paddingInlineStart: "var(--ds-space-050, 4px)",
    paddingInlineEnd: "var(--ds-space-050, 4px)",
    backgroundColor: "var(--ds-background-accent-gray-subtler, #DDDEE1)",
    font: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-bold, 653)",
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    color: "var(--ds-text-warning-inverse, #292A2E)"
});
const $56ac3b5fb8d3a4d7$export$d22dbdfe71f2ad25 = (nodeName, colorScheme)=>{
    const isTraditional = colorScheme === 'traditional';
    switch(nodeName){
        case 'blockquote':
            return (0, $dh538.fg)('platform_editor_ai_aifc_patch_ga_blockers') ? isTraditional ? $56ac3b5fb8d3a4d7$export$781ad9e3e3929b91 : $56ac3b5fb8d3a4d7$export$a26de8170ba89016 : $56ac3b5fb8d3a4d7$export$4be2f4158e5479e9;
        case 'expand':
        case 'decisionList':
            return isTraditional && (0, $dh538.fg)('platform_editor_ai_aifc_patch_ga_blockers') ? $56ac3b5fb8d3a4d7$export$2881f0731c48e52 : $56ac3b5fb8d3a4d7$export$2b892754935ecdf0;
        case 'panel':
        case 'codeBlock':
            return isTraditional && (0, $dh538.fg)('platform_editor_ai_aifc_patch_ga_blockers') ? $56ac3b5fb8d3a4d7$export$4d45bc5137e495cf : $56ac3b5fb8d3a4d7$export$95d973a7458c1194;
        default:
            return undefined;
    }
};
const $56ac3b5fb8d3a4d7$export$70c259518319d790 = (nodeName)=>{
    switch(nodeName){
        case 'expand':
        case 'codeBlock':
        case 'mediaSingle':
        case 'panel':
        case 'decisionList':
            return true;
        case 'embedCard':
        case 'blockquote':
            return (0, $dh538.fg)('platform_editor_ai_aifc_patch_ga_blockers');
        default:
            return false;
    }
};
const $56ac3b5fb8d3a4d7$export$27f77745f9d2a9d3 = (nodeName)=>{
    switch(nodeName){
        case 'mediaSingle':
        case 'embedCard':
            return true;
        case 'blockquote':
            return (0, $dh538.fg)('platform_editor_ai_aifc_patch_ga_blockers');
        default:
            return false;
    }
};
const $56ac3b5fb8d3a4d7$export$ed15446970dd2546 = (nodeName)=>{
    return nodeName === 'heading' || nodeName === 'blockquote' && !(0, $dh538.fg)('platform_editor_ai_aifc_patch_ga_blockers');
};
const $56ac3b5fb8d3a4d7$export$7e94a71f2afbef46 = (intl, nodeName)=>{
    const container = document.createElement('span');
    let borderTopRightRadius;
    if ([
        'expand',
        'decisionList'
    ].includes(nodeName || '')) borderTopRightRadius = "var(--ds-radius-small, 4px)";
    else if ([
        'panel',
        'codeBlock',
        'mediaSingle'
    ].includes(nodeName || '')) borderTopRightRadius = `calc(${"var(--ds-radius-xsmall, 2px)"} + 1px)`;
    const containerStyle = (0, $24P9d.convertToInlineCss)({
        position: 'absolute',
        top: (0, $dh538.fg)('platform_editor_ai_aifc_patch_ga_blockers') ? "var(--ds-space-075, 6px)" : "var(--ds-space-0, 0px)",
        right: (0, $dh538.fg)('platform_editor_ai_aifc_patch_ga_blockers') ? "var(--ds-space-075, 6px)" : "var(--ds-space-0, 0px)",
        zIndex: 2,
        pointerEvents: 'none',
        display: 'flex',
        ...!(0, $dh538.fg)('platform_editor_ai_aifc_patch_ga_blockers') ? {
            overflow: 'hidden',
            borderTopRightRadius: borderTopRightRadius
        } : {}
    });
    container.setAttribute('style', containerStyle);
    container.setAttribute('data-testid', 'show-diff-removed-lozenge');
    // Create vanilla HTML lozenge element with Atlaskit Lozenge styling (visual refresh)
    const lozengeElement = document.createElement('span');
    lozengeElement.setAttribute('style', $56ac3b5fb8d3a4d7$var$lozengeStyle);
    lozengeElement.textContent = intl.formatMessage((0, $808tb.trackChangesMessages).removed).toUpperCase();
    container.appendChild(lozengeElement);
    return container;
};
const $56ac3b5fb8d3a4d7$export$5b1e956de560c1c8 = ()=>{
    const wrapper = document.createElement('div');
    const baseStyle = (0, $24P9d.convertToInlineCss)({
        position: 'relative',
        display: 'block',
        opacity: 1
    });
    wrapper.setAttribute('style', baseStyle);
    return wrapper;
};
const $56ac3b5fb8d3a4d7$export$f4f691d3bcec255 = (colorScheme, isActive)=>{
    const wrapper = document.createElement('span');
    wrapper.setAttribute('style', (0, $4eIWc.getDeletedContentStyle)(colorScheme, isActive));
    return wrapper;
};
const $56ac3b5fb8d3a4d7$export$98e90fe61e416ef5 = (element, targetNode, colorScheme)=>{
    const currentStyle = element.getAttribute('style') || '';
    const deletedContentStyle = (0, $4eIWc.getDeletedContentStyle)(colorScheme);
    const nodeSpecificStyle = $56ac3b5fb8d3a4d7$export$d22dbdfe71f2ad25(targetNode.type.name, colorScheme) || '';
    element.setAttribute('style', `${currentStyle}${deletedContentStyle}${nodeSpecificStyle}`);
};
const $56ac3b5fb8d3a4d7$export$a9f129b53cfeba21 = (nodeView, targetNode, colorScheme)=>{
    const contentWrapper = document.createElement('div');
    const nodeStyle = $56ac3b5fb8d3a4d7$export$d22dbdfe71f2ad25(targetNode.type.name, colorScheme);
    contentWrapper.setAttribute('style', `${(0, $4eIWc.getDeletedContentStyle)(colorScheme)}${nodeStyle || ''}`);
    contentWrapper.append(nodeView);
    return contentWrapper;
};
const $56ac3b5fb8d3a4d7$export$1de4fbcdb1cd74f8 = (dom, nodeView, targetNode, lozenge, colorScheme)=>{
    if (targetNode.type.name !== 'embedCard' || !(nodeView instanceof HTMLElement)) return false;
    const richMediaItem = nodeView.querySelector('.rich-media-item');
    if (richMediaItem instanceof HTMLElement) richMediaItem.appendChild(lozenge);
    else {
        const observer = new MutationObserver((_, obs)=>{
            const loadedRichMedia = nodeView.querySelector('.rich-media-item');
            if (loadedRichMedia instanceof HTMLElement) {
                loadedRichMedia.appendChild(lozenge);
                obs.disconnect();
            }
        });
        observer.observe(nodeView, {
            childList: true,
            subtree: true
        });
    }
    if ($56ac3b5fb8d3a4d7$export$27f77745f9d2a9d3(targetNode.type.name)) {
        const showDiffDeletedNodeClass = colorScheme === 'traditional' ? 'show-diff-deleted-node-traditional' : 'show-diff-deleted-node';
        nodeView.classList.add(showDiffDeletedNodeClass);
    }
    dom.append(nodeView);
    return true;
};
const $56ac3b5fb8d3a4d7$export$29cfe496bdd27d2a = (dom, nodeView, targetNode, lozenge, colorScheme)=>{
    if (targetNode.type.name !== 'mediaSingle' || !(nodeView instanceof HTMLElement)) return false;
    const mediaNode = nodeView.querySelector('[data-prosemirror-node-name="media"]');
    if (!mediaNode || !(mediaNode instanceof HTMLElement)) return false;
    // Add relative positioning to media node to anchor lozenge
    const currentStyle = mediaNode.getAttribute('style') || '';
    const relativePositionStyle = (0, $24P9d.convertToInlineCss)({
        position: 'relative'
    });
    mediaNode.setAttribute('style', `${currentStyle}${relativePositionStyle}`);
    mediaNode.append(lozenge);
    // Add deleted node class if needed
    if ($56ac3b5fb8d3a4d7$export$27f77745f9d2a9d3(targetNode.type.name)) {
        const showDiffDeletedNodeClass = colorScheme === 'traditional' && (0, $dh538.fg)('platform_editor_ai_aifc_patch_ga_blockers') ? 'show-diff-deleted-node-traditional' : 'show-diff-deleted-node';
        nodeView.classList.add(showDiffDeletedNodeClass);
    }
    dom.append(nodeView);
    return true;
};
const $56ac3b5fb8d3a4d7$export$a6d5dd7a5e2cb70d = (dom, nodeView, targetNode, colorScheme, intl)=>{
    const blockWrapper = $56ac3b5fb8d3a4d7$export$5b1e956de560c1c8();
    if ($56ac3b5fb8d3a4d7$export$70c259518319d790(targetNode.type.name)) {
        const lozenge = $56ac3b5fb8d3a4d7$export$7e94a71f2afbef46(intl);
        if ($56ac3b5fb8d3a4d7$export$1de4fbcdb1cd74f8(dom, nodeView, targetNode, lozenge, colorScheme) && (0, $dh538.fg)('platform_editor_ai_aifc_patch_ga_blockers')) return;
        if ($56ac3b5fb8d3a4d7$export$29cfe496bdd27d2a(dom, nodeView, targetNode, lozenge, colorScheme)) return;
        blockWrapper.append(lozenge);
    }
    const contentWrapper = $56ac3b5fb8d3a4d7$export$a9f129b53cfeba21(nodeView, targetNode, colorScheme);
    blockWrapper.append(contentWrapper);
    if (nodeView instanceof HTMLElement && $56ac3b5fb8d3a4d7$export$27f77745f9d2a9d3(targetNode.type.name)) {
        const showDiffDeletedNodeClass = colorScheme === 'traditional' && (0, $dh538.fg)('platform_editor_ai_aifc_patch_ga_blockers') ? 'show-diff-deleted-node-traditional' : 'show-diff-deleted-node';
        nodeView.classList.add(showDiffDeletedNodeClass);
    }
    dom.append(blockWrapper);
};
const $56ac3b5fb8d3a4d7$export$f5e827fa766eb13e = (dom, nodeView, targetNode, colorScheme, intl)=>{
    if ($56ac3b5fb8d3a4d7$export$ed15446970dd2546(targetNode.type.name) && nodeView instanceof HTMLElement) {
        // Apply deleted styles directly to preserve natural block-level margins
        $56ac3b5fb8d3a4d7$export$98e90fe61e416ef5(nodeView, targetNode, colorScheme);
        dom.append(nodeView);
    } else // Use wrapper approach for other block nodes
    $56ac3b5fb8d3a4d7$export$a6d5dd7a5e2cb70d(dom, nodeView, targetNode, colorScheme, intl);
};
module.exports["createDeletedStyleWrapperWithoutOpacity"] = $56ac3b5fb8d3a4d7$export$f4f691d3bcec255;
module.exports["handleBlockNodeView"] = $56ac3b5fb8d3a4d7$export$f5e827fa766eb13e;

});

parcelRegister("3Syf5", function(module, exports) {

var $24P9d = parcelRequire("24P9d");


var $2pjJ5 = parcelRequire("2pjJ5");


var $8m4tT = parcelRequire("8m4tT");


var $ftzrq = parcelRequire("ftzrq");


var $LmqWp = parcelRequire("LmqWp");


var $9LSAA = parcelRequire("9LSAA");

const $a1720879622e745c$var$deletedRowStyle = (0, $24P9d.convertToInlineCss)({
    color: "var(--ds-text-accent-gray, #505258)",
    textDecoration: 'line-through',
    opacity: 0.6,
    display: 'table-row'
});
const $a1720879622e745c$var$deletedTraditionalRowStyle = (0, $24P9d.convertToInlineCss)({
    textDecorationColor: "var(--ds-border-accent-red, #E2483D)",
    textDecoration: 'line-through',
    opacity: 0.6,
    display: 'table-row'
});
/**
 * Extracts information about deleted table rows from a change
 */ const $a1720879622e745c$var$extractDeletedRows = (change, originalDoc, newDoc)=>{
    const deletedRows = [];
    // Find the table in the original document
    const $fromPos = originalDoc.resolve(change.fromA);
    const tableOld = (0, $8m4tT.findParentNodeClosestToPos)($fromPos, (node)=>node.type.name === 'table');
    if (!tableOld) return deletedRows;
    const oldTableMap = (0, $LmqWp.TableMap).get(tableOld.node);
    // Find the table in the new document at the insertion point
    const $newPos = newDoc.resolve(change.fromB);
    const tableNew = (0, $8m4tT.findParentNodeClosestToPos)($newPos, (node)=>node.type.name === 'table');
    if (!tableNew) return deletedRows;
    const newTableMap = (0, $LmqWp.TableMap).get(tableNew.node);
    // If no rows were deleted, return empty
    if (oldTableMap.height <= newTableMap.height || // For now ignore if there are column deletions as well
    oldTableMap.width !== newTableMap.width) return deletedRows;
    // Find which rows were deleted by analyzing the change range
    const changeStartInTable = change.fromA - tableOld.pos - 1;
    const changeEndInTable = change.toA - tableOld.pos - 1;
    let currentOffset = 0;
    let rowIndex = 0;
    tableOld.node.content.forEach((rowNode)=>{
        const rowStart = currentOffset;
        const rowEnd = currentOffset + rowNode.nodeSize;
        // Check if this row overlaps with the deletion range
        const rowOverlapsChange = rowStart >= changeStartInTable && rowStart < changeEndInTable || rowEnd > changeStartInTable && rowEnd <= changeEndInTable || rowStart < changeStartInTable && rowEnd > changeEndInTable;
        if (rowOverlapsChange && rowNode.type.name === 'tableRow' && !$a1720879622e745c$var$isEmptyRow(rowNode)) {
            const startOfRow = newTableMap.mapByRow.slice().reverse().find((row)=>row[0] + tableNew.pos < change.fromB && change.fromB < row[row.length - 1] + tableNew.pos);
            deletedRows.push({
                rowIndex: rowIndex,
                rowNode: rowNode,
                fromA: tableOld.pos + 1 + rowStart,
                toA: tableOld.pos + 1 + rowEnd,
                fromB: startOfRow ? startOfRow[0] + tableNew.start : change.fromB
            });
        }
        currentOffset += rowNode.nodeSize;
        if (rowNode.type.name === 'tableRow') rowIndex++;
    });
    // Filter changes that never truly got deleted
    return deletedRows.filter((deletedRow)=>{
        return !tableNew.node.children.some((newRow)=>(0, $2pjJ5.areNodesEqualIgnoreAttrs)(newRow, deletedRow.rowNode));
    });
};
/**
 * Checks if a table row is empty (contains no meaningful content)
 */ const $a1720879622e745c$var$isEmptyRow = (rowNode)=>{
    let isEmpty = true;
    rowNode.descendants((node)=>{
        if (!isEmpty) return false;
        // If we find any inline content with size > 0, the row is not empty
        if (node.isInline && node.nodeSize > 0) {
            isEmpty = false;
            return false;
        }
        // If we find text content, the row is not empty
        if (node.isText && node.text && node.text.trim() !== '') {
            isEmpty = false;
            return false;
        }
        return true;
    });
    return isEmpty;
};
/**
 * Creates a DOM representation of a deleted table row
 */ const $a1720879622e745c$var$createDeletedRowDOM = (rowNode, nodeViewSerializer, colorScheme)=>{
    const tr = document.createElement('tr');
    tr.setAttribute('style', colorScheme === 'traditional' ? $a1720879622e745c$var$deletedTraditionalRowStyle : $a1720879622e745c$var$deletedRowStyle);
    tr.setAttribute('data-testid', 'show-diff-deleted-row');
    // Serialize each cell in the row
    rowNode.content.forEach((cellNode)=>{
        if (cellNode.type.name === 'tableCell' || cellNode.type.name === 'tableHeader') {
            const nodeView = nodeViewSerializer.tryCreateNodeView(cellNode);
            if (nodeView) tr.appendChild(nodeView);
            else {
                // Fallback to fragment serialization
                const serializedContent = nodeViewSerializer.serializeFragment(cellNode.content);
                if (serializedContent) tr.appendChild(serializedContent);
            }
        }
    });
    return tr;
};
/**
 * Expands a diff to include whole deleted rows when table rows are affected
 */ const $a1720879622e745c$var$expandDiffForDeletedRows = (changes, originalDoc, newDoc)=>{
    const deletedRowInfo = [];
    for (const change of changes){
        // Check if this change affects table content
        const deletedRows = $a1720879622e745c$var$extractDeletedRows(change, originalDoc, newDoc);
        if (deletedRows.length > 0) deletedRowInfo.push(...deletedRows);
    }
    return deletedRowInfo;
};
const $a1720879622e745c$export$ad8852400818e745 = ({ deletedRows: deletedRows, originalDoc: originalDoc, newDoc: newDoc, nodeViewSerializer: nodeViewSerializer, colorScheme: colorScheme })=>{
    return deletedRows.map((deletedRow)=>{
        const rowDOM = $a1720879622e745c$var$createDeletedRowDOM(deletedRow.rowNode, nodeViewSerializer, colorScheme);
        // Find safe insertion position for the deleted row
        const safeInsertPos = (0, $9LSAA.findSafeInsertPos)(newDoc, deletedRow.fromB - 1, // -1 to find the first safe position from the table
        originalDoc.slice(deletedRow.fromA, deletedRow.toA));
        return (0, $ftzrq.Decoration).widget(safeInsertPos, rowDOM, {});
    });
};
const $a1720879622e745c$export$50cf234bf9fce100 = (changes, originalDoc, newDoc, nodeViewSerializer, colorScheme)=>{
    // First, expand the changes to include complete deleted rows
    const deletedRows = $a1720879622e745c$var$expandDiffForDeletedRows(changes.filter((change)=>change.deleted.length > 0), originalDoc, newDoc);
    const allDecorations = $a1720879622e745c$export$ad8852400818e745({
        deletedRows: deletedRows,
        originalDoc: originalDoc,
        newDoc: newDoc,
        nodeViewSerializer: nodeViewSerializer,
        colorScheme: colorScheme
    });
    return {
        decorations: allDecorations
    };
};
module.exports["handleDeletedRows"] = $a1720879622e745c$export$50cf234bf9fce100;

});

parcelRegister("9LSAA", function(module, exports) {

var $8m4tT = parcelRequire("8m4tT");

function $3ac82b36c61b257d$export$c531c54bff461ffa(doc, pos, slice) {
    if (pos > doc.content.size) return doc.content.size;
    let $pos = doc.resolve(pos);
    while(!(0, $8m4tT.canInsert)($pos, slice.content) && slice.content.firstChild?.type.name !== 'paragraph'){
        if ($pos.pos + 1 > doc.content.size) break;
        $pos = doc.resolve($pos.pos + 1);
    }
    return $pos.pos;
}
module.exports["findSafeInsertPos"] = $3ac82b36c61b257d$export$c531c54bff461ffa;

});

parcelRegister("8R7BX", function(module, exports) {

var $aXG5V = parcelRequire("aXG5V");


var $1oCLl = parcelRequire("1oCLl");

const $17b314da77ea36bc$var$filterUndefined = (x)=>!!x;
const $17b314da77ea36bc$var$extractMarkStep = (step)=>{
    if (step instanceof (0, $aXG5V.AddMarkStep)) return {
        type: 'add',
        from: step.from,
        to: step.to,
        markName: step.mark.type.name
    };
    if (step instanceof (0, $aXG5V.RemoveMarkStep)) return {
        type: 'remove',
        from: step.from,
        to: step.to,
        markName: step.mark.type.name
    };
    return undefined;
};
const $17b314da77ea36bc$export$cb37e032b0f65b99 = (steps)=>{
    if (!(0, $1oCLl.expValEquals)('platform_editor_deduplicate_mark_diff', 'isEnabled', true)) return steps.map((step)=>{
        if (step instanceof (0, $aXG5V.AddMarkStep) || step instanceof (0, $aXG5V.RemoveMarkStep)) return {
            fromB: step.from,
            toB: step.to
        };
        return undefined;
    }).filter($17b314da77ea36bc$var$filterUndefined);
    const resultRanges = [];
    let lastOp;
    for (const step of steps){
        const op = $17b314da77ea36bc$var$extractMarkStep(step);
        if (!op) continue;
        // Check if previous operation cancels this one
        if (lastOp && lastOp.from === op.from && lastOp.to === op.to && lastOp.markName === op.markName && lastOp.type !== op.type) resultRanges.pop();
        else resultRanges.push({
            fromB: op.from,
            toB: op.to
        });
        lastOp = op;
    }
    return resultRanges;
};
module.exports["getMarkChangeRanges"] = $17b314da77ea36bc$export$cb37e032b0f65b99;

});

parcelRegister("kOdMm", function(module, exports) {

var $jy7VG = parcelRequire("jy7VG");


var $2pjJ5 = parcelRequire("2pjJ5");


var $aXG5V = parcelRequire("aXG5V");


var $dh538 = parcelRequire("dh538");

/**
 * Attempts to merge two consecutive ReplaceStep operations.
 * This merges steps where:
 * - Both steps replace content at the same starting position
 * - The second step's range encompasses the first step's range
 * - The second step has content to insert
 * Returns null if steps cannot be merged.
 */ function $77c34b4e3d11b0db$var$mergeReplaceSteps(step1, step2) {
    if (!(step1 instanceof (0, $aXG5V.ReplaceStep)) || !(step2 instanceof (0, $aXG5V.ReplaceStep))) return null;
    // Confirm the step overlaps exactly with the previous
    const step2Length = step2.to - step2.from;
    if (step1.from === step2.from && step2.to >= step1.to && step2.slice.size >= step2Length && step2Length === step1.slice.size && step2.slice.size >= step1.slice.size && step1.slice.openEnd === step2.slice.openEnd && step1.slice.openStart === step2.slice.openStart) return new (0, $aXG5V.ReplaceStep)(step1.from, step1.to, step2.slice);
    return null;
}
function $77c34b4e3d11b0db$export$320ba57788df881b(steps, originalDoc) {
    const stepsToFilter = (0, $dh538.fg)('platform_editor_ai_aifc_patch_ga') ? $77c34b4e3d11b0db$var$removeUnusedSteps(steps, originalDoc) : steps;
    return stepsToFilter// Remove steps that don't affect document structure or content
    .filter((step)=>!(step instanceof (0, $jy7VG.AnalyticsStep)))// Merge consecutive steps where possible
    .reduce((acc, step)=>{
        const lastStep = acc[acc.length - 1];
        const merged = (0, $dh538.fg)('platform_editor_ai_aifc_patch_ga') ? lastStep?.merge?.(step) ?? $77c34b4e3d11b0db$var$mergeReplaceSteps(lastStep, step) : lastStep?.merge?.(step);
        if (merged) acc[acc.length - 1] = merged;
        else acc.push(step);
        return acc;
    }, []);
}
/**
 * Does a first pass to remove steps that don't impact the document
 */ function $77c34b4e3d11b0db$var$removeUnusedSteps(steps, originalDoc) {
    const finalSteps = [];
    let firstPassDoc = originalDoc;
    for (const step of steps){
        const result = step.apply(firstPassDoc);
        if (result.failed === null && result.doc && !(0, $2pjJ5.areNodesEqualIgnoreAttrs)(firstPassDoc, result.doc, [
            'localId'
        ])) {
            finalSteps.push(step);
            firstPassDoc = result.doc;
        }
    }
    return finalSteps;
}
module.exports["simplifySteps"] = $77c34b4e3d11b0db$export$320ba57788df881b;

});

parcelRegister("8IH6e", function(module, exports) {

var $5SAOw = parcelRequire("5SAOw");

function $e9d15807b524bec2$export$42cf4389dbe8b0ff(view) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return view.nodeViews !== undefined;
}
class $e9d15807b524bec2$export$314a8d5cfa8a18e6 {
    /**
   * Initializes or reinitializes the NodeViewSerializer with a new EditorView.
   * This allows the same serializer instance to be reused across different editor states.
   */ init(params) {
        this.serializer = (0, $5SAOw.DOMSerializer).fromSchema(params.editorView.state.schema);
        if ($e9d15807b524bec2$export$42cf4389dbe8b0ff(params.editorView)) this.editorView = params.editorView;
        const nodeViews = // eslint-disable-next-line @typescript-eslint/no-explicit-any
        params.editorView?.nodeViews || {};
        this.nodeViews = nodeViews ?? this.editorView?.nodeViews ?? {};
    }
    /**
   * Appends serialized child nodes to the given contentDOM element.
   */ appendChildNodes(children, contentDOM) {
        children.forEach((child)=>{
            const childNode = this.tryCreateNodeView(child) || this.serializeNode(child);
            if (childNode) contentDOM?.append(childNode);
        });
    }
    /**
   * Attempts to create a node view for the given node.
   *
   * Returns `null` when there is no `EditorView`, no constructor for the node type,
   * or the node type is blocklisted. Otherwise returns the constructed node view instance.
   */ tryCreateNodeView(targetNode) {
        if (!this.editorView) return null;
        const constructor = this.nodeViews?.[targetNode.type.name];
        if (this.nodeViewBlocklist.has(targetNode.type.name)) return null;
        try {
            if (!constructor) {
                if (targetNode.isInline) return null;
                const toDOMResult = targetNode.type.spec.toDOM?.(targetNode);
                if (!toDOMResult) return null;
                const { dom: dom, contentDOM: contentDOM } = (0, $5SAOw.DOMSerializer).renderSpec(document, toDOMResult);
                if (dom instanceof HTMLElement) {
                    if (targetNode.type.name === 'paragraph' && targetNode.children.length === 1) return this.serializeFragment(targetNode.content);
                    // Iteratively populate children
                    this.appendChildNodes(targetNode.children, contentDOM);
                }
                return dom;
            }
            const { dom: dom, contentDOM: contentDOM } = constructor(targetNode, this.editorView, ()=>0, [], {});
            // Iteratively populate children
            this.appendChildNodes(targetNode.children, contentDOM);
            return dom;
        } catch (e) {
            return null;
        }
    }
    /**
   * Serializes a node to a DOM `Node` using the schema's `DOMSerializer`.
   */ serializeNode(node) {
        if (!this.serializer) throw new Error('NodeViewSerializer must be initialized with init() before use');
        try {
            return this.serializer.serializeNode(node);
        } catch (e) {
            return null;
        }
    }
    /**
   * Serializes a fragment to a `DocumentFragment` using the schema's `DOMSerializer`.
   */ serializeFragment(fragment) {
        if (!this.serializer) throw new Error('NodeViewSerializer must be initialized with init() before use');
        try {
            return this.serializer.serializeFragment(fragment);
        } catch (e) {
            return null;
        }
    }
    /**
   * Returns a copy of the current node view blocklist.
   */ getNodeViewBlocklist() {
        return new Set(this.nodeViewBlocklist);
    }
    /**
   * Returns a filtered copy of the node view blocklist, excluding specified node types.
   * @param excludeTypes - Array of node type names to exclude from the blocklist
   */ getFilteredNodeViewBlocklist(excludeTypes) {
        const filtered = new Set(this.nodeViewBlocklist);
        excludeTypes.forEach((type)=>filtered.delete(type));
        return filtered;
    }
    constructor(params){
        this.editorView = void 0;
        this.serializer = void 0;
        this.nodeViews = void 0;
        this.nodeViewBlocklist = void 0;
        if (params?.editorView) this.init({
            editorView: params.editorView
        });
        this.nodeViewBlocklist = new Set(params.blocklist ?? [
            'paragraph'
        ]);
    }
}
module.exports["NodeViewSerializer"] = $e9d15807b524bec2$export$314a8d5cfa8a18e6;

});

parcelRegister("aB4bz", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $d6D0N = parcelRequire("d6D0N");


var $cukKH = parcelRequire("cukKH");


var $gmn4v = parcelRequire("gmn4v");


var $kpe3L = parcelRequire("kpe3L");


var $ifwgm = parcelRequire("ifwgm");

const $594c0761b769300b$export$1ce21d3d70c60c32 = ({ api: api, config: options })=>{
    const isToolbarAIFCEnabled = Boolean(api?.toolbar);
    const primaryToolbarComponent = ()=>{
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $ifwgm.TrackChangesToolbarButton), {
            api: api
        });
    };
    if (options?.showOnToolbar === true) {
        if (isToolbarAIFCEnabled) api?.toolbar?.actions.registerComponents((0, $kpe3L.getToolbarComponents)(api, options));
        else api?.primaryToolbar?.actions?.registerComponent({
            name: 'trackChanges',
            component: primaryToolbarComponent
        });
    }
    return {
        name: 'trackChanges',
        pmPlugins () {
            return [
                {
                    name: 'trackChangesKeyMap',
                    plugin: ()=>(0, $d6D0N.keymapPlugin)(api)
                },
                {
                    name: 'trackChangesPlugin',
                    plugin: ()=>(0, $cukKH.createTrackChangesPlugin)(api)
                }
            ];
        },
        commands: {
            toggleChanges: ({ tr: tr })=>{
                return tr.setMeta((0, $cukKH.trackChangesPluginKey), {
                    action: (0, $gmn4v.TOGGLE_TRACK_CHANGES_ACTION).TOGGLE_TRACK_CHANGES
                });
            },
            resetBaseline: ({ tr: tr })=>{
                if (!api?.trackChanges?.sharedState.currentState()?.isShowDiffAvailable) return null;
                return tr.setMeta((0, $cukKH.trackChangesPluginKey), {
                    action: (0, $gmn4v.TOGGLE_TRACK_CHANGES_ACTION).RESET_BASELINE
                });
            }
        },
        getSharedState: (editorState)=>{
            if (!editorState) return {
                isDisplayingChanges: false,
                isShowDiffAvailable: false
            };
            return {
                isDisplayingChanges: Boolean((0, $cukKH.trackChangesPluginKey).getState(editorState)?.shouldChangesBeDisplayed),
                isShowDiffAvailable: Boolean((0, $cukKH.trackChangesPluginKey).getState(editorState)?.isShowDiffAvailable)
            };
        }
    };
};
module.exports["trackChangesPlugin"] = $594c0761b769300b$export$1ce21d3d70c60c32;

});

parcelRegister("d6D0N", function(module, exports) {

var $d7ZU3 = parcelRequire("d7ZU3");


var $hgeg8 = parcelRequire("hgeg8");


var $1S4f7 = parcelRequire("1S4f7");


var $dus6D = parcelRequire("dus6D");


var $dh538 = parcelRequire("dh538");

function $4f7135484255b265$export$e832373cff8dec22(api) {
    const list = {};
    const browser = (0, $d7ZU3.getBrowserInfo)();
    // Exclude Firefox browser from keyboard shortcut
    if (!browser.gecko && (0, $dh538.fg)('platform_editor_ai_aifc_patch_ga_blockers')) (0, $hgeg8.bindKeymapWithCommand)(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.toggleViewChanges).common, ()=>{
        const isShowDiffAvailable = api?.trackChanges?.sharedState.currentState()?.isShowDiffAvailable;
        if (!isShowDiffAvailable) return false;
        const result = api?.core.actions.execute(api?.trackChanges?.commands.toggleChanges);
        return result ?? false;
    }, list);
    return new (0, $1S4f7.SafePlugin)({
        props: {
            handleKeyDown (view, event) {
                const keyboardEvent = (0, $hgeg8.isCapsLockOnAndModifyKeyboardEvent)(event);
                return (0, $dus6D.keydownHandler)(list)(view, keyboardEvent);
            }
        }
    });
}
module.exports["keymapPlugin"] = $4f7135484255b265$export$e832373cff8dec22;

});

parcelRegister("cukKH", function(module, exports) {

var $1S4f7 = parcelRequire("1S4f7");


var $ks2lK = parcelRequire("ks2lK");


var $aXG5V = parcelRequire("aXG5V");


var $jMTY6 = parcelRequire("jMTY6");


var $dR0MY = parcelRequire("dR0MY");


var $gmn4v = parcelRequire("gmn4v");

const $b4822fc2c345489d$export$7304ae0cfc08f061 = new (0, $ks2lK.PluginKey)('trackChangesPlugin');
const $b4822fc2c345489d$export$26b3581d344cfc94 = (doc, steps)=>{
    try {
        // Filter out AttrStep's since attribute changes shouldn't affect baseline content comparison
        const contentSteps = steps.filter((step)=>!(step.step instanceof (0, $aXG5V.AttrStep)));
        for (const step of contentSteps.slice().reverse()){
            const result = step.inverted.apply(doc);
            if (result.failed === null && result.doc) doc = result.doc;
        }
        return doc;
    } catch (e) {
        // Temporary - we need to understand how this happens - but we want to unblock issues where this crashes the editor
        return undefined;
    }
};
const $b4822fc2c345489d$export$67af324863e9eeaf = (api)=>{
    // Mark the state to be reset on next time the document has a meaningful change
    let resetBaseline = false;
    return new (0, $1S4f7.SafePlugin)({
        key: $b4822fc2c345489d$export$7304ae0cfc08f061,
        state: {
            init () {
                return {
                    steps: [],
                    shouldChangesBeDisplayed: false,
                    isShowDiffAvailable: false,
                    allocations: new Set()
                };
            },
            apply (tr, state) {
                const metadata = tr.getMeta($b4822fc2c345489d$export$7304ae0cfc08f061);
                if (metadata && metadata.action === (0, $gmn4v.TOGGLE_TRACK_CHANGES_ACTION).RESET_BASELINE) return {
                    ...state,
                    steps: [],
                    isShowDiffAvailable: false
                };
                if (metadata && metadata.action === (0, $gmn4v.TOGGLE_TRACK_CHANGES_ACTION).TOGGLE_TRACK_CHANGES) {
                    resetBaseline = true;
                    return {
                        ...state,
                        shouldChangesBeDisplayed: !state.shouldChangesBeDisplayed
                    };
                }
                const isDocChanged = tr.docChanged && tr.steps.some((step)=>step instanceof (0, $aXG5V.ReplaceStep) || step instanceof (0, $aXG5V.ReplaceAroundStep) || step instanceof (0, $aXG5V.AddMarkStep) || step instanceof (0, $aXG5V.RemoveMarkStep) || step instanceof (0, $aXG5V.AttrStep));
                const isAnnotationStep = (step)=>step instanceof (0, $aXG5V.AddMarkStep) && step.mark.type.name === 'annotation';
                if (!isDocChanged || tr.getMeta('isRemote') || tr.getMeta('replaceDocument') || tr.steps.some(isAnnotationStep)) // If the transaction is remote, we need to map the steps to the current document
                return {
                    ...state,
                    steps: state.steps.map((s)=>{
                        const newStep = s.step.map(tr.mapping);
                        const newInvertedStep = s.inverted.map(tr.mapping);
                        if (newStep && newInvertedStep) return new (0, $dR0MY.InvertableStep)(newStep, newInvertedStep, s.allocation);
                        return undefined;
                    }).filter((s)=>!!s)
                };
                // If we don't have the history plugin don't limit the change tracking
                const historyState = api?.history?.sharedState.currentState();
                const currentAllocation = historyState ? historyState.done.eventCount + historyState.undone.eventCount : (state.steps.at(-1)?.allocation ?? 0) + 1;
                const newSteps = tr.steps.map((step, idx)=>new (0, $dR0MY.InvertableStep)(step, step.invert(tr.docs[idx]), currentAllocation));
                const concatSteps = resetBaseline ? newSteps : [
                    ...state.steps,
                    ...newSteps
                ];
                resetBaseline = false;
                const { allocations: allocations, steps: steps } = (0, $jMTY6.filterSteps)(concatSteps, state.allocations.add(currentAllocation));
                // Calculate if there are actual changes by comparing current doc with baseline
                const baselineDoc = $b4822fc2c345489d$export$26b3581d344cfc94(tr.doc, steps);
                const hasChangesFromBaseline = baselineDoc ? !tr.doc.eq(baselineDoc) : false;
                // Create a new ChangeSet based on document changes
                return {
                    ...state,
                    allocations: allocations,
                    steps: steps,
                    shouldChangesBeDisplayed: false,
                    isShowDiffAvailable: hasChangesFromBaseline
                };
            }
        },
        view () {
            return {
                update (view, prevState) {
                    const prevShouldChangesBeDisplayed = $b4822fc2c345489d$export$7304ae0cfc08f061.getState(prevState)?.shouldChangesBeDisplayed;
                    const currentPluginState = $b4822fc2c345489d$export$7304ae0cfc08f061.getState(view.state);
                    const currentShouldChangesBeDisplayed = currentPluginState?.shouldChangesBeDisplayed;
                    if (prevShouldChangesBeDisplayed === false && currentShouldChangesBeDisplayed === true) {
                        const steps = currentPluginState?.steps ?? [];
                        const originalDoc = $b4822fc2c345489d$export$26b3581d344cfc94(view.state.doc, steps);
                        if (originalDoc) api?.core?.actions.execute(api?.showDiff?.commands?.showDiff({
                            originalDoc: originalDoc,
                            steps: steps.map((s)=>s.step)
                        }));
                    } else if (currentShouldChangesBeDisplayed === false && prevShouldChangesBeDisplayed === true) api?.core?.actions.execute(api?.showDiff?.commands?.hideDiff);
                }
            };
        }
    });
};
module.exports["trackChangesPluginKey"] = $b4822fc2c345489d$export$7304ae0cfc08f061;
module.exports["createTrackChangesPlugin"] = $b4822fc2c345489d$export$67af324863e9eeaf;

});

parcelRegister("jMTY6", function(module, exports) {

var $dUXjg = parcelRequire("dUXjg");

function $0f39de1919deebad$export$1f6a8febb8dbe92b(steps, allocations) {
    if (allocations.size <= (0, $dUXjg.MAX_STEPS_FROM_BASELINE)) return {
        steps: steps,
        allocations: allocations
    };
    // Create a new allocation, retaining only the most recent values
    const elements = Array.from(allocations);
    const newAllocation = new Set(elements.slice(-(0, $dUXjg.MAX_STEPS_FROM_BASELINE)));
    const finalSteps = [];
    let cutoffFound = false;
    for (const step of steps){
        if (newAllocation.has(step.allocation)) cutoffFound = true;
        // Accept everything after this point otherwise we could have mis-ordered steps
        if (cutoffFound) finalSteps.push(step);
    }
    return {
        steps: finalSteps,
        allocations: newAllocation
    };
}
module.exports["filterSteps"] = $0f39de1919deebad$export$1f6a8febb8dbe92b;

});

parcelRegister("dUXjg", function(module, exports) {
// To be determined a suitable threshold
// Exported for testing
const $70c4b5744ffd488b$export$e7e75006689980e4 = 10;
module.exports["MAX_STEPS_FROM_BASELINE"] = $70c4b5744ffd488b$export$e7e75006689980e4;

});

parcelRegister("dR0MY", function(module, exports) {
class $68ea13a8482d82ad$export$ebdc1f934f4dd665 {
    constructor(step, inverted, allocation){
        this.step = step;
        this.inverted = inverted;
        this.allocation = allocation;
    }
}
module.exports["InvertableStep"] = $68ea13a8482d82ad$export$ebdc1f934f4dd665;

});

parcelRegister("gmn4v", function(module, exports) {
var $c202f366898454cc$export$afb82ed05a2451a3 = /*#__PURE__*/ function(TOGGLE_TRACK_CHANGES_ACTION) {
    TOGGLE_TRACK_CHANGES_ACTION["TOGGLE_TRACK_CHANGES"] = "TOGGLE_TRACK_CHANGES";
    TOGGLE_TRACK_CHANGES_ACTION["RESET_BASELINE"] = "RESET_BASELINE";
    return TOGGLE_TRACK_CHANGES_ACTION;
}({});
module.exports["TOGGLE_TRACK_CHANGES_ACTION"] = $c202f366898454cc$export$afb82ed05a2451a3;

});

parcelRegister("kpe3L", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $cPCP8 = parcelRequire("cPCP8");

var $4Chin = parcelRequire("4Chin");


var $ifwgm = parcelRequire("ifwgm");

const $7e8e83c32ee71781$export$a758406ca53b86a5 = (api, options)=>{
    return [
        {
            type: (0, $cPCP8.TRACK_CHANGES_GROUP).type,
            key: (0, $cPCP8.TRACK_CHANGES_GROUP).key,
            parents: [
                {
                    type: (0, $cPCP8.TRACK_CHANGES_SECTION).type,
                    key: (0, $cPCP8.TRACK_CHANGES_SECTION).key,
                    rank: (0, $4Chin.TRACK_CHANGES_SECTION_RANK)[(0, $cPCP8.TRACK_CHANGES_GROUP).key]
                }
            ]
        },
        {
            type: (0, $cPCP8.TRACK_CHANGES_BUTTON).type,
            key: (0, $cPCP8.TRACK_CHANGES_BUTTON).key,
            parents: [
                {
                    type: (0, $cPCP8.TRACK_CHANGES_GROUP).type,
                    key: (0, $cPCP8.TRACK_CHANGES_GROUP).key,
                    rank: (0, $4Chin.TRACK_CHANGES_GROUP_RANK)[(0, $cPCP8.TRACK_CHANGES_BUTTON).key]
                }
            ],
            component: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $ifwgm.TrackChangesToolbarButton), {
                    api: api,
                    wrapper: options?.ButtonWrapper
                })
        }
    ];
};
module.exports["getToolbarComponents"] = $7e8e83c32ee71781$export$a758406ca53b86a5;

});

parcelRegister("ifwgm", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $1qfLF = parcelRequire("1qfLF");


var $d7ZU3 = parcelRequire("d7ZU3");


var $eiA8Z = parcelRequire("eiA8Z");


var $hgeg8 = parcelRequire("hgeg8");


var $808tb = parcelRequire("808tb");


var $fi2El = parcelRequire("fi2El");

var $7ERUE = parcelRequire("7ERUE");

var $iIVVb = parcelRequire("iIVVb");


var $dh538 = parcelRequire("dh538");

const $97b620886c6f4f29$export$da54b7c34578dd9e = ({ api: api, wrapper: Wrapper })=>{
    const isToolbarAIFCEnabled = Boolean(api?.toolbar);
    const { isDisplayingChanges: isDisplayingChanges, isShowDiffAvailable: isShowDiffAvailable } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'trackChanges'
    ], (states)=>({
            isDisplayingChanges: states.trackChangesState?.isDisplayingChanges,
            isShowDiffAvailable: states.trackChangesState?.isShowDiffAvailable
        }));
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const handleClick = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback(()=>{
        const wasShowingDiffSelected = isDisplayingChanges;
        const result = api?.core.actions.execute(api?.trackChanges?.commands.toggleChanges);
        // On de-selection - focus back on the editor
        if (result && wasShowingDiffSelected) api?.core.actions.focus();
    }, [
        api,
        isDisplayingChanges
    ]);
    const browser = (0, $d7ZU3.getBrowserInfo)();
    // Exclude Firefox browser from showing keyboard shortcut in tooltip
    const showShortcut = !browser.gecko && (0, $dh538.fg)('platform_editor_ai_aifc_patch_ga_blockers');
    const tooltipContent = showShortcut ? /*#__PURE__*/ (0, $l998X.jsx)((0, $hgeg8.ToolTipContent), {
        description: formatMessage((0, $808tb.trackChangesMessages).toolbarIconLabel),
        keymap: (0, $hgeg8.toggleViewChanges)
    }) : formatMessage((0, $808tb.trackChangesMessages).toolbarIconLabel);
    if (!isToolbarAIFCEnabled) return /*#__PURE__*/ (0, $l998X.jsx)((0, $iIVVb.ToolbarTooltip), {
        content: tooltipContent,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($fi2El))),
            label: formatMessage((0, $808tb.trackChangesMessages).toolbarIconLabel),
            appearance: "subtle",
            isDisabled: !isShowDiffAvailable,
            isSelected: isDisplayingChanges,
            onClick: handleClick
        })
    });
    const button = /*#__PURE__*/ (0, $l998X.jsx)((0, $iIVVb.ToolbarTooltip), {
        content: tooltipContent,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $7ERUE.ToolbarButton), {
            iconBefore: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fi2El))), {
                label: formatMessage((0, $808tb.trackChangesMessages).toolbarIconLabel),
                size: "small"
            }),
            onClick: handleClick,
            isDisabled: !isShowDiffAvailable,
            isSelected: isDisplayingChanges
        })
    });
    return Wrapper ? /*#__PURE__*/ (0, $l998X.jsx)(Wrapper, {
        children: button
    }) : button;
};
module.exports["TrackChangesToolbarButton"] = $97b620886c6f4f29$export$da54b7c34578dd9e;

});

parcelRegister("dF1N1", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fO7hX = parcelRequire("fO7hX");


var $6qdjm = parcelRequire("6qdjm");


var $dh538 = parcelRequire("dh538");


var $doFG6 = parcelRequire("doFG6");


var $lRm6W = parcelRequire("lRm6W");


var $79MFg = parcelRequire("79MFg");

const $15f96a0d1cd67d4c$export$4010adcbb216eb38 = ({ api: api, config: config })=>{
    if (!api) throw new Error('api is not defined');
    let streamQueue;
    // Only allow one session to be active at a time
    let sessionId = null;
    // Tracking variables for debugging session lifecycle issues
    let hasSessionBeenStarted = false;
    let isEndingSession = false;
    let lastEndedSessionId = null;
    let endSessionCallCount = 0;
    let sessionAborted = false;
    const streamFlowPacer = (0, $lRm6W.createStreamFlowPacer)(config?.streamFlowPacerEnabled);
    return {
        name: 'aiStreamingOrchestrator',
        actions: {
            startSession: (traceId, params)=>{
                sessionId = (0, $dh538.fg)('platform_editor_ai_aifc_patch_ga_blockers') ? crypto.randomUUID() ?? (0, $fO7hX.uuid).generate() : crypto.randomUUID();
                hasSessionBeenStarted = true;
                sessionAborted = false;
                streamQueue = new (0, $79MFg.StreamCommandQueue)(api, streamFlowPacer);
                if ((0, $dh538.fg)('platform_editor_ai_traceid_in_analytics_events')) {
                    streamQueue.startSession(sessionId, traceId, params?.singleInstrumentationId);
                    api.aiExperience.actions.startSession(sessionId, traceId);
                } else {
                    streamQueue.startSession(sessionId, undefined, params?.singleInstrumentationId);
                    api.aiExperience.actions.startSession(sessionId);
                }
                return sessionId;
            },
            endSession: async (error)=>{
                // In the session abort we end the session and no longer need to run this
                // On a new session we reset the state so this is safe to ignore
                if (sessionAborted) return;
                if (sessionId === null) {
                    if ((0, $dh538.fg)('platform_editor_ai_aifc_patch_ga_blockers')) {
                        (0, $doFG6.fireADFStreamingEndSessionErrorAnalytics)({
                            api: api,
                            sessionStarted: hasSessionBeenStarted,
                            endSessionCallCount: endSessionCallCount,
                            lastEndedSessionId: lastEndedSessionId,
                            isDoubleCall: isEndingSession
                        });
                        throw new Error(`endSession requires a session to be started first!`);
                    } else throw new Error(`endSession requires a session to be started first!`);
                }
                endSessionCallCount++;
                isEndingSession = true;
                const currentSessionId = sessionId;
                try {
                    streamQueue?.queueEndSession(currentSessionId);
                    if (error) {
                        if ((0, $dh538.fg)('platform_editor_ai_migrate_from_xstate')) api.aiExperience.actions.dispatchAIEvent({
                            type: 'error',
                            errorInfo: {
                                failureReason: error.failureReason,
                                statusCode: error.statusCode
                            }
                        });
                        else {
                            const { send: send } = api.aiExperience.actions.getAiExperienceActor();
                            send({
                                type: 'error',
                                errorInfo: {
                                    failureReason: error.failureReason,
                                    statusCode: error.statusCode
                                }
                            });
                        }
                    }
                    // Since `endSession` is going to be called after all the actions are invoked
                    // so we can basically wait for the queue to be empty
                    await streamQueue?.onEmptyQueue();
                    streamQueue?.endSession(currentSessionId);
                    // https://atlassian.slack.com/archives/C0962DYFLRL/p1759397599541949?thread_ts=1759366160.706849&cid=C0962DYFLRL
                    // streamQueue?.destroy();
                    api.aiExperience.actions.endSession(currentSessionId, {
                        type: error ? 'error' : 'finished'
                    });
                    hasSessionBeenStarted = false;
                    lastEndedSessionId = currentSessionId;
                    sessionId = null;
                } finally{
                    isEndingSession = false;
                }
            },
            abortSession: ()=>{
                // abortSession can be called multiple times from multiple command handlers
                if (!sessionId) return;
                const sessionToEnd = sessionId;
                lastEndedSessionId = sessionToEnd;
                sessionId = null;
                streamQueue?.abort();
                if (sessionToEnd) {
                    api.aiExperience.actions.endSession(sessionToEnd, {
                        type: 'abort'
                    });
                    sessionAborted = true;
                }
            },
            initAction: (command, options)=>{
                if (sessionId === null) throw new Error('initAction requires a session to be started first!');
                const actionId = crypto.randomUUID();
                streamQueue?.initStreamCommand(actionId, command, options);
                return actionId;
            },
            // We are sending the full document as a chunk for create actions
            streamValue: (actionId, chunk)=>{
                // Use the queue manager to handle streaming
                // This will either process immediately if actor is ready, or queue for later
                streamQueue?.queueStreamCommand(actionId, chunk);
            },
            finishAction: (actionId, error)=>{
                if (error) {
                    if ((0, $dh538.fg)('platform_editor_ai_migrate_from_xstate')) api.aiExperience.actions.dispatchAIEvent({
                        type: 'error',
                        errorInfo: {
                            failureReason: error.failureReason,
                            statusCode: error.statusCode
                        }
                    });
                    else {
                        const { send: send } = api.aiExperience.actions.getAiExperienceActor();
                        send({
                            type: 'error',
                            errorInfo: {
                                failureReason: error.failureReason,
                                statusCode: error.statusCode
                            }
                        });
                    }
                }
                streamQueue?.endStreamCommand(actionId);
            }
        },
        usePluginHook: ()=>{
            const prevStreamPausedRef = (0, $42omo.useRef)(undefined);
            (0, $6qdjm.usePluginStateEffect)(api, [
                'aiExperience'
            ], ({ aiExperienceState: aiExperienceState })=>{
                const streamPaused = aiExperienceState?.aiSessionPluginState?.streamPaused;
                if (streamPaused !== prevStreamPausedRef.current) {
                    if (streamPaused) streamFlowPacer?.pause();
                    else streamFlowPacer?.resume();
                    prevStreamPausedRef.current = streamPaused;
                }
            }, {
                disabled: !(0, $dh538.fg)('platform_editor_ai_migrate_from_xstate')
            });
            (0, $42omo.useEffect)(()=>{
                return ()=>{
                    streamQueue?.destroy();
                };
            }, []);
        }
    };
};
module.exports["aiStreamingOrchestratorPlugin"] = $15f96a0d1cd67d4c$export$4010adcbb216eb38;

});

parcelRegister("doFG6", function(module, exports) {

var $d925B = parcelRequire("d925B");


var $2pjJ5 = parcelRequire("2pjJ5");


var $dh538 = parcelRequire("dh538");


var $2QlXt = parcelRequire("2QlXt");


var $70XxM = parcelRequire("70XxM");


var $kXhWE = parcelRequire("kXhWE");


var $upqam = parcelRequire("upqam");

function $7b61ecd8bc5f3510$export$6dcba6b9d3966cf9({ api: api, isCreateAction: isCreateAction, traceId: traceId }) {
    return (event)=>{
        if ((0, $dh538.fg)('platform_editor_ai_traceid_in_analytics_events')) {
            const commonAttributes = {
                traceId: (0, $dh538.fg)('platform_editor_ai_traceid_in_analytics_events') ? traceId : undefined,
                experienceName: null,
                selectionType: null,
                selectionCategory: null,
                streamId: null,
                source: {
                    type: 'orchestrator',
                    isCreateAction: isCreateAction
                }
            };
            if (event.type === 'error') api?.analytics?.actions.fireAnalyticsEvent({
                action: 'error',
                actionSubject: 'editorPluginAI',
                actionSubjectId: 'adfStreaming',
                eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    ...commonAttributes,
                    errorMessage: event.message,
                    errorData: event.data
                }
            });
            else api?.analytics?.actions.fireAnalyticsEvent({
                action: 'info',
                actionSubject: 'editorPluginAI',
                actionSubjectId: 'adfStreaming',
                eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    ...commonAttributes,
                    message: event.message,
                    data: event.data
                }
            });
        } else if (event.type === 'error') api?.analytics?.actions.fireAnalyticsEvent({
            action: 'error',
            actionSubject: 'editorPluginAI',
            actionSubjectId: 'adfStreaming',
            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
            attributes: {
                errorMessage: event.message,
                errorData: event.data,
                experienceName: null,
                selectionType: null,
                selectionCategory: null,
                streamId: null,
                source: {
                    type: 'orchestrator',
                    isCreateAction: isCreateAction
                }
            }
        });
        else api?.analytics?.actions.fireAnalyticsEvent({
            action: 'info',
            actionSubject: 'editorPluginAI',
            actionSubjectId: 'adfStreaming',
            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
            attributes: {
                message: event.message,
                data: event.data,
                experienceName: null,
                selectionType: null,
                selectionCategory: null,
                streamId: null,
                source: {
                    type: 'orchestrator',
                    isCreateAction: isCreateAction
                }
            }
        });
    };
}
function $7b61ecd8bc5f3510$export$7535a054b27a27c4({ api: api, initialNode: initialNode, lastDoc: lastDoc }) {
    api?.analytics?.actions.fireAnalyticsEvent({
        action: 'replaceNodeAction',
        actionSubject: 'editorPluginAI',
        actionSubjectId: 'orchestratorReplaceNode',
        eventType: (0, $d925B.EVENT_TYPE).TRACK,
        attributes: {
            attributeOnlyChange: (0, $upqam.isAttributeOnlyChange)(api, initialNode, lastDoc),
            nodeName: initialNode?.type.name
        }
    });
}
// Validates the command is valid ()
const $7b61ecd8bc5f3510$var$validateCommandType = (cmd)=>cmd?.type && (0, $70XxM.allStreamingCommands).includes(cmd.type) ? cmd.type : 'invalid';
function $7b61ecd8bc5f3510$export$276ecd5322451ab4({ api: api, docBeforeStreaming: docBeforeStreaming, command: command, traceId: traceId }) {
    const docAfterStreaming = (0, $kXhWE.getPmDoc)(api);
    if (docBeforeStreaming && docAfterStreaming) {
        const isSameDoc = docBeforeStreaming.eq(docAfterStreaming);
        const isSameDocIgnoreAttrs = (0, $2pjJ5.areNodesEqualIgnoreAttrs)(docBeforeStreaming, docAfterStreaming);
        if (isSameDoc || isSameDocIgnoreAttrs) api.analytics?.actions.fireAnalyticsEvent({
            action: (0, $d925B.ACTION).NO_DOC_CHANGE_FOUND,
            actionSubject: (0, $d925B.ACTION_SUBJECT).AI_STREAMING,
            actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).EXPERIENCE_APPLICATION,
            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
            attributes: {
                command: (0, $dh538.fg)('platform_editor_ai_traceid_in_analytics_events') ? $7b61ecd8bc5f3510$var$validateCommandType(command) : '',
                isSameDoc: isSameDoc,
                isSameDocIgnoreAttrs: isSameDocIgnoreAttrs,
                traceId: (0, $dh538.fg)('platform_editor_ai_traceid_in_analytics_events') ? traceId : undefined
            }
        });
    }
}
function $7b61ecd8bc5f3510$export$8b7d4483ec260574({ api: api, sessionStarted: sessionStarted, endSessionCallCount: endSessionCallCount, lastEndedSessionId: lastEndedSessionId, isDoubleCall: isDoubleCall }) {
    api?.analytics?.actions.fireAnalyticsEvent({
        action: 'error',
        actionSubject: 'editorPluginAI',
        actionSubjectId: 'adfStreamingEndSession',
        eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
        attributes: {
            sessionStarted: sessionStarted,
            endSessionCallCount: endSessionCallCount,
            lastEndedSessionId: lastEndedSessionId,
            isDoubleCall: isDoubleCall
        }
    });
}
function $7b61ecd8bc5f3510$export$4b84cbb6abceadd2({ api: api, sessionId: sessionId, traceId: traceId }) {
    api?.analytics?.actions.fireAnalyticsEvent({
        action: 'sessionStart',
        actionSubject: 'editorPluginAI',
        actionSubjectId: 'userFlow',
        eventType: (0, $d925B.EVENT_TYPE).UI,
        attributes: {
            aiGroupId: sessionId,
            actionTaken: undefined,
            editCount: 0,
            aiSessionId: '',
            traceIds: traceId ? [
                traceId
            ] : undefined
        }
    });
}
function $7b61ecd8bc5f3510$export$2197bcc2a00f4a51({ api: api, command: command, actionId: actionId, traceId: traceId }) {
    api?.analytics?.actions.fireAnalyticsEvent({
        action: 'captured',
        actionSubject: 'editorPluginAI',
        actionSubjectId: 'toolCall',
        eventType: (0, $d925B.EVENT_TYPE).TRACK,
        attributes: {
            actionId: actionId,
            commandType: $7b61ecd8bc5f3510$var$validateCommandType(command),
            traceId: traceId
        }
    });
}
function $7b61ecd8bc5f3510$export$c20b86820b0850bf({ api: api, command: command, traceId: traceId, isCreateAction: isCreateAction, error: error }) {
    api?.analytics?.actions.fireAnalyticsEvent({
        action: 'error',
        actionSubject: 'editorPluginAI',
        actionSubjectId: 'adfStreaming',
        eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
        attributes: {
            errorMessage: 'toolCallError',
            errorData: {
                commandType: command?.type,
                commandReason: command?.type === 'endStream' ? command?.reason : undefined,
                errorMessage: (0, $2QlXt.ErrorUtils).extractErrorMessage(error)
            },
            traceId: traceId,
            experienceName: null,
            selectionType: null,
            selectionCategory: null,
            streamId: null,
            source: {
                type: 'orchestrator',
                isCreateAction: isCreateAction ?? false
            }
        }
    });
}
module.exports["createFireADFStreamingAnalyticsEvent"] = $7b61ecd8bc5f3510$export$6dcba6b9d3966cf9;
module.exports["fireAttributeOnlyReplaceNodeAnalytics"] = $7b61ecd8bc5f3510$export$7535a054b27a27c4;
module.exports["checkAndFireNoDocumentChangeAnalytics"] = $7b61ecd8bc5f3510$export$276ecd5322451ab4;
module.exports["fireADFStreamingEndSessionErrorAnalytics"] = $7b61ecd8bc5f3510$export$8b7d4483ec260574;
module.exports["fireSessionStartedAnalytics"] = $7b61ecd8bc5f3510$export$4b84cbb6abceadd2;
module.exports["fireToolCallCapturedAnalytics"] = $7b61ecd8bc5f3510$export$2197bcc2a00f4a51;
module.exports["fireCommandError"] = $7b61ecd8bc5f3510$export$c20b86820b0850bf;

});

parcelRegister("70XxM", function(module, exports) {
const $af0b798917256420$export$d4371db4dc3f8b5f = [
    'replaceNode',
    'removeNode',
    'insertNodeBefore',
    'insertNodeAfter',
    'appendNodeToEnd',
    'setAttrs',
    'wrap',
    'wrapNode',
    'appendNode'
];
 // #endregion
module.exports["allStreamingCommands"] = $af0b798917256420$export$d4371db4dc3f8b5f;

});

parcelRegister("kXhWE", function(module, exports) {
function $839bfdacc8d0b035$export$6bf900bab6a4720d(api) {
    let doc;
    // Quick and dirty way to get the doc
    api?.core.actions.execute(({ tr: tr })=>{
        doc = tr.doc;
        return null;
    });
    return doc;
}
module.exports["getPmDoc"] = $839bfdacc8d0b035$export$6bf900bab6a4720d;

});

parcelRegister("upqam", function(module, exports) {

var $2pjJ5 = parcelRequire("2pjJ5");


var $cz1qC = parcelRequire("cz1qC");


var $51Pdx = parcelRequire("51Pdx");

function $9dc598573bd03537$export$450b2ad108e2e506(api, initialNode, finalNode) {
    const schema = api?.core.sharedState.currentState()?.schema;
    if (!initialNode || !finalNode || !schema || !initialNode.attrs.localId) return false;
    const finalPMDoc = (0, $51Pdx.makeDocumentValid)(api, finalNode, undefined)?.doc;
    if (!finalPMDoc) return false;
    const finalPMNode = (0, $cz1qC.findNodeByLocalIdAndDoc)(finalPMDoc, initialNode.attrs.localId)?.node;
    return (finalPMNode && !initialNode.eq(finalPMNode) && (0, $2pjJ5.areNodesEqualIgnoreAttrs)(initialNode, finalPMNode)) ?? false;
}
module.exports["isAttributeOnlyChange"] = $9dc598573bd03537$export$450b2ad108e2e506;

});

parcelRegister("cz1qC", function(module, exports) {

var $4QzBR = parcelRequire("4QzBR");


var $d925B = parcelRequire("d925B");


var $dh538 = parcelRequire("dh538");

function $009cb14caceb5527$export$1bd732ee2c8aaeb(doc, localId) {
    let nodeResult;
    doc.descendants((node, pos, parent)=>{
        if (nodeResult) return false;
        if (node.attrs.localId === localId) nodeResult = {
            node: node,
            pos: pos,
            parent: parent
        };
        return !nodeResult;
    });
    return nodeResult;
}
function $009cb14caceb5527$export$c1cb5b5eb3aab3e3(doc, localId) {
    let nodeResult;
    doc.descendants((node, pos, parent)=>{
        if (node.attrs.localId === localId) {
            nodeResult = {
                node: node,
                pos: pos,
                parent: parent
            };
            return false;
        }
        return true;
    });
    return nodeResult;
}
function $009cb14caceb5527$export$b7b4fc0a0195a016(api, localId) {
    if (!localId) return undefined;
    let foundNode;
    api?.core.actions.execute(({ tr: tr })=>{
        foundNode = $009cb14caceb5527$export$1bd732ee2c8aaeb(tr.doc, localId)?.node;
        return null;
    });
    return foundNode;
}
function $009cb14caceb5527$export$aadcc3ba2430b(api, tr, localId, callback, reversed) {
    const result = ((0, $dh538.fg)('platform_editor_ai_aifc_patch_ga_blockers') ? reversed ? $009cb14caceb5527$export$c1cb5b5eb3aab3e3 : $009cb14caceb5527$export$1bd732ee2c8aaeb : $009cb14caceb5527$export$1bd732ee2c8aaeb)(tr.doc, localId);
    if (result) {
        api?.aiExperience?.actions.tagAsAIStreamingTransformation(tr);
        callback(result);
    }
    if (!result) {
        const localIdState = api?.localId?.sharedState.currentState();
        let localIdStatus;
        if (!localIdState) localIdStatus = 'localIdPluginMissing';
        else if (!localIdState.localIdWatchmenEnabled) localIdStatus = 'localIdWatchmenDisabled';
        else localIdStatus = localIdState.localIdStatus?.get(localId) ?? 'notFound';
        let docSize;
        // Quick and dirty way to get the node size - do not copy this pattern, use `requestDocument`
        api?.core.actions.execute(({ tr: tr })=>{
            docSize = tr.doc.nodeSize;
            return null;
        });
        api?.analytics?.actions.fireAnalyticsEvent({
            action: (0, $d925B.ACTION).LOCAL_ID_NOT_FOUND,
            actionSubject: (0, $d925B.ACTION_SUBJECT).AI_STREAMING,
            actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).EXPERIENCE_APPLICATION,
            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
            attributes: {
                localIdLength: localId?.length,
                docSize: docSize,
                scrubbedLocalId: (0, $dh538.fg)('platform_editor_ai_traceid_in_analytics_events') ? (0, $4QzBR.scrubStr)(localId) : '',
                localIdStatus: (0, $dh538.fg)('platform_editor_ai_aifc_localid_error_reporting') ? localIdStatus : 'unavailable',
                localIdStatusSize: localIdState?.localIdStatus?.size ?? 0
            }
        });
        if ((0, $dh538.fg)('platform_editor_ai_aifc_patch_ga')) return null;
        else throw new Error(`Node with localId ${localId} not found`);
    }
    return tr;
}
module.exports["findNodeByLocalIdAndDoc"] = $009cb14caceb5527$export$1bd732ee2c8aaeb;
module.exports["findNodeByLocalIdAndApi"] = $009cb14caceb5527$export$b7b4fc0a0195a016;
module.exports["findNodeByLocalId"] = $009cb14caceb5527$export$aadcc3ba2430b;

});

parcelRegister("51Pdx", function(module, exports) {

var $h9yJL = parcelRequire("h9yJL");


var $5SAOw = parcelRequire("5SAOw");


var $aXG5V = parcelRequire("aXG5V");


var $dh538 = parcelRequire("dh538");

const $adc2c60cd4921249$var$transformer = new (0, $h9yJL.JSONTransformer)();
function $adc2c60cd4921249$export$7b6c9d9d26e2f428(api, response, type) {
    const schema = api?.core.sharedState.currentState()?.schema;
    if (!schema || !response) return {
        adfDoc: response
    };
    try {
        const doc = schema.node('doc', null, [
            schema.node('paragraph', null, [])
        ]);
        const transform = new (0, $aXG5V.Transform)(doc);
        const node = (0, $5SAOw.Node).fromJSON(schema, response);
        const newDoc = transform.replaceWith(0, 2, node).doc;
        if ((0, $dh538.fg)('platform_editor_ai_aifc_patch_ga')) return {
            doc: newDoc,
            // The "doc" response can cause nesting issues (ie. by wrapping a taskItem in doc -> taskList -> taskItem)
            // We should use the response, but for now only use it for `replaceNode` since it causes some edge cases with other commands
            // that need to be resolved separately
            adfDoc: type === 'replaceNode' || (0, $dh538.fg)('platform_editor_ai_aifc_patch_ga_blockers') ? response : $adc2c60cd4921249$var$transformer.encode(newDoc)
        };
        return {
            doc: newDoc,
            adfDoc: $adc2c60cd4921249$var$transformer.encode(newDoc)
        };
    } catch  {
        return {
            adfDoc: response
        };
    }
}
module.exports["makeDocumentValid"] = $adc2c60cd4921249$export$7b6c9d9d26e2f428;

});

parcelRegister("lRm6W", function(module, exports) {

var $c6GJD = parcelRequire("c6GJD");


var $e83av = parcelRequire("e83av");

function $19e1d609df7dfc8f$var$isNumber(value) {
    return typeof value === 'number';
}
function $19e1d609df7dfc8f$var$isRamp(value) {
    if (typeof value !== 'object' || value === null) return false;
    const v = value;
    return $19e1d609df7dfc8f$var$isNumber(v.initialDelaySec) && $19e1d609df7dfc8f$var$isNumber(v.stepDelaySec) && $19e1d609df7dfc8f$var$isNumber(v.flushDelaySec) && $19e1d609df7dfc8f$var$isNumber(v.growthFactor);
}
function $19e1d609df7dfc8f$var$getExperimentValue(key, defaultValue) {
    return (0, $c6GJD.default).getExperimentValue('platform-editor-ai-streaming-speed', key, defaultValue, {
        typeGuard: $19e1d609df7dfc8f$var$isNumber
    });
}
function $19e1d609df7dfc8f$export$9ea8217d5ec56f82(enabled) {
    if (enabled === false) return null;
    const backlogRampThreshold = $19e1d609df7dfc8f$var$getExperimentValue('backlogRampThreshold', 100);
    const initialCharsPerTick = $19e1d609df7dfc8f$var$getExperimentValue('initialCharsPerTick', 8);
    const maxCharsPerTick = $19e1d609df7dfc8f$var$getExperimentValue('maxCharsPerTick', 1000);
    const tickMs = $19e1d609df7dfc8f$var$getExperimentValue('tickMs', 41);
    const ramp = (0, $c6GJD.default).getExperimentValue('platform-editor-ai-streaming-speed', 'ramp', {
        initialDelaySec: 6,
        stepDelaySec: 3,
        flushDelaySec: 0.5,
        growthFactor: 1.5
    }, {
        typeGuard: $19e1d609df7dfc8f$var$isRamp
    });
    // These settings are copied from the ai plugins pacer -> platform/packages/editor/editor-plugin-ai/src/ui/utils/request/stream-flow-pacer.ts
    return new (0, $e83av.StreamFlowPacer)({
        backlogRampThreshold: backlogRampThreshold,
        initialCharsPerTick: initialCharsPerTick,
        maxCharsPerTick: maxCharsPerTick,
        ramp: ramp,
        tickMs: tickMs
    });
}
module.exports["createStreamFlowPacer"] = $19e1d609df7dfc8f$export$9ea8217d5ec56f82;

});

parcelRegister("79MFg", function(module, exports) {

var $2pjJ5 = parcelRequire("2pjJ5");


var $dh538 = parcelRequire("dh538");


var $1oCLl = parcelRequire("1oCLl");


var $4pSml = parcelRequire("4pSml");


var $1xicG = parcelRequire("1xicG");


var $9Tkc6 = parcelRequire("9Tkc6");


var $hI9Sy = parcelRequire("hI9Sy");


var $doFG6 = parcelRequire("doFG6");


var $cz1qC = parcelRequire("cz1qC");


var $kXhWE = parcelRequire("kXhWE");


var $eSNDK = parcelRequire("eSNDK");


var $51Pdx = parcelRequire("51Pdx");


var $ldVMA = parcelRequire("ldVMA");


var $icc5i = parcelRequire("icc5i");


var $8hcFZ = parcelRequire("8hcFZ");


var $7y1H8 = parcelRequire("7y1H8");

class $4c93be51fe49a367$export$f3feb8728b17a0a9 {
    isActorReady() {
        try {
            const currentState = this.api.aiExperience.sharedState.currentState();
            if (!(0, $dh538.fg)('platform_editor_ai_migrate_from_xstate')) {
                // Check if actor exists and is in streaming state
                const actor = this.api.aiExperience.actions.getAiExperienceActor();
                return actor && currentState?.isStreaming === true;
            }
            return currentState?.isStreaming === true;
        } catch  {
            return false;
        }
    }
    commandToProcess(commandToProcess) {
        const { type: type, actionId: actionId, chunk: chunk } = commandToProcess;
        if (type === 'initStream') return this.initStreamPromise(commandToProcess.command, commandToProcess.options);
        else if (type === 'endStream') return this.endExperiencePromise(commandToProcess);
        else return this.processStreamCommandPromise(actionId, chunk);
    }
    async processQueue() {
        if (this.processingQueue) return;
        if (this.queueTimeout) clearTimeout(this.queueTimeout);
        this.processingQueue = true;
        let commandsToProcess = [
            ...this.queue
        ].filter((cmd)=>cmd.actionId === this.currentAction?.id);
        this.inProcessing = [
            ...new Set(commandsToProcess.map((cmd)=>cmd.actionId))
        ];
        this.queue = this.queue.filter((cmd)=>!commandsToProcess.includes(cmd));
        let currentCommand = null;
        try {
            commandsToProcess = (0, $ldVMA.mergeStreamCommands)(commandsToProcess);
            for (const commandToProcess of commandsToProcess){
                currentCommand = commandToProcess;
                if (this.aborted.includes(commandToProcess.actionId)) {
                    // If we abort the last stream let's move onto the next stream
                    if (commandToProcess.type === 'endStream' && (0, $dh538.fg)('platform_editor_ai_aifc_patch_ga')) this.resolvePendingQueue(true);
                    continue;
                }
                await this.wrapInTimeout(this.commandToProcess(commandToProcess), commandToProcess);
            }
        } catch (error) {
            if ((0, $1oCLl.expValEquals)('platform_editor_ai_fix_insert_after_selection', 'isEnabled', true)) (0, $doFG6.fireCommandError)({
                api: this.api,
                traceId: this.traceId,
                command: currentCommand,
                isCreateAction: this.currentAction?.isCreateAction,
                error: error
            });
            else throw error;
        } finally{
            // Reset the processing queue flag
            this.processingQueue = false;
            const lastCommand = commandsToProcess.pop();
            this.inProcessing = [];
            if (lastCommand?.type === 'endStream') this.checkAndResolveEmptyQueue();
        }
        // If commands have been added to the queue during async operations, process them now
        if (this.queue.filter((cmd)=>cmd.actionId === this.currentAction?.id).length > 0) this.processQueue();
        else if (this.queue.length > 0) this.queueTimeout = setTimeout(()=>{
            this.logger.logError(`Current stream queue timed out while starting next`, {
                actionId: this.currentAction?.id ?? undefined
            });
            this.resolvePendingQueue(true);
            this.processQueue();
        }, this.CURRENT_QUEUE_TIMEOUT);
    }
    onEmptyQueue() {
        if ((0, $dh538.fg)('platform_editor_ai_aifc_patch_ga')) {
            const promise = new Promise((resolve)=>{
                this.onEmptyQueueResolve = resolve;
            });
            this.checkAndResolveEmptyQueue();
            return promise;
        } else {
            if (this.queue.length === 0) return Promise.resolve();
            return new Promise((resolve)=>{
                this.onEmptyQueueResolve = resolve;
            });
        }
    }
    async wrapInTimeout(promise, cmd) {
        const { promise: wrappedPromise, resetTimeout: resetTimeout } = (0, $icc5i.createTimeoutWrapper)(promise, {
            timeout: this.COMMAND_TIMEOUT,
            onTimeout: ()=>{
                this.logger.logError(`Stream command timed out ${cmd.type}`, {
                    actionId: cmd.actionId,
                    chunk: cmd.chunk
                });
            },
            onCleanup: ()=>{
                this.currentCommandTimeoutReset = null;
                if (cmd.type === 'endStream') this.checkAndResolveEmptyQueue();
                this.resolvePendingQueue();
            }
        });
        this.currentCommandTimeoutReset = resetTimeout;
        await wrappedPromise;
    }
    /**
   * End the AI experience
   */ endStreamCommand(actionId) {
        // duplicated endStreamCommand will kill accept reject screen prematurely
        if (this.endedActionIds.includes(actionId)) {
            this.logger.logPublic('End Stream Command Ignored', {
                actionId: actionId
            });
            return;
        }
        this.endedActionIds.push(actionId);
        if (this.endedActionIds.length > 10) this.endedActionIds.shift();
        this.logger.logPublic('End Stream Command', {
            actionId: actionId
        });
        // deprecated - Cleanup with platform_editor_ai_aifc_patch_ga
        this.hideLoadingScreen = false;
        if (this.aborted.includes(actionId) || this.isAborted) {
            this.updateAbortedCache([
                actionId
            ]);
            return;
        }
        // Actor not ready, queue the command
        this.queue.push({
            type: 'endStream',
            actionId: actionId,
            chunk: undefined,
            reason: 'endCurrentStream'
        });
        this.processQueue();
    }
    endExperience() {
        // if it's isFinalStream
        // - when auto accept AI changes is on, editor-plugin-ai will end itself
        // - when auto accept AI changes is off, the accept reject screen will be shown
        // if it's not isFinalStream, the endAIExperience is used to kill a previous AI modal
        // - which can be the previous accept reject screen
        // - or the command palette screen (followed by rovo free-gen screen)
        if (!this.isFinalStream) {
            this.logger.logQueueState('End AI Experience');
            this.api.aiExperience.actions.endAIExperience();
        }
        this.isFinalStream = false;
        // deprecated - Cleanup with platform_editor_ai_aifc_patch_ga
        this.hideLoadingScreen = false;
        this.adfStreamer?.reset();
        this.streamFlowPacer?.reset();
        this.subscription?.();
    }
    resolvePendingQueue(timeout = false) {
        if (timeout || this.isPendingResolveQueue) {
            const currentAction = this.queue.find((cmd)=>cmd.type === 'initStream') ?? null;
            this.logger.logQueueState('Resolve Pending Queue', {
                actionId: currentAction?.actionId,
                reason: timeout ? 'timeout' : 'isPendingResolveQueue'
            });
            this.currentAction = currentAction ? {
                id: currentAction.actionId,
                isCreateAction: (currentAction.command.type === 'appendNode' || currentAction.command.type === 'appendNodeToEnd') && currentAction.command.streamingType === 'create',
                initialNode: (0, $cz1qC.findNodeByLocalIdAndApi)(this.api, currentAction.command.type === 'replaceNode' && currentAction.command.localId),
                type: currentAction.command.type
            } : null;
            this.isPendingResolveQueue = false;
        }
    }
    checkAndResolveEmptyQueue() {
        if (this.queue.length === 0 && this.inProcessing.length === 0) this.onEmptyQueueResolve?.();
    }
    endNonStreamble() {
        if ((0, $dh538.fg)('platform_editor_ai_migrate_from_xstate')) this.api.aiExperience.actions.dispatchAIEvent({
            type: 'complete',
            adfResponse: undefined
        });
        else {
            const { send: send } = this.api.aiExperience.actions.getAiExperienceActor();
            send({
                type: 'complete',
                markdown: '',
                adfResponse: undefined,
                cacheKey: '',
                modelInput: {}
            });
        }
    }
    async endExperiencePromise(command) {
        const { actionId: actionId, reason: reason } = command;
        this.logger.logQueueState('End Experience', {
            actionId: actionId,
            reason: reason
        });
        this.isPendingResolveQueue = reason === 'endCurrentStream';
        // should not check empty queue if the end command is triggered by the initStreamCommand
        // which is used to close a previous AI modal
        // because there are more commands to process even if the queue is empty
        // and this.isPendingResolveQueue will be reset, so use a different flag here
        const shouldCheckEmptyQueue = reason === 'endCurrentStream';
        const isStreamingCommand = !(this.currentAction?.type && !(0, $eSNDK.isAStreamableCommand)({
            type: this.currentAction?.type
        }));
        if (this.isStreaming && isStreamingCommand) {
            await this.processStreamCommandPromise(actionId, '', true);
            if (this.currentAction?.type === 'replaceNode') (0, $doFG6.fireAttributeOnlyReplaceNodeAnalytics)({
                api: this.api,
                initialNode: this.currentAction.initialNode,
                lastDoc: this.adfStreamer?.getLastDoc()
            });
            (0, $doFG6.checkAndFireNoDocumentChangeAnalytics)({
                api: this.api,
                command: this.currentCommand,
                docBeforeStreaming: this.docBeforeStreaming,
                traceId: this.traceId
            });
        } else if (!isStreamingCommand && (0, $dh538.fg)('platform_editor_ai_aifc_patch_ga')) this.isFinalStream = true;
        return new Promise((resolve)=>{
            const endNow = ()=>{
                this.endExperience();
                // After we end the experience there are a number of React re-renders that occur immediately after
                // This causes the state to flick between streaming and not streaming, it's not pretty
                // but wrap this in a `requestAnimationFrame` to delay our check until this clears.
                // To fix this properly we probably need to decouple the state with React
                const checkStreaming = ()=>{
                    const resolveAndEndStream = ()=>{
                        resolve();
                        this.logger.logQueueState('End Experience Resolved', {
                            actionId: actionId,
                            reason: reason
                        });
                        this.resolvePendingQueue();
                        shouldCheckEmptyQueue && this.checkAndResolveEmptyQueue();
                    };
                    if (!isStreamingCommand && (0, $dh538.fg)('platform_editor_ai_aifc_patch_ga')) {
                        this.endNonStreamble();
                        resolveAndEndStream();
                        return;
                    }
                    if (!this.api.aiExperience?.sharedState.currentState()?.isStreaming) {
                        resolveAndEndStream();
                        return;
                    }
                    const unsubscribe = this.api.aiExperience?.sharedState.onChange(({ nextSharedState: nextSharedState })=>{
                        if (!nextSharedState.isStreaming) {
                            unsubscribe();
                            resolveAndEndStream();
                        }
                    });
                };
                setTimeout(checkStreaming, 0);
            };
            // If we're not running the pacer or its a non-streamable command, end immediately
            if (!this.streamFlowPacer?.isRunning() || this.currentAction?.type && !(0, $eSNDK.isAStreamableCommand)({
                type: this.currentAction?.type
            })) endNow();
            else this.streamFlowPacer.onComplete(()=>{
                // Need to be careful not to end the experience too soon. We need to give the xstate and react time to process
                // the final stream events before we kill the experience. Otherwise you will see an unfinished stream in the doc.
                setTimeout(endNow, 100);
            });
        });
    }
    /**
   * Streams the AI experience
   */ queueStreamCommand(actionId, chunk) {
        this.logger.logPublic('Stream Command', {
            actionId: actionId,
            chunk: chunk
        });
        if (this.aborted.includes(actionId) || this.isAborted) {
            this.updateAbortedCache([
                actionId
            ]);
            return;
        }
        // Actor not ready, queue the command
        this.queue.push({
            type: 'streamCommand',
            actionId: actionId,
            chunk: chunk
        });
        if (this.isActorReady()) this.processQueue();
        else {
            // if there are multiple sequential queueStreamCommand calls
            // and we assign the return value to this.subscription and call this.subscription
            // we won't be able to unsubscribe the corresponding right one
            // and will cause the callback to be called tons of times when state changes
            const unsubscribe = this.api?.aiExperience.sharedState.onChange(()=>{
                if (this.isActorReady()) {
                    unsubscribe?.();
                    this.processQueue();
                }
            });
        }
    }
    hasChangedDocument(latestDoc) {
        if (!this.previousValidDoc && latestDoc && (0, $dh538.fg)('platform_editor_ai_aifc_patch_ga_blockers')) return true;
        const nodesAreNotEqual = !this.previousValidDoc?.doc || !latestDoc?.doc || !(0, $2pjJ5.areNodesEqualIgnoreAttrs)(this.previousValidDoc?.doc, latestDoc.doc);
        if (this.streamFlowPacer === null) return Boolean(nodesAreNotEqual && latestDoc.doc && !(0, $2pjJ5.isEmptyDocument)(latestDoc.doc));
        const latestCount = this.streamFlowPacer?.adfTextLen(latestDoc?.adfDoc);
        return Boolean(nodesAreNotEqual && latestDoc.adfDoc && this.previousValidDoc?.adfDoc && latestCount.chars > 0 && // Ensure we only stream changes if the stream flow pacer detects semantic changes
        !this.streamFlowPacer?.adfTextLen(this.previousValidDoc?.adfDoc).gte(latestCount));
    }
    createCallback(usePush) {
        if (usePush) return (evt)=>{
            const fullEvent = (0, $1xicG.normaliseAIExperienceEvent)(evt);
            this?.streamFlowPacer?.push(fullEvent);
        };
        if ((0, $dh538.fg)('platform_editor_ai_migrate_from_xstate')) return (evt)=>{
            this.api.aiExperience.actions.dispatchAIEvent(evt);
        };
        // Legacy path: send to actor with padded defaults
        const { send: send } = this.api.aiExperience.actions.getAiExperienceActor();
        return (evt)=>{
            const payload = (0, $1xicG.normaliseAIExperienceEvent)(evt);
            send(payload);
        };
    }
    processStreamCommand(actionId, chunk, finalStream = false) {
        if ((0, $dh538.fg)('platform_editor_ai_migrate_from_xstate')) this.streamFlowPacer?.setEmit((evt)=>{
            // While the stream flow pacer is doing work reset the timeout
            this.currentCommandTimeoutReset?.();
            this.api.aiExperience.actions.dispatchAIEvent(evt);
        });
        else {
            const { send: send } = this.api.aiExperience.actions.getAiExperienceActor();
            this.streamFlowPacer?.setEmit((evt)=>{
                // While the stream flow pacer is doing work reset the timeout
                this.currentCommandTimeoutReset?.();
                send(evt);
            });
        }
        const callback = this.createCallback(!!this.streamFlowPacer?.push);
        // Initialize streamer if needed
        if (!this.adfStreamer) {
            const schema = this.api.core.sharedState.currentState()?.schema;
            this.adfStreamer = schema ? new (0, $4pSml.ADFStreamer)(schema, (0, $doFG6.createFireADFStreamingAnalyticsEvent)({
                api: this.api,
                isCreateAction: this.currentAction?.isCreateAction ?? false,
                traceId: (0, $dh538.fg)('platform_editor_ai_traceid_in_analytics_events') ? this.traceId : undefined
            })) : undefined;
        }
        if (finalStream) {
            const adfResponseBefore = (0, $51Pdx.makeDocumentValid)(this.api, this.adfStreamer?.getLastDoc(), this.currentAction?.type).adfDoc;
            const schema = this.api.core.sharedState.currentState()?.schema;
            const { updatedResponse: updatedResponse, localId: localId } = (0, $8hcFZ.updateInsertAfterDoc)(adfResponseBefore, this.currentAction?.type, schema);
            const adfResponse = (0, $dh538.fg)('platform_editor_ai_aifc_patch_ga') ? updatedResponse : adfResponseBefore;
            this.insertAfterQueueLocalId = localId;
            this.adfStreamer?.endStreamingSession({
                hasProcessedFinalResponse: true
            });
            this.logger.logQueueState('Final Stream', {
                actionId: actionId,
                adf: adfResponse,
                finalStream: true
            });
            callback({
                type: 'complete',
                adfResponse: adfResponse
            });
            return true;
        }
        // Resetting because we are going to get full ADF as chunk
        this.adfStreamer?.reset();
        this.adfStreamer?.processChunk(chunk);
        const latestDoc = (0, $51Pdx.makeDocumentValid)(this.api, this.adfStreamer?.getLastDocWithoutLastLeafNode(), this.currentAction?.type);
        const changed = this.hasChangedDocument(latestDoc);
        this.previousValidDoc = latestDoc;
        // We compare the before/after docs because if nothing has changed then it will not trigger a react update (because the adfResponse needs to be different)
        // which means the chunkNumber will never update and the processStreamCommandPromise Promise will never resolve.
        // This cause the wrapInTimeout 1sec delay to occur before the next chunk is processed. This means we can end up in a situation
        // where we're recieving a lot of chunks, but nothing in the view is changed and everything starts taking a lot of time
        // because of the sequential 1sec failovers.
        if (changed) {
            callback({
                type: 'stream',
                adfResponse: latestDoc.adfDoc
            });
            return true;
        }
        return false;
    }
    processStreamCommandPromise(actionId, chunk, finalStream = false) {
        this.logger.logQueueState('Streaming Command', {
            actionId: actionId,
            chunk: chunk,
            finalStream: finalStream
        });
        this.isStreaming = !finalStream;
        this.isFinalStream = finalStream;
        return new Promise((resolve)=>{
            // do not wrap the code in setTimeout, it will pause the streaming when the tab is in background
            const chunkBefore = this.api.aiExperience?.sharedState.currentState()?.chunkNumber;
            if (!this.processStreamCommand(actionId, chunk, finalStream)) {
                // If nothing was processed then we should be able to end immediately since we will never get a chuckNumber update
                // this means the next chunk can be processed straight away.
                resolve();
                this.logger.logQueueState('Streaming Command Resolved', {
                    actionId: actionId,
                    chunk: chunk,
                    finalStream: finalStream
                });
                return;
            }
            if (chunkBefore !== this.api.aiExperience?.sharedState.currentState()?.chunkNumber) {
                resolve();
                this.logger.logQueueState('Streaming Command Resolved', {
                    actionId: actionId,
                    chunk: chunk,
                    finalStream: finalStream
                });
                return;
            }
            // if there are multiple sequential queueStreamCommand calls and one of them timeout
            // and we assign the return value to this.subscription and call this.subscription
            // we won't be able to unsubscribe the corresponding right one
            // and will cause the callback to be called tons of times when state changes
            const unsubscribe = this.api.aiExperience?.sharedState.onChange(({ nextSharedState: nextSharedState, prevSharedState: prevSharedState })=>{
                if (nextSharedState?.chunkNumber !== prevSharedState?.chunkNumber) {
                    unsubscribe?.();
                    resolve();
                    this.logger.logQueueState('Streaming Command Resolved', {
                        actionId: actionId,
                        chunk: chunk,
                        finalStream: finalStream
                    });
                }
            });
        });
    }
    /**
   * Streams the AI experience
   */ initStreamCommand(actionId, command, options) {
        this.logger.logPublic('Init Command', {
            actionId: actionId,
            command: command
        });
        this.isAborted = false;
        // Track tool call captured for analytics
        if ((0, $dh538.fg)('platform_editor_ai_tool_call_received_analytics')) (0, $doFG6.fireToolCallCapturedAnalytics)({
            api: this.api,
            command: command,
            actionId: actionId,
            traceId: this.traceId
        });
        // deprecated - Cleanup with platform_editor_ai_aifc_patch_ga
        this.hideLoadingScreen = options?.hideLoadingScreen ?? false;
        if (!this.currentAction) this.currentAction = {
            id: actionId,
            isCreateAction: (command.type === 'appendNode' || command.type === 'appendNodeToEnd') && command.streamingType === 'create',
            initialNode: (0, $cz1qC.findNodeByLocalIdAndApi)(this.api, command.type === 'replaceNode' && command.localId),
            type: command.type
        };
        // If we're already running end the stream and restart
        if (this.api.aiExperience.sharedState.currentState()?.aiDecorationExperiencePluginState.isRunning) this.queue.push({
            type: 'endStream',
            actionId: actionId,
            chunk: undefined,
            reason: 'endPreviousStream'
        });
        this.queue.push({
            type: 'initStream',
            actionId: actionId,
            chunk: undefined,
            command: command,
            options: options
        });
        this.processQueue();
    }
    applyCommand(command) {
        const insertAfterQueue = this.currentCommand?.type === 'insertNodeAfter' && command.type === 'insertNodeAfter' && command.localId === this.currentCommand?.localId;
        this.currentCommand = command;
        this.docBeforeStreaming = (0, $kXhWE.getPmDoc)(this.api);
        let isSuccessful = true;
        // If we have subsequent "insertAfter" commands with the same localId, instead point to the end of the
        // previous insertion. This is because the AI will "insertAfter" in a logical order, but that puts the content
        // into the document backwards.
        if (insertAfterQueue && this.insertAfterQueueLocalId && (0, $dh538.fg)('platform_editor_ai_aifc_patch_ga')) // If for some reason the localId doesn't exist in the document fallback to the original stream command
        try {
            isSuccessful = this.streamingCommands[command.type]({
                ...command,
                localId: this.insertAfterQueueLocalId
            });
        } catch  {
            isSuccessful = this.streamingCommands[command.type](command);
        }
        else isSuccessful = this.streamingCommands[command.type](command);
        return isSuccessful;
    }
    initStream(command, options) {
        const applied = this.applyCommand(command);
        // If we couldn't apply the command (ie. broken localId) add it to the abort cache so we don't apply anymore commands
        if (!applied && (0, $dh538.fg)('platform_editor_ai_aifc_patch_ga')) {
            // Never start the stream and resolve immediately
            if (this.currentAction?.id) this.updateAbortedCache([
                this.currentAction?.id
            ]);
            return true;
        }
        this.streamFlowPacer?.reset();
        this.adfStreamer?.reset();
        // We have to set an empty callback before starting otherwise the flow pacer wont start. We need to cleanup the flow pacer
        // and make it more generic.
        this.streamFlowPacer?.setEmit(()=>{});
        this.streamFlowPacer?.start();
        if ((0, $dh538.fg)('platform_editor_ai_aifc_patch_ga')) {
            const isCreate = (command.type === 'appendNode' || command.type === 'appendNodeToEnd') && command.streamingType === 'create';
            this.logger.logQueueState('Open AI Modal', {
                command: command
            });
            this.api.aiExperience.actions.openAIModal({
                invokedFrom: 'streamingApi',
                configItem: (0, $9Tkc6.UNSTABLE_configItems).freeGenerateAifcConfigItem,
                withStreamingHighlight: !isCreate,
                // don't show accept reject screen for staging first-time creation streaming
                withAcceptReject: !isCreate,
                hideLoadingScreen: ((0, $dh538.fg)('platform_editor_tmp_hide_loader') && options?.hideLoadingScreen) ?? false,
                traceId: this.traceId,
                singleInstrumentationId: this.singleInstrumentationId,
                isCreate: isCreate
            });
            if (!(0, $eSNDK.isAStreamableCommand)(command)) (0, $doFG6.checkAndFireNoDocumentChangeAnalytics)({
                api: this.api,
                command: this.currentCommand,
                docBeforeStreaming: this.docBeforeStreaming,
                traceId: this.traceId
            });
            return false;
        } else if ((0, $eSNDK.isAStreamableCommand)(command)) {
            const isCreate = (command.type === 'appendNode' || command.type === 'appendNodeToEnd') && command.streamingType === 'create';
            this.logger.logQueueState('Open AI Modal', {
                command: command
            });
            this.api.aiExperience.actions.openAIModal({
                invokedFrom: 'streamingApi',
                configItem: (0, $9Tkc6.UNSTABLE_configItems).freeGenerateAifcConfigItem,
                withStreamingHighlight: !isCreate,
                // don't show accept reject screen for staging first-time creation streaming
                withAcceptReject: !isCreate,
                hideLoadingScreen: (0, $dh538.fg)('platform_editor_tmp_hide_loader') && this.hideLoadingScreen
            });
            return false;
        } else {
            (0, $doFG6.checkAndFireNoDocumentChangeAnalytics)({
                api: this.api,
                command: this.currentCommand,
                docBeforeStreaming: this.docBeforeStreaming,
                traceId: this.traceId
            });
            return true;
        }
    }
    async initStreamPromise(command, options) {
        await new Promise((resolve)=>{
            this.logger.logQueueState(`Init Command ${command.type}`, {
                command: command
            });
            if (this.initStream(command, options)) {
                resolve();
                this.logger.logQueueState(`Init Command Resolved ${command.type}`, {
                    command: command
                });
                return;
            }
            const unsubscribe = this.api.aiExperience?.sharedState.onChange(({ nextSharedState: nextSharedState })=>{
                if (nextSharedState.aiDecorationExperiencePluginState.isRunning) {
                    unsubscribe?.();
                    resolve();
                    this.logger.logQueueState(`Init Command Resolved ${command.type}`, {
                        command: command
                    });
                }
            });
        });
    }
    startSession(sessionId, traceId, singleInstrumentationId) {
        if ((0, $dh538.fg)('platform_editor_ai_traceid_in_analytics_events')) {
            this.traceId = traceId;
            (0, $doFG6.fireSessionStartedAnalytics)({
                api: this.api,
                sessionId: sessionId,
                traceId: traceId
            });
        }
        this.singleInstrumentationId = singleInstrumentationId;
        this.logger.logPublic('Start Session', {
            sessionId: sessionId,
            singleInstrumentationId: singleInstrumentationId
        });
    }
    queueEndSession(sessionId) {
        this.logger.logPublic('Queue End Session', {
            sessionId: sessionId
        });
    }
    endSession(sessionId) {
        if ((0, $dh538.fg)('platform_editor_ai_traceid_in_analytics_events')) this.traceId = undefined;
        this.singleInstrumentationId = undefined;
        if ((0, $dh538.fg)('platform_editor_ai_aifc_patch_ga')) this.currentCommand = undefined;
        this.logger.logPublic('End Session', {
            sessionId: sessionId
        });
    }
    destroy() {
        this.queue = [];
        this.adfStreamer = undefined;
        this.currentCommand = undefined;
        this.docBeforeStreaming = undefined;
        if ((0, $dh538.fg)('platform_editor_ai_traceid_in_analytics_events')) this.traceId = undefined;
        this.singleInstrumentationId = undefined;
    }
    /**
   * Abort the current streaming and end the experience
   * This is a hard abort and will clear the queue
   * This will only restart the experience when initStreamCommand is called again
   */ abort() {
        this.logger.logPublic('Abort');
        const currentQueue = this.queue.map((cmd)=>cmd.actionId);
        this.queue = [];
        // Add new aborted action IDs to end of array
        this.updateAbortedCache([
            ...new Set(currentQueue),
            ...this.inProcessing
        ]);
        this.isAborted = true;
        this.endExperience();
        this.isPendingResolveQueue = false;
        if (this.queueTimeout) clearTimeout(this.queueTimeout);
        this.currentAction = null;
        this.isFinalStream = false;
        if ((0, $dh538.fg)('platform_editor_ai_aifc_patch_ga')) this.currentCommand = undefined;
        if ((0, $dh538.fg)('platform_editor_ai_traceid_in_analytics_events')) this.traceId = undefined;
        this.singleInstrumentationId = undefined;
    }
    updateAbortedCache(actionIds) {
        this.aborted = [
            ...new Set([
                ...this.aborted,
                ...actionIds
            ])
        ];
        const maxAbortedCacheLength = 5;
        if (this.aborted.length > maxAbortedCacheLength) this.aborted = this.aborted.slice(-maxAbortedCacheLength);
    }
    constructor(api, streamFlowPacer = null){
        this.api = api;
        this.streamFlowPacer = streamFlowPacer;
        this.queue = [];
        this.adfStreamer = void 0;
        this.streamingCommands = void 0;
        this.currentCommand = undefined;
        this.docBeforeStreaming = undefined;
        this.isStreaming = false;
        this.isFinalStream = false;
        this.aborted = [];
        this.subscription = null;
        this.previousValidDoc = null;
        this.logger = void 0;
        this.endedActionIds = [];
        this.currentAction = null;
        // deprecated - Cleanup with platform_editor_ai_aifc_patch_ga
        this.hideLoadingScreen = false;
        this.insertAfterQueueLocalId = undefined;
        /**
     * The traceId received in response header from AI api call
     * This is used to trace the AI experience through the backend to frontend.
     */ this.traceId = undefined;
        /**
     * The singleInstrumentationId for tracking the AI experience
     * This is used to correlate events across multiple stream processing passes
     */ this.singleInstrumentationId = undefined;
        this.processingQueue = false;
        this.inProcessing = [];
        this.queueTimeout = null;
        // This is only used *if* we have started receiving values with a different
        // action id (new stream) and we have nothing left in the current stream (ie. it hasn't finished)
        // Really this shouldn't be hit since this would only happen on the edge when we're wrapping up the old stream
        // and starting the next early
        this.CURRENT_QUEUE_TIMEOUT = 5000;
        this.currentCommandTimeoutReset = null;
        this.onEmptyQueueResolve = null;
        // 2 seconds - this is the maximum time to process a command before we abort it and continue
        // This can be longer if for example if a lot of commands have been processed, but the stream flow
        // pacer has a backlog (particularly for elements with lots of attributes / marks etc) and hasn't had
        // a chance to emit yet
        this.COMMAND_TIMEOUT = 2000;
        this.isPendingResolveQueue = false;
        this.isAborted = false;
        this.logger = new (0, $hI9Sy.DebugLogger)(api);
        this.streamingCommands = (0, $7y1H8.createStreamingCommands)(api);
    }
}
module.exports["StreamCommandQueue"] = $4c93be51fe49a367$export$f3feb8728b17a0a9;

});

parcelRegister("hI9Sy", function(module, exports) {

var $dh538 = parcelRequire("dh538");

const $127e6d5334706012$var$reset = '\x1b[0m';
const $127e6d5334706012$var$red = '\x1b[31m';
const $127e6d5334706012$var$magenta = '\x1b[35m';
const $127e6d5334706012$var$green = '\x1b[32m';
const $127e6d5334706012$var$blue = '\x1b[34m';
class $127e6d5334706012$export$21e6cc849c1dc1ab {
    add(log) {
        if ((0, $dh538.fg)('platform_editor_editor_debugging_panel')) {
            try {
                if (window.top?.__aifcDebuggerEnabled__) {
                    const { type: type, message: message } = log;
                    // eslint-disable-next-line no-console
                    console.log(`${$127e6d5334706012$var$magenta}[AIFC]:EditorStreamQueue${$127e6d5334706012$var$reset} ${type === 'Public' ? $127e6d5334706012$var$green : type === 'Queue' ? $127e6d5334706012$var$blue : $127e6d5334706012$var$red}${type}${$127e6d5334706012$var$reset} ${message}`, log);
                }
            } catch  {
            // Ignore cross-origin errors
            }
            this.logs.push({
                type: log.type,
                message: log.message,
                timestamp: log.timestamp
            });
            if (this.logs.length > this.MAX_LENGTH) this.logs.shift(); // Remove the oldest log to maintain a max log
        }
    }
    logPublic(message, data) {
        this.add({
            type: 'Public',
            message: message,
            ...data,
            timestamp: new Date()
        });
    }
    logError(message, data) {
        this.add({
            type: 'Error',
            message: message,
            ...data,
            timestamp: new Date()
        });
    }
    logQueueState(message, data) {
        this.add({
            type: 'Queue',
            message: message,
            ...data,
            timestamp: new Date()
        });
    }
    // Current ADF at the time of logging so we can recreate the scenario
    getAdf() {
        if (!this.api) return undefined;
        let doc;
        this.api.core.actions.execute(({ tr: tr })=>{
            doc = tr.doc.toJSON();
            return null;
        });
        return doc;
    }
    getDebugInformation() {
        return {
            logs: this.logs,
            adf: this.getAdf(),
            selection: this.api?.selection?.actions.getSelectionFragment() ?? undefined,
            localIds: this.api?.selection?.actions.getSelectionLocalIds() ?? undefined
        };
    }
    constructor(api){
        this.api = api;
        this.logs = [];
        this.MAX_LENGTH = 100;
        if ((0, $dh538.fg)('platform_editor_editor_debugging_panel')) {
            if (window.top) try {
                window.top.__aifcEditorDebugData__ = ()=>this.getDebugInformation();
            } catch  {
            // Ignore cross-origin errors
            }
        }
    }
}
module.exports["DebugLogger"] = $127e6d5334706012$export$21e6cc849c1dc1ab;

});

parcelRegister("eSNDK", function(module, exports) {
function $c127a9255266496a$export$f85aff2979b590a7(command) {
    return [
        'replaceNode',
        'insertNodeBefore',
        'insertNodeAfter',
        'appendNode',
        'appendNodeToEnd'
    ].includes(command.type);
}
module.exports["isAStreamableCommand"] = $c127a9255266496a$export$f85aff2979b590a7;

});

parcelRegister("ldVMA", function(module, exports) {
function $a561bee60676cdb0$export$c48ec1bf46060d54(commandsToProcess) {
    const mergedCommands = [];
    for (const command of commandsToProcess){
        const lastCommand = mergedCommands[mergedCommands.length - 1];
        // Check if we can merge the current command with the last one
        if (command.type === 'streamCommand' && lastCommand && lastCommand.type === 'streamCommand' && command.actionId === lastCommand.actionId) lastCommand.chunk = command.chunk;
        else // Otherwise, just push the command to mergedCommands
        mergedCommands.push(command);
    }
    return mergedCommands;
}
module.exports["mergeStreamCommands"] = $a561bee60676cdb0$export$c48ec1bf46060d54;

});

parcelRegister("icc5i", function(module, exports) {
function $d96f5329afc42f98$export$6c44330c7facd24b(promise, options) {
    const { timeout: timeout, onTimeout: onTimeout, onCleanup: onCleanup } = options;
    let timeoutHandle;
    let timeoutResolve;
    let isCompleted = false;
    // Function to start/restart the timeout
    const resetTimeout = ()=>{
        if (isCompleted) return;
        if (timeoutHandle) clearTimeout(timeoutHandle);
        timeoutHandle = setTimeout(()=>{
            if (!isCompleted) {
                onTimeout();
                timeoutResolve?.();
            }
        }, timeout);
    };
    const timeoutPromise = new Promise((resolve)=>{
        timeoutResolve = resolve;
    });
    resetTimeout();
    // Race the original promise against the timeout
    const wrappedPromise = Promise.race([
        promise,
        timeoutPromise
    ]).finally(()=>{
        isCompleted = true;
        if (timeoutHandle) clearTimeout(timeoutHandle);
        onCleanup?.();
    });
    return {
        resetTimeout: resetTimeout,
        promise: wrappedPromise
    };
}
module.exports["createTimeoutWrapper"] = $d96f5329afc42f98$export$6c44330c7facd24b;

});

parcelRegister("8hcFZ", function(module, exports) {

var $6jPem = parcelRequire("6jPem");


var $dh538 = parcelRequire("dh538");

function $76ccf77dd7d8e539$export$ab173b3d1046c711(adfResponse, type, schema) {
    if (!adfResponse || type !== 'insertNodeAfter' || !(0, $dh538.fg)('platform_editor_ai_aifc_patch_ga')) return {
        updatedResponse: adfResponse,
        localId: undefined
    };
    const indexMap = [];
    let newLocalId = crypto.randomUUID();
    const depthToCheckAgainst = (0, $dh538.fg)('platform_editor_ai_aifc_patch_ga_blockers') ? 0 : 1;
    // First pass just to get the node to update
    (0, $6jPem.traverse)(adfResponse, {
        any: (_n, _p, index, depth)=>{
            if (depth === depthToCheckAgainst) indexMap.push(index);
        }
    });
    // Update the localId of the last node
    let localIdUpdated = false;
    const newAdfResponse = (0, $6jPem.traverse)({
        ...adfResponse
    }, {
        any: (node, _p, index, depth)=>{
            if (depth === depthToCheckAgainst && indexMap[indexMap.length - 1] === index && !!schema?.nodes[node.type]?.spec?.attrs?.localId) {
                localIdUpdated = true;
                if (!!node?.attrs?.localId && (0, $dh538.fg)('platform_editor_ai_aifc_patch_ga_blockers')) newLocalId = node?.attrs?.localId;
                return {
                    ...node,
                    attrs: {
                        ...node.attrs,
                        localId: newLocalId
                    }
                };
            }
        }
    });
    return {
        updatedResponse: newAdfResponse ? newAdfResponse : adfResponse,
        localId: localIdUpdated ? newLocalId : undefined
    };
}
module.exports["updateInsertAfterDoc"] = $76ccf77dd7d8e539$export$ab173b3d1046c711;

});

parcelRegister("7y1H8", function(module, exports) {

var $feOE7 = parcelRequire("feOE7");


var $fXyrT = parcelRequire("fXyrT");


var $9Cct9 = parcelRequire("9Cct9");


var $eSiwf = parcelRequire("eSiwf");


var $eSaBl = parcelRequire("eSaBl");


var $bzMdN = parcelRequire("bzMdN");


var $4r9cm = parcelRequire("4r9cm");

function $748219bd4f4f1029$export$a0774277976bc21f(api) {
    return {
        replaceNode: (0, $eSaBl.createReplaceNodeCommand)(api),
        insertNodeBefore: (0, $9Cct9.createInsertNodeBeforeCommand)(api),
        insertNodeAfter: (0, $fXyrT.createInsertNodeAfterCommand)(api),
        removeNode: (0, $eSiwf.createRemoveNodeCommand)(api),
        appendNode: (0, $feOE7.createAppendNodeToEndCommand)(api),
        appendNodeToEnd: (0, $feOE7.createAppendNodeToEndCommand)(api),
        wrap: (0, $4r9cm.createWrapNodeCommand)(api),
        wrapNode: (0, $4r9cm.createWrapNodeCommand)(api),
        setAttrs: (0, $bzMdN.createSetAttrsCommand)(api)
    };
}
module.exports["createStreamingCommands"] = $748219bd4f4f1029$export$a0774277976bc21f;

});

parcelRegister("feOE7", function(module, exports) {

var $2pjJ5 = parcelRequire("2pjJ5");


var $ks2lK = parcelRequire("ks2lK");

const $d4e9e31242338f4c$export$9e6d85a71b01d30 = (api)=>()=>{
        return api.core.actions.execute(({ tr: tr })=>{
            let selection;
            if ((0, $2pjJ5.isEmptyDocument)(tr.doc)) selection = (0, $ks2lK.Selection).atEnd(tr.doc);
            else {
                const $pos = tr.doc.resolve(tr.doc.content.size);
                tr.insert($pos.pos, tr.doc.type.schema.nodes.paragraph.create());
                selection = (0, $ks2lK.TextSelection).create(tr.doc, $pos.pos + 1);
            }
            if (!selection) throw new Error('Failed to create selection');
            api?.aiExperience?.actions.tagAsAIStreamingTransformation(tr);
            tr.setSelection(selection).scrollIntoView();
            return tr;
        });
    };
module.exports["createAppendNodeToEndCommand"] = $d4e9e31242338f4c$export$9e6d85a71b01d30;

});

parcelRegister("fXyrT", function(module, exports) {

var $ks2lK = parcelRequire("ks2lK");


var $7XFGZ = parcelRequire("7XFGZ");


var $LmqWp = parcelRequire("LmqWp");


var $9MzzS = parcelRequire("9MzzS");


var $dh538 = parcelRequire("dh538");


var $1oCLl = parcelRequire("1oCLl");


var $cz1qC = parcelRequire("cz1qC");

const $c2ca03eb7fbe6fb1$var$nodeNamesToSkipInsertParagraph = [
    'listItem',
    'taskItem',
    'decisionItem'
];
const $c2ca03eb7fbe6fb1$export$d4ccce03e5361e34 = (api)=>(command)=>{
        return api.core.actions.execute(({ tr: tr })=>{
            return (0, $cz1qC.findNodeByLocalId)(api, tr, command.localId, ({ pos: pos, node: node, parent: parent })=>{
                if (node.type.name === 'tableRow' && parent) {
                    const tableMap = (0, $LmqWp.TableMap).get(parent);
                    const $pos = tr.doc.resolve(pos);
                    const tableStart = $pos.start($pos.depth);
                    const rect = tableMap.findCell(pos - tableStart + 1);
                    const tableContext = {
                        map: tableMap,
                        table: parent,
                        tableStart: tableStart
                    };
                    (0, $9MzzS.addRow)(tr, tableContext, rect.bottom);
                    const $newPos = tr.doc.resolve(pos);
                    const table = $newPos.node($newPos.depth);
                    const newTableMap = (0, $LmqWp.TableMap).get(table);
                    // Not considering merged cells
                    const cells = newTableMap.mapByRow[rect.bottom];
                    const selection = (0, $7XFGZ.CellSelection).rowSelection(tr.doc.resolve(cells[0] + tableStart), tr.doc.resolve(cells[cells.length - 1] + tableStart));
                    tr.setSelection(selection).scrollIntoView();
                } else if ($c2ca03eb7fbe6fb1$var$nodeNamesToSkipInsertParagraph.includes(node.type.name) && parent && (0, $dh538.fg)('platform_editor_ai_aifc_patch_ga_blockers')) {
                    /**
						 * Not creating new paragraph node when inserting node after list item.
						 * Because when inserting new list item, it will add new list item in new list.
						 */ const selection = (0, $ks2lK.TextSelection).create(tr.doc, pos + node.nodeSize);
                    tr.setSelection(selection).scrollIntoView();
                } else {
                    let insertPos = Math.min(pos + node.nodeSize, tr.doc.content.size);
                    if ((0, $dh538.fg)('platform_editor_ai_aifc_patch_ga')) {
                        insertPos = pos + node.nodeSize;
                        while(insertPos < tr.doc.content.size){
                            const $pos = tr.doc.resolve(insertPos);
                            let nextNode = null;
                            // For top-level nodes (depth 0 = document), check document children directly
                            // For nested nodes, use nodeAfter which works at higher depths
                            if ($pos.depth === 0) {
                                // At document root level, find the next top-level child
                                const childIndex = $pos.indexAfter(0);
                                if (childIndex < tr.doc.childCount) nextNode = tr.doc.child(childIndex);
                            } else // For nested structures, nodeAfter works correctly
                            nextNode = $pos.nodeAfter;
                            // Skip nodes without localId (from previous AI insertions)
                            // This prevents sequential insertions from overriding each other
                            if (nextNode && !nextNode.attrs.localId) insertPos += nextNode.nodeSize;
                            else break;
                        }
                    }
                    if (node.type.name === 'tableCell' || node.type.name === 'tableHeader') insertPos--;
                    if ((0, $1oCLl.expValEquals)('platform_editor_ai_fix_insert_after_selection', 'isEnabled', true)) {
                        if (insertPos + 1 <= tr.doc.content.size) tr.insert(insertPos, tr.doc.type.schema.nodes.paragraph.create());
                        const selection = (0, $ks2lK.TextSelection).create(tr.doc, Math.min(insertPos + 1, tr.doc.content.size));
                        tr.setSelection(selection).scrollIntoView();
                    } else {
                        tr.insert(insertPos, tr.doc.type.schema.nodes.paragraph.create());
                        const selection = (0, $ks2lK.TextSelection).create(tr.doc, insertPos + 1);
                        tr.setSelection(selection).scrollIntoView();
                    }
                }
            }, // Inserting after should always look for the last node with a matching localid. This will ensure that we
            // always insert AFTER.
            true);
        });
    };
module.exports["createInsertNodeAfterCommand"] = $c2ca03eb7fbe6fb1$export$d4ccce03e5361e34;

});

parcelRegister("9Cct9", function(module, exports) {

var $ks2lK = parcelRequire("ks2lK");


var $cz1qC = parcelRequire("cz1qC");

const $221cde67568b69a7$export$1226208ece997066 = (api)=>(command)=>{
        return api.core.actions.execute(({ tr: tr })=>{
            return (0, $cz1qC.findNodeByLocalId)(api, tr, command.localId, ({ pos: pos })=>{
                const selection = new (0, $ks2lK.TextSelection)(tr.doc.resolve(pos));
                tr.setSelection(selection).scrollIntoView();
            });
        });
    };
module.exports["createInsertNodeBeforeCommand"] = $221cde67568b69a7$export$1226208ece997066;

});

parcelRegister("eSiwf", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $cz1qC = parcelRequire("cz1qC");

const $32edc2d4989fa97a$export$9a6ccf2338830d60 = (api)=>(command)=>{
        return api.core.actions.execute(({ tr: tr })=>{
            return (0, $cz1qC.findNodeByLocalId)(api, tr, command.localId, ({ node: node, pos: pos })=>{
                if ((0, $dh538.fg)('platform_editor_ai_instrumentation_updates')) api.aiExperience.actions.tagAsAIStreamingTransformation(tr, {
                    isFinal: true
                });
                tr.delete(pos, pos + node.nodeSize).scrollIntoView();
            });
        });
    };
module.exports["createRemoveNodeCommand"] = $32edc2d4989fa97a$export$9a6ccf2338830d60;

});

parcelRegister("eSaBl", function(module, exports) {

var $ks2lK = parcelRequire("ks2lK");


var $7XFGZ = parcelRequire("7XFGZ");


var $dh538 = parcelRequire("dh538");


var $cz1qC = parcelRequire("cz1qC");

const $909a39db2548dac9$export$8077407ea1dae01f = (api)=>(command)=>{
        return api.core.actions.execute(({ tr: tr })=>{
            return (0, $cz1qC.findNodeByLocalId)(api, tr, command.localId, ({ pos: pos, node: node })=>{
                let selection = null;
                // this if block can be removed when 'platform_editor_ai_aifc_patch_ga' is removed
                // i.e. we will not want any special handling for table replacements
                if (node.type.name === 'table' && !(0, $dh538.fg)('platform_editor_ai_aifc_patch_ga')) {
                    tr.replaceRangeWith(pos, pos + node.nodeSize, tr.doc.type.schema.nodes.paragraph.create());
                    selection = (0, $ks2lK.TextSelection).create(tr.doc, pos + 1);
                } else if ((0, $ks2lK.NodeSelection).isSelectable(node)) selection = (0, $ks2lK.NodeSelection).create(tr.doc, pos);
                else {
                    const role = node.type.spec.tableRole;
                    if (role === 'cell' || role === 'header_cell') selection = (0, $7XFGZ.CellSelection).create(tr.doc, pos);
                    else if (role === 'row') {
                        // There's always a cell after the row
                        const $cell = tr.doc.resolve(pos + 1);
                        selection = (0, $7XFGZ.CellSelection).rowSelection($cell, $cell, true);
                    } else {
                        const $pos = tr.doc.resolve(pos);
                        const $end = tr.doc.resolve(pos + node.nodeSize);
                        selection = (0, $ks2lK.TextSelection).between($pos, $end);
                    }
                }
                if (selection) tr.setSelection(selection).scrollIntoView();
            });
        });
    };
module.exports["createReplaceNodeCommand"] = $909a39db2548dac9$export$8077407ea1dae01f;

});

parcelRegister("bzMdN", function(module, exports) {

var $ks2lK = parcelRequire("ks2lK");


var $dh538 = parcelRequire("dh538");


var $cz1qC = parcelRequire("cz1qC");

const $834280e13ce7e027$var$getValidAttributes = (attrs, nodeSpec)=>{
    const validAttrs = {};
    for(const key in attrs)if (nodeSpec.attrs?.hasOwnProperty(key)) validAttrs[key] = attrs[key];
    return validAttrs;
};
const $834280e13ce7e027$export$3c4e918a3d6ca42f = (api)=>(command)=>{
        return api.core.actions.execute(({ tr: tr })=>{
            let shouldExecute = false;
            (0, $cz1qC.findNodeByLocalId)(api, tr, command.localId, ({ node: node, pos: pos })=>{
                if (node) {
                    const attrs = command.attrs;
                    if (!attrs || typeof attrs !== 'object') return;
                    const validAttrs = $834280e13ce7e027$var$getValidAttributes(attrs, node.type.spec);
                    node.type.spec.attrs;
                    if ((0, $dh538.fg)('platform_editor_ai_instrumentation_updates')) api.aiExperience?.actions.tagAsAIStreamingTransformation(tr, {
                        isFinal: true
                    });
                    tr.setNodeMarkup(pos, node.type, {
                        ...node.attrs,
                        ...validAttrs
                    });
                    tr.setSelection((0, $ks2lK.TextSelection).near(tr.doc.resolve(pos)));
                    shouldExecute = true;
                }
            });
            return shouldExecute ? tr : null;
        });
    };
module.exports["createSetAttrsCommand"] = $834280e13ce7e027$export$3c4e918a3d6ca42f;

});

parcelRegister("4r9cm", function(module, exports) {

var $3KVX0 = parcelRequire("3KVX0");


var $4rpi6 = parcelRequire("4rpi6");


var $d925B = parcelRequire("d925B");


var $5SAOw = parcelRequire("5SAOw");


var $aXG5V = parcelRequire("aXG5V");


var $dh538 = parcelRequire("dh538");


var $2QlXt = parcelRequire("2QlXt");


var $cz1qC = parcelRequire("cz1qC");

const $f350631d999bc8ec$var$panelTypes = new (0, $3KVX0.default)((0, $4rpi6.panel).props.attrs.props.panelType.values);
function $f350631d999bc8ec$var$wrapChild(fragment, type, attrs) {
    if (!fragment.firstChild) return null;
    const wrappingNodeTypes = type.contentMatch.findWrapping(fragment.firstChild.type);
    let currentChildNodes = null;
    if (wrappingNodeTypes) {
        currentChildNodes = fragment.content;
        for(let i = wrappingNodeTypes.length - 1; i >= 0; i--){
            const wrappingNodeType = wrappingNodeTypes[i];
            const nextChildNode = wrappingNodeType.createAndFill(null, currentChildNodes);
            if (nextChildNode) currentChildNodes = [
                nextChildNode
            ];
            else {
                currentChildNodes = null;
                break;
            }
        }
    }
    if (currentChildNodes) return type.createAndFill(attrs, currentChildNodes);
    return null;
}
function $f350631d999bc8ec$var$findPosForNode(node, $to) {
    for(let depth = $to.depth; depth >= 0; depth--){
        const ancestor = $to.node(depth);
        if (ancestor.type.contentMatch.matchType(node.type)) return $to.after(depth + 1);
    }
    return null;
}
function $f350631d999bc8ec$var$getAncestorTypes($to) {
    const ancestors = [];
    for(let depth = $to.depth; depth >= 0; depth--){
        const ancestor = $to.node(depth);
        ancestors.push(ancestor.type.name);
    }
    return ancestors;
}
function $f350631d999bc8ec$var$getChildTypes(fragment) {
    return fragment.content.map((node)=>node.type.name);
}
const $f350631d999bc8ec$export$2c6212a0adabc271 = (api)=>(command)=>{
        let success = false;
        let error;
        let repaired = false;
        let ancestors = [];
        let fragments = [];
        api.core.actions.execute(({ tr: tr })=>{
            try {
                (0, $cz1qC.findNodeByLocalId)(api, tr, command.localId, ({ node: node, pos: pos })=>{
                    const $from = tr.doc.resolve(pos);
                    const $to = tr.doc.resolve(pos + node.nodeSize);
                    const range = $from.blockRange($to);
                    if (range) {
                        const type = tr.doc.type.schema.nodes[command.wrapperType];
                        const attrs = command.wrapperAttrs;
                        // TODO: EDITOR-1371 - Validate attributes for all nodes
                        if (command.wrapperType === 'panel' && attrs.panelType !== undefined) {
                            const panelType = command.wrapperAttrs.panelType;
                            const panelTypeResult = $f350631d999bc8ec$var$panelTypes.search(panelType);
                            if (panelTypeResult.length) attrs.panelType = panelTypeResult[0].item;
                            else attrs.panelType = 'info';
                        }
                        try {
                            // NOTE: `wrapping` will be empty ([]) when it fits directly
                            const wrapping = (0, $aXG5V.findWrapping)(range, type, attrs);
                            if (wrapping !== null) {
                                tr.wrap(range, wrapping).scrollIntoView();
                                success = true;
                            } else {
                                const slice = tr.doc.slice(range.$from.pos, range.$to.pos);
                                const fragment = slice.content;
                                let node = type.createAndFill(attrs, fragment);
                                if (!node) node = $f350631d999bc8ec$var$wrapChild(fragment, type, attrs);
                                if (node) {
                                    const insertPos = $f350631d999bc8ec$var$findPosForNode(node, $to);
                                    if (insertPos !== null) {
                                        tr.insert(insertPos, node).scrollIntoView();
                                        tr.replaceRange(range.$from.pos, range.$to.pos, (0, $5SAOw.Slice).empty);
                                        success = true;
                                        repaired = true;
                                    }
                                }
                                ancestors = $f350631d999bc8ec$var$getAncestorTypes($to);
                                fragments = $f350631d999bc8ec$var$getChildTypes(fragment);
                            }
                        } catch (e) {
                            error = e;
                            // TODO: EDITOR-1370 - Log the error
                            // eslint-disable-next-line no-console
                            console.error(e);
                        }
                    }
                });
                if ((0, $dh538.fg)('platform_editor_ai_instrumentation_updates')) api.aiExperience.actions.tagAsAIStreamingTransformation(tr, {
                    isFinal: true
                });
            } catch (e) {
                error = e;
                // TODO: EDITOR-1370 - Log the error
                // eslint-disable-next-line no-console
                console.error(e);
            }
            return tr;
        });
        if (!success || repaired) {
            // Log the error
            const errorMessage = (0, $2QlXt.ErrorUtils).extractErrorMessage(error);
            let errorStack = '';
            if (error instanceof Error) errorStack = error.stack || '';
            api?.analytics?.actions.fireAnalyticsEvent({
                action: (0, $d925B.ACTION).INVALID_COMMAND_FOUND,
                actionSubject: (0, $d925B.ACTION_SUBJECT).AI_STREAMING,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).EXPERIENCE_APPLICATION,
                eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    success: // Disable for now #hot-122604
                    // command,
                    success,
                    repaired: repaired,
                    ancestors: ancestors,
                    fragments: fragments,
                    errorMessage: errorMessage,
                    errorStack: errorStack
                }
            });
        }
        return success;
    };
module.exports["createWrapNodeCommand"] = $f350631d999bc8ec$export$2c6212a0adabc271;

});

parcelRegister("98Cy1", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5UhfH = parcelRequire("5UhfH");

function $c1b5771e8fcb5e0a$export$de773409fd90c392(spaceId, objectId, product = 'confluence') {
    const [contextIdentProvider, setContextIdentProvider] = (0, $42omo.useState)(undefined);
    const spaceIdPromise = (0, $5UhfH.useSpaceIdPromise)(spaceId);
    (0, $42omo.useEffect)(()=>{
        setContextIdentProvider(spaceIdPromise.then((containerId)=>{
            return {
                containerId: containerId,
                objectId: objectId,
                product: product
            };
        }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        spaceId,
        objectId,
        product
    ]);
    return contextIdentProvider;
}
module.exports["useContextIdentifierProvider"] = $c1b5771e8fcb5e0a$export$de773409fd90c392;

});

parcelRegister("3plmx", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $btw9C = parcelRequire("btw9C");


var $kLzei = parcelRequire("kLzei");


var $bQm3c = parcelRequire("bQm3c");


var $btIEy = parcelRequire("btIEy");


var $i6Ps3 = parcelRequire("i6Ps3");


var $6M71K = parcelRequire("6M71K");

const $78db0f388b3bc59b$var$useInitialState = ()=>{
    return (0, $42omo.useMemo)(()=>{
        const ssrProvidersData = window['__SSR_EDITOR_NODE_DATA_PROVIDERS_DATA__'] || {};
        const ssrData = ssrProvidersData.editorCardProvider;
        if (!ssrData) return undefined;
        return Object.entries(ssrData).reduce((acc, [url, details])=>{
            acc[url] = {
                status: (0, $btw9C.getStatus)(details),
                details: details,
                metadataStatus: 'resolved'
            };
            return acc;
        }, {});
    }, []);
};
const $78db0f388b3bc59b$var$useStoreOptions = ()=>{
    const isPageSSR = (0, $i6Ps3.isPageSSRd)();
    const initialState = $78db0f388b3bc59b$var$useInitialState();
    const oldInitialState = window['__SSR_SMARTLINKS__'];
    const oldStoreOptions = (0, $btIEy.useStoreOptions)(oldInitialState, isPageSSR);
    return (0, $42omo.useMemo)(()=>{
        if (initialState) return {
            initialState: initialState
        };
        return oldStoreOptions.storeOptions;
    }, [
        oldStoreOptions,
        initialState
    ]);
};
function $78db0f388b3bc59b$export$eaed11d22c122636(WrappedComponent) {
    return (props)=>{
        const { isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $bQm3c.useSessionData)();
        const storeOptions = $78db0f388b3bc59b$var$useStoreOptions();
        const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(WrappedComponent, props);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6M71K.ConfluenceSmartCardProvider), {
            ...(0, $kLzei.getSmartCardRenderers)(),
            storeOptions: storeOptions,
            isAdminHubAIEnabled: isAdminHubAIEnabled
        }, content));
    };
}
module.exports["withSmartCardProviderContext"] = $78db0f388b3bc59b$export$eaed11d22c122636;

});


//# sourceMappingURL=CommentEditor.df54f94c.js.map
